/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class WorkStationWorkingConditionStatusServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 修改采集项因子配置
     * @param editorConditionStatusDTO editorConditionStatusDTO
     * @return OK
     */
    editorConditionStatusSetting(editorConditionStatusDTO: EditorConditionStatusDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/condition-status/editor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editorConditionStatusDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditorConditionStatusSetting(_response);
        });
    }

    protected processEditorConditionStatusSetting(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 初始化工况参数配置
     * @return OK
     */
    initWcsSetting(): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/condition-status/init";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInitWcsSetting(_response);
        });
    }

    protected processInitWcsSetting(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 获取采集项因子列表
     * @return OK
     */
    getWorkConditionStatus(): Promise<WorkConditionSettingVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/condition-status/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkConditionStatus(_response);
        });
    }

    protected processGetWorkConditionStatus(response: AxiosResponse): Promise<WorkConditionSettingVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkConditionSettingVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkConditionSettingVO[]>(<any>null);
    }
}

export class CustomMachineServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 创建或更新自定义机床信息
     * @param customMachineSubmitDTO customMachineSubmitDTO
     * @return OK
     */
    submit(customMachineSubmitDTO: CustomMachineSubmitDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/custom-machine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customMachineSubmitDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除自定义机床列表
     * @param idList idList
     * @return OK
     */
    deleteMachineList(idList: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/custom-machine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteMachineList(_response);
        });
    }

    protected processDeleteMachineList(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 校验自定义机床信息
     * @param customMachineCheckDTO customMachineCheckDTO
     * @return OK
     */
    checkMachine(customMachineCheckDTO: CustomMachineCheckDTO): Promise<CheckMachineVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/custom-machine/check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customMachineCheckDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckMachine(_response);
        });
    }

    protected processCheckMachine(response: AxiosResponse): Promise<CheckMachineVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? CheckMachineVO.fromJS(resultData200) : new CheckMachineVO();
            return result200;
        }
        return Promise.resolve<CheckMachineVO>(<any>null);
    }

    /**
     * 导出模板
     * @return OK
     */
    exportTemplate(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/custom-machine/export-template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportTemplate(_response);
        });
    }

    protected processExportTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导入自定义设备
     * @param file (optional) file
     * @return OK
     */
    importMachine(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/custom-machine/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportMachine(_response);
        });
    }

    protected processImportMachine(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 分页查询自定义机床
     * @param current (optional) 当前页
     * @param customMachineSelectDTO customMachineSelectDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    page(current: number | null | undefined, customMachineSelectDTO: CustomMachineSelectDTO, size: number | null | undefined): Promise<IPageOfCustomMachineVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/custom-machine/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customMachineSelectDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<IPageOfCustomMachineVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCustomMachineVO.fromJS(resultData200) : new IPageOfCustomMachineVO();
            return result200;
        }
        return Promise.resolve<IPageOfCustomMachineVO>(<any>null);
    }
}

export class DeviceServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 添加设备
     * @param deviceInDTO deviceInDTO
     * @return OK
     */
    saveDevice(deviceInDTO: DeviceInDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceInDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveDevice(_response);
        });
    }

    protected processSaveDevice(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 编辑设备
     * @param deviceUpdateDTO deviceUpdateDTO
     * @return OK
     */
    updateDevice(deviceUpdateDTO: DeviceUpdateDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateDevice(_response);
        });
    }

    protected processUpdateDevice(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 添加设备附件
     * @param deviceFileInDTO deviceFileInDTO
     * @return OK
     */
    saveDeviceFile(deviceFileInDTO: DeviceFileInDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device/file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceFileInDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveDeviceFile(_response);
        });
    }

    protected processSaveDeviceFile(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 查询租户下设备列表
     * @return OK
     */
    getDeviceList(): Promise<DeviceSimpleVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceList(_response);
        });
    }

    protected processGetDeviceList(response: AxiosResponse): Promise<DeviceSimpleVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceSimpleVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DeviceSimpleVO[]>(<any>null);
    }

    /**
     * 关键词查询租户下设备列表
     * @param keyWord (optional) keyWord
     * @return OK
     */
    getDeviceListByKeyWord(keyWord: string | null | undefined): Promise<DeviceSimpleVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device/listByKeyWord?";
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceListByKeyWord(_response);
        });
    }

    protected processGetDeviceListByKeyWord(response: AxiosResponse): Promise<DeviceSimpleVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceSimpleVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DeviceSimpleVO[]>(<any>null);
    }

    /**
     * 分页查询设备
     * @param current (optional) 当前页
     * @param devicePageDTO devicePageDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageDevices(current: number | null | undefined, devicePageDTO: DevicePageDTO, size: number | null | undefined): Promise<PageOfDevicePageVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(devicePageDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageDevices(_response);
        });
    }

    protected processGetPageDevices(response: AxiosResponse): Promise<PageOfDevicePageVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PageOfDevicePageVO.fromJS(resultData200) : new PageOfDevicePageVO();
            return result200;
        }
        return Promise.resolve<PageOfDevicePageVO>(<any>null);
    }

    /**
     * 查询设备详情
     * @param workStationId workStationId
     * @return OK
     */
    deviceDetail(workStationId: string): Promise<DeviceDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device/{workStationId}";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined.");
        url_ = url_.replace("{workStationId}", encodeURIComponent("" + workStationId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeviceDetail(_response);
        });
    }

    protected processDeviceDetail(response: AxiosResponse): Promise<DeviceDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? DeviceDTO.fromJS(resultData200) : new DeviceDTO();
            return result200;
        }
        return Promise.resolve<DeviceDTO>(<any>null);
    }

    /**
     * 查询设备附件
     * @param workStationId workStationId
     * @return OK
     */
    getDeviceFile(workStationId: string): Promise<DeviceFileDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device/{workStationId}/file";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined.");
        url_ = url_.replace("{workStationId}", encodeURIComponent("" + workStationId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceFile(_response);
        });
    }

    protected processGetDeviceFile(response: AxiosResponse): Promise<DeviceFileDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceFileDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DeviceFileDTO[]>(<any>null);
    }
}

export class DeviceStandardSettingServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增设备标准设置
     * @param deviceStandardSettingDTOList deviceStandardSettingDTOList
     * @return OK
     */
    insertDeviceStandardSetting(deviceStandardSettingDTOList: DeviceStandardSettingDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device-standard-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceStandardSettingDTOList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInsertDeviceStandardSetting(_response);
        });
    }

    protected processInsertDeviceStandardSetting(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 编辑设备标准设置
     * @param deviceStandardSettingUpdateDTOList deviceStandardSettingUpdateDTOList
     * @return OK
     */
    updateDeviceStandardSetting(deviceStandardSettingUpdateDTOList: DeviceStandardSettingUpdateDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device-standard-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceStandardSettingUpdateDTOList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateDeviceStandardSetting(_response);
        });
    }

    protected processUpdateDeviceStandardSetting(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除设备标准设置
     * @param ids ids
     * @return OK
     */
    deleteDeviceStandardSetting(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device-standard-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteDeviceStandardSetting(_response);
        });
    }

    protected processDeleteDeviceStandardSetting(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 判断程序号是否存在
     * @param programName (optional) programName
     * @param workstationId (optional) workstationId
     * @return OK
     */
    programNameIsExists(programName: string | null | undefined, workstationId: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device-standard-setting/programIsExists?";
        if (programName !== undefined)
            url_ += "programName=" + encodeURIComponent("" + programName) + "&"; 
        if (workstationId !== undefined)
            url_ += "workstationId=" + encodeURIComponent("" + workstationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProgramNameIsExists(_response);
        });
    }

    protected processProgramNameIsExists(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 同步设置
     * @param workStationId (optional) 同步来源工位id
     * @param workStationIds (optional) 同步目标工位id集合
     * @return OK
     */
    sync(workStationId: string | null | undefined, workStationIds: string[] | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device-standard-setting/sync?";
        if (workStationId !== undefined)
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationIds);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSync(_response);
        });
    }

    protected processSync(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取设备标准设置列表
     * @param workStationId workStationId
     * @return OK
     */
    getDeviceStandardSettingList(workStationId: string): Promise<DeviceStandardSettingVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device-standard-setting/{workStationId}";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined.");
        url_ = url_.replace("{workStationId}", encodeURIComponent("" + workStationId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceStandardSettingList(_response);
        });
    }

    protected processGetDeviceStandardSettingList(response: AxiosResponse): Promise<DeviceStandardSettingVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceStandardSettingVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DeviceStandardSettingVO[]>(<any>null);
    }
}

export class DeviceTypeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增设备类型
     * @param dto dto
     * @return OK
     */
    createDeviceType(dto: DeviceTypeDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateDeviceType(_response);
        });
    }

    protected processCreateDeviceType(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 更新设备类型
     * @param dto dto
     * @return OK
     */
    updateDeviceType(dto: DeviceTypeUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateDeviceType(_response);
        });
    }

    protected processUpdateDeviceType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除设备类型
     * @param ids (optional) 设备id集合
     * @return OK
     */
    deleteDeviceTypeByIds(ids: string[] | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device-types?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteDeviceTypeByIds(_response);
        });
    }

    protected processDeleteDeviceTypeByIds(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 设备类型详情
     * @param id id
     * @return OK
     */
    getDeviceTypeById(id: string): Promise<DeviceTypeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device-types/detail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceTypeById(_response);
        });
    }

    protected processGetDeviceTypeById(response: AxiosResponse): Promise<DeviceTypeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? DeviceTypeVO.fromJS(resultData200) : new DeviceTypeVO();
            return result200;
        }
        return Promise.resolve<DeviceTypeVO>(<any>null);
    }

    /**
     * 导出设备类型
     * @param deviceTypeExcelDTO deviceTypeExcelDTO
     * @return OK
     */
    exportProduct(deviceTypeExcelDTO: DeviceTypeExcelDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device-types/excel/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceTypeExcelDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportProduct(_response);
        });
    }

    protected processExportProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 设备类型模板导出
     * @return OK
     */
    exportDeviceTypeTemplate(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device-types/excel/export/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportDeviceTypeTemplate(_response);
        });
    }

    protected processExportDeviceTypeTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导入设备类型
     * @param file (optional) file
     * @return OK
     */
    importProducts(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device-types/excel/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportProducts(_response);
        });
    }

    protected processImportProducts(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 分页查询设备类型
     * @param deviceTypePageDTO deviceTypePageDTO
     * @return OK
     */
    pageDeviceType(deviceTypePageDTO: DeviceTypePageDTO): Promise<IPageOfDeviceTypeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device-types/page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceTypePageDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageDeviceType(_response);
        });
    }

    protected processPageDeviceType(response: AxiosResponse): Promise<IPageOfDeviceTypeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfDeviceTypeVO.fromJS(resultData200) : new IPageOfDeviceTypeVO();
            return result200;
        }
        return Promise.resolve<IPageOfDeviceTypeVO>(<any>null);
    }
}

export class DeviceExcelServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出设备信息
     * @param checkRecordIds checkRecordIds
     * @return OK
     */
    exportDevice(checkRecordIds: DeviceIdsDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device/excel/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkRecordIds);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportDevice(_response);
        });
    }

    protected processExportDevice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 下载导入模板
     * @return OK
     */
    exportDeviceTemplate(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device/excel/export/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportDeviceTemplate(_response);
        });
    }

    protected processExportDeviceTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导入设备信息
     * @param file (optional) file
     * @return OK
     */
    importDevice(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/device/excel/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportDevice(_response);
        });
    }

    protected processImportDevice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class IotServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出dmp文件
     * @param gatewayId gatewayId
     * @return OK
     */
    exportDmpFile(gatewayId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/dmp/export/{gatewayId}";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined.");
        url_ = url_.replace("{gatewayId}", encodeURIComponent("" + gatewayId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportDmpFile(_response);
        });
    }

    protected processExportDmpFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导入dmp文件
     * @param dmpFile dmpFile
     * @param gatewayId gatewayId
     * @return OK
     */
    importDmpFile(dmpFile: FileParameter, gatewayId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/dmp/import/{gatewayId}";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined.");
        url_ = url_.replace("{gatewayId}", encodeURIComponent("" + gatewayId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (dmpFile === null || dmpFile === undefined)
            throw new Error("The parameter 'dmpFile' cannot be null.");
        else
            content_.append("dmpFile", dmpFile.data, dmpFile.fileName ? dmpFile.fileName : "dmpFile");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportDmpFile(_response);
        });
    }

    protected processImportDmpFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class GatewayAppServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新建网关应用
     * @param dto dto
     * @return OK
     */
    create(dto: GatewayAppAddDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/gateway-apps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 更新网关应用
     * @param dto dto
     * @return OK
     */
    update(dto: GatewayAppUpdateDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/gateway-apps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询网关应用
     * @param gatewayId gatewayId
     * @return OK
     */
    queryGatewayAppList(gatewayId: string): Promise<网关应用[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/gateway-apps/list?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryGatewayAppList(_response);
        });
    }

    protected processQueryGatewayAppList(response: AxiosResponse): Promise<网关应用[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(网关应用.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<网关应用[]>(<any>null);
    }

    /**
     * 获取网关应用状态
     * @param gatewayAppId gatewayAppId
     * @return OK
     */
    getGatewayAppStatus(gatewayAppId: string): Promise<网关应用状态信息> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/gateway-apps/status/{gatewayAppId}";
        if (gatewayAppId === undefined || gatewayAppId === null)
            throw new Error("The parameter 'gatewayAppId' must be defined.");
        url_ = url_.replace("{gatewayAppId}", encodeURIComponent("" + gatewayAppId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayAppStatus(_response);
        });
    }

    protected processGetGatewayAppStatus(response: AxiosResponse): Promise<网关应用状态信息> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? 网关应用状态信息.fromJS(resultData200) : new 网关应用状态信息();
            return result200;
        }
        return Promise.resolve<网关应用状态信息>(<any>null);
    }

    /**
     * 切换网关应用
     * @param dto dto
     * @return OK
     */
    switchingType(dto: GatewayAppSwitchingTypeDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/gateway-apps/switching-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSwitchingType(_response);
        });
    }

    protected processSwitchingType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询网关应用类型
     * @param gatewayId gatewayId
     * @param tagName tagName
     * @return OK
     */
    queryGatewayAppTypeList(gatewayId: string, tagName: string): Promise<网关应用类型[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/gateway-apps/type?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        if (tagName === undefined || tagName === null)
            throw new Error("The parameter 'tagName' must be defined and cannot be null.");
        else
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryGatewayAppTypeList(_response);
        });
    }

    protected processQueryGatewayAppTypeList(response: AxiosResponse): Promise<网关应用类型[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(网关应用类型.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<网关应用类型[]>(<any>null);
    }

    /**
     * 删除网关应用
     * @param gatewayAppId gatewayAppId
     * @return OK
     */
    delete(gatewayAppId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/gateway-apps/{gatewayAppId}";
        if (gatewayAppId === undefined || gatewayAppId === null)
            throw new Error("The parameter 'gatewayAppId' must be defined.");
        url_ = url_.replace("{gatewayAppId}", encodeURIComponent("" + gatewayAppId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class GatewayServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询网关是否在线
     * @param gatewayId gatewayId
     * @return OK
     */
    getGatewayStatus(gatewayId: string): Promise<网关在线信息> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/gateways/status/{gatewayId}";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined.");
        url_ = url_.replace("{gatewayId}", encodeURIComponent("" + gatewayId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayStatus(_response);
        });
    }

    protected processGetGatewayStatus(response: AxiosResponse): Promise<网关在线信息> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? 网关在线信息.fromJS(resultData200) : new 网关在线信息();
            return result200;
        }
        return Promise.resolve<网关在线信息>(<any>null);
    }
}

export class IothubParameterServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 设置网关参数
     * @param dto dto
     * @return OK
     */
    setGatewayParams(dto: GatewayParamterSetValueDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/iothub-paramties/gatewaies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSetGatewayParams(_response);
        });
    }

    protected processSetGatewayParams(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取网关参数
     * @param gatewayId (optional) 网关ID
     * @return OK
     */
    getGatewayParams(gatewayId: string | null | undefined): Promise<ParamVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/iothub-paramties/gatewaies/{gatewayId}";
        if (gatewayId !== null && gatewayId !== undefined)
        url_ = url_.replace("{gatewayId}", encodeURIComponent("" + gatewayId)); 
        else
            url_ = url_.replace("/{gatewayId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayParams(_response);
        });
    }

    protected processGetGatewayParams(response: AxiosResponse): Promise<ParamVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParamVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ParamVO[]>(<any>null);
    }

    /**
     * 设置网关应用参数
     * @param dto dto
     * @return OK
     */
    setGatewayAppParams(dto: GatewayAppParamterSetValueDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/iothub-paramties/gateway-apps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSetGatewayAppParams(_response);
        });
    }

    protected processSetGatewayAppParams(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取网关应用参数
     * @param gatewayAppId (optional) 网关应用ID
     * @return OK
     */
    getGatewayAppParams(gatewayAppId: string | null | undefined): Promise<ParamVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/iothub-paramties/gateway-apps/{gatewayAppId}";
        if (gatewayAppId !== null && gatewayAppId !== undefined)
        url_ = url_.replace("{gatewayAppId}", encodeURIComponent("" + gatewayAppId)); 
        else
            url_ = url_.replace("/{gatewayAppId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayAppParams(_response);
        });
    }

    protected processGetGatewayAppParams(response: AxiosResponse): Promise<ParamVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParamVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ParamVO[]>(<any>null);
    }

    /**
     * 设置多个参数
     * @param id (optional) id
     * @param list list
     * @param type (optional) 类型
     * @return OK
     */
    setMultipleGatewayParams(id: string | null | undefined, list: MultipleParameterSetValueDTO[], type: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/iothub-paramties/multiple-parameters/{type}/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        if (type !== null && type !== undefined)
        url_ = url_.replace("{type}", encodeURIComponent("" + type)); 
        else
            url_ = url_.replace("/{type}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(list);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSetMultipleGatewayParams(_response);
        });
    }

    protected processSetMultipleGatewayParams(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class IothubPropertyServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询连接通道的address信息
     * @param gatewayAppId gatewayAppId
     * @return OK
     */
    queryAddressInfo(gatewayAppId: string): Promise<DeviceAddressVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/iothub-properties/gateway-app/address?";
        if (gatewayAppId === undefined || gatewayAppId === null)
            throw new Error("The parameter 'gatewayAppId' must be defined and cannot be null.");
        else
            url_ += "gatewayAppId=" + encodeURIComponent("" + gatewayAppId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryAddressInfo(_response);
        });
    }

    protected processQueryAddressInfo(response: AxiosResponse): Promise<DeviceAddressVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceAddressVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DeviceAddressVo[]>(<any>null);
    }

    /**
     * 属性详情
     * @param gatewayAppId (optional) 网关应用ID
     * @param name (optional) 属性名称
     * @return OK
     */
    getProperty(gatewayAppId: string | null | undefined, name: string | null | undefined): Promise<PropertiesVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/iothub-properties/gateway-app/detail?";
        if (gatewayAppId !== undefined)
            url_ += "gatewayAppId=" + encodeURIComponent("" + gatewayAppId) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProperty(_response);
        });
    }

    protected processGetProperty(response: AxiosResponse): Promise<PropertiesVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PropertiesVO.fromJS(resultData200) : new PropertiesVO();
            return result200;
        }
        return Promise.resolve<PropertiesVO>(<any>null);
    }

    /**
     * 查询所有属性
     * @param gatewayAppId gatewayAppId
     * @return OK
     */
    exportProperties(gatewayAppId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/iothub-properties/gateway-app/export?";
        if (gatewayAppId === undefined || gatewayAppId === null)
            throw new Error("The parameter 'gatewayAppId' must be defined and cannot be null.");
        else
            url_ += "gatewayAppId=" + encodeURIComponent("" + gatewayAppId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportProperties(_response);
        });
    }

    protected processExportProperties(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 通过json导入物模型
     * @param dto dto
     * @return OK
     */
    importPropertiesByJson(dto: ImportPropertiesDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/iothub-properties/gateway-app/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportPropertiesByJson(_response);
        });
    }

    protected processImportPropertiesByJson(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 通过上传文件导入物模型
     * @param file (optional) 上传的采集项文件
     * @param gatewayAppId (optional) 网关应用ID
     * @return OK
     */
    importPropertiesByFile(file: FileParameter | null | undefined, gatewayAppId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/iothub-properties/gateway-app/import-file?";
        if (gatewayAppId !== undefined)
            url_ += "gatewayAppId=" + encodeURIComponent("" + gatewayAppId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportPropertiesByFile(_response);
        });
    }

    protected processImportPropertiesByFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 设置属性值
     * @param gatewayAppId (optional) 网关应用ID
     * @param name (optional) 属性名称
     * @param value (optional) 属性名称
     * @return OK
     */
    setPropertyValue(gatewayAppId: string | null | undefined, name: string | null | undefined, value: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/iothub-properties/gateway-app/set-value?";
        if (gatewayAppId !== undefined)
            url_ += "gatewayAppId=" + encodeURIComponent("" + gatewayAppId) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSetPropertyValue(_response);
        });
    }

    protected processSetPropertyValue(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 删除属性
     * @param gatewayAppId (optional) 网关应用ID
     * @param name (optional) 属性名称
     * @return OK
     */
    delProperty(gatewayAppId: string | null | undefined, name: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/iothub-properties/gateway-apps/delete?";
        if (gatewayAppId !== undefined)
            url_ += "gatewayAppId=" + encodeURIComponent("" + gatewayAppId) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelProperty(_response);
        });
    }

    protected processDelProperty(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询属性
     * @param current (optional) 当前页
     * @param gatewayAppId gatewayAppId
     * @param size (optional) 每页的数量
     * @return OK
     */
    queryGatewayAppProperties(current: number | null | undefined, gatewayAppId: string, size: number | null | undefined): Promise<IPageOf网关应用> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/iothub-properties/gateway-apps/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (gatewayAppId === undefined || gatewayAppId === null)
            throw new Error("The parameter 'gatewayAppId' must be defined and cannot be null.");
        else
            url_ += "gatewayAppId=" + encodeURIComponent("" + gatewayAppId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryGatewayAppProperties(_response);
        });
    }

    protected processQueryGatewayAppProperties(response: AxiosResponse): Promise<IPageOf网关应用> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOf网关应用.fromJS(resultData200) : new IPageOf网关应用();
            return result200;
        }
        return Promise.resolve<IPageOf网关应用>(<any>null);
    }

    /**
     * 新增/修改属性
     * @param dto dto
     * @return OK
     */
    updateProperty(dto: 网关应用_2): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/iothub-properties/gateway-apps/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateProperty(_response);
        });
    }

    protected processUpdateProperty(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询属性
     * @param current (optional) 当前页
     * @param gatewayId gatewayId
     * @param size (optional) 每页的数量
     * @return OK
     */
    queryGatewayProperties(current: number | null | undefined, gatewayId: string, size: number | null | undefined): Promise<IPageOf网关应用> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/iothub-properties/gateways/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryGatewayProperties(_response);
        });
    }

    protected processQueryGatewayProperties(response: AxiosResponse): Promise<IPageOf网关应用> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOf网关应用.fromJS(resultData200) : new IPageOf网关应用();
            return result200;
        }
        return Promise.resolve<IPageOf网关应用>(<any>null);
    }
}

export class WorkStationIotServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询未关联指定工位的IOT列表
     * @return OK
     */
    getIots(): Promise<Iot列表[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/iots";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIots(_response);
        });
    }

    protected processGetIots(response: AxiosResponse): Promise<Iot列表[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Iot列表.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<Iot列表[]>(<any>null);
    }

    /**
     * 新增关联
     * @param dto dto
     * @return OK
     */
    createWorkStationIot(dto: WorkStationIotDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-iots";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateWorkStationIot(_response);
        });
    }

    protected processCreateWorkStationIot(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 取消关联
     * @param iotId IOT设备id
     * @param workStationId 工位id
     * @return OK
     */
    deleteWorkStationIot(iotId: string, workStationId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-iots?";
        if (iotId === undefined || iotId === null)
            throw new Error("The parameter 'iotId' must be defined and cannot be null.");
        else
            url_ += "iotId=" + encodeURIComponent("" + iotId) + "&"; 
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteWorkStationIot(_response);
        });
    }

    protected processDeleteWorkStationIot(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询工位与iot设备关联信息
     * @param workStationId (optional) workStationId
     * @return OK
     */
    getWorkStationIot(workStationId: string | null | undefined): Promise<WorkStationIot[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-iots/info?";
        if (workStationId !== undefined)
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkStationIot(_response);
        });
    }

    protected processGetWorkStationIot(response: AxiosResponse): Promise<WorkStationIot[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationIot.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationIot[]>(<any>null);
    }

    /**
     * 查询工位关联的IOT列表
     * @param workStationId 工位id
     * @return OK
     */
    getIotsByWorkstationId(workStationId: string): Promise<Iot简要信息[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations/{workStationId}/iots";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined.");
        url_ = url_.replace("{workStationId}", encodeURIComponent("" + workStationId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIotsByWorkstationId(_response);
        });
    }

    protected processGetIotsByWorkstationId(response: AxiosResponse): Promise<Iot简要信息[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Iot简要信息.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<Iot简要信息[]>(<any>null);
    }
}

export class MachineServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getForEdit
     * @param id id
     * @return OK
     */
    getForEdit(id: string): Promise<MachineVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<MachineVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MachineVO.fromJS(resultData200) : new MachineVO();
            return result200;
        }
        return Promise.resolve<MachineVO>(<any>null);
    }

    /**
     * 创建或更新机床信息
     * @param input input
     * @return OK
     */
    createOrUpdateMachine(input: CreateOrUpdateMachineDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateMachine(_response);
        });
    }

    protected processCreateOrUpdateMachine(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 删除机床列表
     * @param input input
     * @return OK
     */
    deleteMachineList(input: DeleteMachineListDTO): Promise<DeleteMachineListVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteMachineList(_response);
        });
    }

    protected processDeleteMachineList(response: AxiosResponse): Promise<DeleteMachineListVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? DeleteMachineListVO.fromJS(resultData200) : new DeleteMachineListVO();
            return result200;
        }
        return Promise.resolve<DeleteMachineListVO>(<any>null);
    }

    /**
     * 查询机床下拉列表（包含已删除的数据）
     * @param customerId (optional) 客户ID
     * @param name (optional) 机床名称
     * @param serialNo (optional) 机床序列号
     * @return OK
     */
    getAllMachineSelectList(customerId: string | null | undefined, name: string | null | undefined, serialNo: string | null | undefined): Promise<AllMachineSelectVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/all-select?";
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (serialNo !== undefined)
            url_ += "serialNo=" + encodeURIComponent("" + serialNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllMachineSelectList(_response);
        });
    }

    protected processGetAllMachineSelectList(response: AxiosResponse): Promise<AllMachineSelectVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AllMachineSelectVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AllMachineSelectVO[]>(<any>null);
    }

    /**
     * 绑定IOT功能
     * @param input input
     * @return OK
     */
    bindIot(input: BindMachineIotDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/bind-iot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processBindIot(_response);
        });
    }

    protected processBindIot(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 机床功能
     * @param id id
     * @return OK
     */
    feature(id: string): Promise<MachineFeatureVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/feature?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFeature(_response);
        });
    }

    protected processFeature(response: AxiosResponse): Promise<MachineFeatureVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MachineFeatureVO.fromJS(resultData200) : new MachineFeatureVO();
            return result200;
        }
        return Promise.resolve<MachineFeatureVO>(<any>null);
    }

    /**
     * 获取机器的网关信息
     * @param id id
     * @return OK
     */
    getMachineGateway(id: string): Promise<MachineGatewayVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/gateway?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMachineGateway(_response);
        });
    }

    protected processGetMachineGateway(response: AxiosResponse): Promise<MachineGatewayVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MachineGatewayVO.fromJS(resultData200) : new MachineGatewayVO();
            return result200;
        }
        return Promise.resolve<MachineGatewayVO>(<any>null);
    }

    /**
     * 获取可分配的机床
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    getAssignableMachineList(current: number | null | undefined, size: number | null | undefined): Promise<PageOfAssignableMachineDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/get-assignable-machine-list?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAssignableMachineList(_response);
        });
    }

    protected processGetAssignableMachineList(response: AxiosResponse): Promise<PageOfAssignableMachineDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PageOfAssignableMachineDTO.fromJS(resultData200) : new PageOfAssignableMachineDTO();
            return result200;
        }
        return Promise.resolve<PageOfAssignableMachineDTO>(<any>null);
    }

    /**
     * IOT采集设定
     * @param input input
     * @return OK
     */
    iotCollectionSettings(input: IotCollectionSettingDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/iot-collection-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processIotCollectionSettings(_response);
        });
    }

    protected processIotCollectionSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 分页查询机床
     * @param current (optional) 当前页
     * @param queryDto queryDto
     * @param size (optional) 每页的数量
     * @return OK
     */
    getMachineList(current: number | null | undefined, queryDto: GetMachineListDTO, size: number | null | undefined): Promise<PageOfGetMachineListVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMachineList(_response);
        });
    }

    protected processGetMachineList(response: AxiosResponse): Promise<PageOfGetMachineListVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PageOfGetMachineListVO.fromJS(resultData200) : new PageOfGetMachineListVO();
            return result200;
        }
        return Promise.resolve<PageOfGetMachineListVO>(<any>null);
    }

    /**
     * 查询重复的序列号设备列表
     * @return OK
     */
    getRepeatedSerialNoMachineList(): Promise<RepeatedSerialNoMachineVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/repeated-serial-no-machine-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRepeatedSerialNoMachineList(_response);
        });
    }

    protected processGetRepeatedSerialNoMachineList(response: AxiosResponse): Promise<RepeatedSerialNoMachineVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RepeatedSerialNoMachineVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<RepeatedSerialNoMachineVO[]>(<any>null);
    }

    /**
     * 查询机床下拉列表
     * @param customerId (optional) 客户ID
     * @param name (optional) 机床名称
     * @param serialNo (optional) 机床序列号
     * @return OK
     */
    getMachineSelectList(customerId: string | null | undefined, name: string | null | undefined, serialNo: string | null | undefined): Promise<MachineSelectVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/select?";
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (serialNo !== undefined)
            url_ += "serialNo=" + encodeURIComponent("" + serialNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMachineSelectList(_response);
        });
    }

    protected processGetMachineSelectList(response: AxiosResponse): Promise<MachineSelectVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MachineSelectVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MachineSelectVO[]>(<any>null);
    }

    /**
     * 判断机床序列号是否存在
     * @param customerId 客户ID
     * @param serialNo 设备序列号
     * @return OK
     */
    getMachineSerialNoIsExists(customerId: string, serialNo: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/serial-no-is-exists?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&"; 
        if (serialNo === undefined || serialNo === null)
            throw new Error("The parameter 'serialNo' must be defined and cannot be null.");
        else
            url_ += "serialNo=" + encodeURIComponent("" + serialNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMachineSerialNoIsExists(_response);
        });
    }

    protected processGetMachineSerialNoIsExists(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 分享机床
     * @param input input
     * @return OK
     */
    shareMachine(input: ShareMachineDTO): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/share-machine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processShareMachine(_response);
        });
    }

    protected processShareMachine(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * 大区机床数量统计
     * @param type 类型: 1:全部 2:自定义设备 3:网关设备 4:机型
     * @return OK
     */
    getAreaMachineStatistics(type: number): Promise<AreaMachineStatisticsVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/statistics/area?";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAreaMachineStatistics(_response);
        });
    }

    protected processGetAreaMachineStatistics(response: AxiosResponse): Promise<AreaMachineStatisticsVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaMachineStatisticsVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AreaMachineStatisticsVO[]>(<any>null);
    }

    /**
     * 设备类型机床数量统计
     * @param type 类型: 1:全部 2:自定义设备 3:网关设备
     * @return OK
     */
    getDeviceTypeMachineStatistics(type: number): Promise<ChartDataVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/statistics/device-type?";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceTypeMachineStatistics(_response);
        });
    }

    protected processGetDeviceTypeMachineStatistics(response: AxiosResponse): Promise<ChartDataVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChartDataVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ChartDataVO[]>(<any>null);
    }

    /**
     * 省份机床数量统计
     * @param queryDTO queryDTO
     * @return OK
     */
    getProvinceMachineStatistics(queryDTO: ProvinceMachineStatisticsDTO): Promise<ProvinceMachineStatisticsVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/statistics/province";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProvinceMachineStatistics(_response);
        });
    }

    protected processGetProvinceMachineStatistics(response: AxiosResponse): Promise<ProvinceMachineStatisticsVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProvinceMachineStatisticsVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProvinceMachineStatisticsVO[]>(<any>null);
    }

    /**
     * 未激活设备列表
     * @return OK
     */
    getUnactivatedMachineList(): Promise<UnactivatedMachineDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/unactivated-machine";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUnactivatedMachineList(_response);
        });
    }

    protected processGetUnactivatedMachineList(response: AxiosResponse): Promise<UnactivatedMachineDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnactivatedMachineDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<UnactivatedMachineDTO[]>(<any>null);
    }

    /**
     * 解除绑定IOT功能
     * @param input input
     * @return OK
     */
    unbindIot(input: UnbindMachineIotDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/unbind-iot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUnbindIot(_response);
        });
    }

    protected processUnbindIot(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取机床客户详情信息
     * @param id id
     * @return OK
     */
    getMachineCustomerDetail(id: string): Promise<MachineCustomerDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMachineCustomerDetail(_response);
        });
    }

    protected processGetMachineCustomerDetail(response: AxiosResponse): Promise<MachineCustomerDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MachineCustomerDetailVO.fromJS(resultData200) : new MachineCustomerDetailVO();
            return result200;
        }
        return Promise.resolve<MachineCustomerDetailVO>(<any>null);
    }
}

export class MachineIotServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getDetail
     * @param workStationId workStationId
     * @return OK
     */
    getDetail(workStationId: string): Promise<MachineIotVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine-iot/getDetail?";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDetail(_response);
        });
    }

    protected processGetDetail(response: AxiosResponse): Promise<MachineIotVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MachineIotVo.fromJS(resultData200) : new MachineIotVo();
            return result200;
        }
        return Promise.resolve<MachineIotVo>(<any>null);
    }

    /**
     * getGatewayBindInfoList
     * @param gatewayCode gatewayCode
     * @return OK
     */
    getGatewayBindInfoList(gatewayCode: string): Promise<GatewayBindInfoDto[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/machine-iot/getGatewayBindInfoList?";
        if (gatewayCode === undefined || gatewayCode === null)
            throw new Error("The parameter 'gatewayCode' must be defined and cannot be null.");
        else
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayBindInfoList(_response);
        });
    }

    protected processGetGatewayBindInfoList(response: AxiosResponse): Promise<GatewayBindInfoDto[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GatewayBindInfoDto.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<GatewayBindInfoDto[]>(<any>null);
    }
}

export class ProcessServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 保存或新增工序
     * @param processInsertDTO processInsertDTO
     * @return OK
     */
    createOrUpdateProcess(processInsertDTO: ProcessInsertDTO): Promise<Process> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(processInsertDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateProcess(_response);
        });
    }

    protected processCreateOrUpdateProcess(response: AxiosResponse): Promise<Process> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Process.fromJS(resultData200) : new Process();
            return result200;
        }
        return Promise.resolve<Process>(<any>null);
    }

    /**
     * 删除工序
     * @param ids ids
     * @return OK
     */
    deleteProcess(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/process?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteProcess(_response);
        });
    }

    protected processDeleteProcess(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 分页查询
     * @param current (optional) 当前页
     * @param employeeSearchDTO employeeSearchDTO
     * @param keyWords (optional) keyWords
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageProcess(current: number | null | undefined, employeeSearchDTO: ProcessSearchDTO, keyWords: string | null | undefined, size: number | null | undefined): Promise<IPageOfProcessBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/process/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (keyWords !== undefined)
            url_ += "keyWords=" + encodeURIComponent("" + keyWords) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeeSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageProcess(_response);
        });
    }

    protected processGetPageProcess(response: AxiosResponse): Promise<IPageOfProcessBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfProcessBO.fromJS(resultData200) : new IPageOfProcessBO();
            return result200;
        }
        return Promise.resolve<IPageOfProcessBO>(<any>null);
    }

    /**
     * 获取工序为绑定的工位id
     * @param processId processId
     * @return OK
     */
    getProcessUnboundWorkStation(processId: string): Promise<ProcessWorkStationVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/process/work-station-list?";
        if (processId === undefined || processId === null)
            throw new Error("The parameter 'processId' must be defined and cannot be null.");
        else
            url_ += "processId=" + encodeURIComponent("" + processId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProcessUnboundWorkStation(_response);
        });
    }

    protected processGetProcessUnboundWorkStation(response: AxiosResponse): Promise<ProcessWorkStationVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessWorkStationVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProcessWorkStationVO[]>(<any>null);
    }

    /**
     * 查询工序详细信息
     * @param id id
     * @return OK
     */
    getProcess(id: string): Promise<ProcessBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/process/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProcess(_response);
        });
    }

    protected processGetProcess(response: AxiosResponse): Promise<ProcessBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProcessBO.fromJS(resultData200) : new ProcessBO();
            return result200;
        }
        return Promise.resolve<ProcessBO>(<any>null);
    }
}

export class ProcessExcelServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出生产工序
     * @return OK
     */
    exportProduct(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/process/excel/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportProduct(_response);
        });
    }

    protected processExportProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 下载导入模板
     * @return OK
     */
    exportProductTemplate(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/process/excel/export/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportProductTemplate(_response);
        });
    }

    protected processExportProductTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导入工序数据
     * @param file (optional) file
     * @return OK
     */
    importProducts(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/process/excel/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportProducts(_response);
        });
    }

    protected processImportProducts(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ServiceRouteServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    listRoutes(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListRoutes(_response);
        });
    }

    protected processListRoutes(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class ListRoutesServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    1(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    2(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process2(_response);
        });
    }

    protected process2(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    3(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process3(_response);
        });
    }

    protected process3(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    5(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process5(_response);
        });
    }

    protected process5(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    6(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process6(_response);
        });
    }

    protected process6(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    4(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process4(_response);
        });
    }

    protected process4(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class WorkStationWcsSettingServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 删除设定
     * @param id id
     * @return OK
     */
    deleteWcsSetting(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/wcs-setting/delete-setting/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteWcsSetting(_response);
        });
    }

    protected processDeleteWcsSetting(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 单条编辑工况参数
     * @param workStationWcsEditDTO workStationWcsEditDTO
     * @return OK
     */
    updateWcsSetting(workStationWcsEditDTO: WorkStationWcsEditDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/wcs-setting/editor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationWcsEditDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateWcsSetting(_response);
        });
    }

    protected processUpdateWcsSetting(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 新增工况参数设定
     * @param wcsSettingDTO wcsSettingDTO
     * @return OK
     */
    insertWcsSetting(wcsSettingDTO: WcsSettingDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/wcs-setting/insert-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(wcsSettingDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInsertWcsSetting(_response);
        });
    }

    protected processInsertWcsSetting(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取工况参数列表
     * @return OK
     */
    getWorkStationWcsSettingList(): Promise<WorkStationWcsVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/wcs-setting/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkStationWcsSettingList(_response);
        });
    }

    protected processGetWorkStationWcsSettingList(response: AxiosResponse): Promise<WorkStationWcsVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationWcsVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationWcsVO[]>(<any>null);
    }
}

export class WorkStationStatusServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 根据工位code集合获取工况参数
     * @param workStationConditionStatusCodeDTO workStationConditionStatusCodeDTO
     * @return OK
     */
    list(workStationConditionStatusCodeDTO: WorkStationConditionStatusCodeDTO): Promise<WorkStationConditionStatusCollectVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-condition-status/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationConditionStatusCodeDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<WorkStationConditionStatusCollectVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationConditionStatusCollectVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationConditionStatusCollectVO[]>(<any>null);
    }
}

export class WorkStationGroupServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取工位组列表
     * @return OK
     */
    list(): Promise<WorkStationGroupListVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-group";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<WorkStationGroupListVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStationGroupListVO.fromJS(resultData200) : new WorkStationGroupListVO();
            return result200;
        }
        return Promise.resolve<WorkStationGroupListVO>(<any>null);
    }

    /**
     * allWorkStationGroupList
     * @return OK
     */
    allWorkStationGroupList(): Promise<WorkStationInGroupVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-group/all-work-station-group-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAllWorkStationGroupList(_response);
        });
    }

    protected processAllWorkStationGroupList(response: AxiosResponse): Promise<WorkStationInGroupVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationInGroupVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationInGroupVO[]>(<any>null);
    }

    /**
     * 新增工位到工位组
     * @param workStationAddToGroupDTO workStationAddToGroupDTO
     * @return OK
     */
    insertWorkStationToGroup(workStationAddToGroupDTO: WorkStationAddToGroupDTO): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-group/insert-work-station-to-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationAddToGroupDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInsertWorkStationToGroup(_response);
        });
    }

    protected processInsertWorkStationToGroup(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * 通过工作组id获取工位信息
     * @param current (optional) 当前页
     * @param groupId groupId
     * @param size (optional) 每页的数量
     * @return OK
     */
    workStationPage(current: number | null | undefined, groupId: string, size: number | null | undefined): Promise<IPageOfWorkStationGroupVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-group/page/{groupId}?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId)); 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationPage(_response);
        });
    }

    protected processWorkStationPage(response: AxiosResponse): Promise<IPageOfWorkStationGroupVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfWorkStationGroupVO.fromJS(resultData200) : new IPageOfWorkStationGroupVO();
            return result200;
        }
        return Promise.resolve<IPageOfWorkStationGroupVO>(<any>null);
    }

    /**
     * 通过工位组id删除工位信息
     * @param groupId groupId
     * @param workStationId workStationId
     * @return OK
     */
    removeWorkStation(groupId: string, workStationId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-group/remove-work-station/{groupId}?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId)); 
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemoveWorkStation(_response);
        });
    }

    protected processRemoveWorkStation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 新增工位组下的工位信息
     * @param saveWorkStationToGroupDTO saveWorkStationToGroupDTO
     * @return OK
     */
    saveWorkStationToGroup(saveWorkStationToGroupDTO: SaveWorkStationToGroupDTO): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-group/save-work-station";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveWorkStationToGroupDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveWorkStationToGroup(_response);
        });
    }

    protected processSaveWorkStationToGroup(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * 可视化工位工位组接口
     * @return OK
     */
    visualWorkStation(): Promise<WorkStationInGroupVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-group/visual-work-station";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVisualWorkStation(_response);
        });
    }

    protected processVisualWorkStation(response: AxiosResponse): Promise<WorkStationInGroupVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationInGroupVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationInGroupVO[]>(<any>null);
    }

    /**
     * 获取工位组信息、工位列表信息
     * @return OK
     */
    workStationGroupList(): Promise<WorkStationInGroupVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-group/work-station-group-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationGroupList(_response);
        });
    }

    protected processWorkStationGroupList(response: AxiosResponse): Promise<WorkStationInGroupVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationInGroupVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationInGroupVO[]>(<any>null);
    }

    /**
     * 通过工位组id获取未绑定的工位信息
     * @param groupId groupId
     * @return OK
     */
    workStationList(groupId: string): Promise<WorkStationBriefVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-group/work-station-list/{groupId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationList(_response);
        });
    }

    protected processWorkStationList(response: AxiosResponse): Promise<WorkStationBriefVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationBriefVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationBriefVO[]>(<any>null);
    }

    /**
     * 修改工作组信息
     * @param id id
     * @param name name
     * @return OK
     */
    update(id: string, name: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-group/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 通过Id删除工位组信息
     * @param id id
     * @return OK
     */
    deleteWordStationById(id: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-group/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteWordStationById(_response);
        });
    }

    protected processDeleteWordStationById(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 新增工位组信息
     * @param name name
     * @param parentId parentId
     * @return OK
     */
    saveWorkStation(name: string, parentId: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-group/{parentId}?";
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId)); 
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveWorkStation(_response);
        });
    }

    protected processSaveWorkStation(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class WorkStationNewIotServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * initIotAssociate
     * @return OK
     */
    initIotAssociate(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-new-iot/init-iot-associate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInitIotAssociate(_response);
        });
    }

    protected processInitIotAssociate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询未关联指定工位的IOT列表
     * @return OK
     */
    getIots(): Promise<Iot列表[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-new-iot/iots";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIots(_response);
        });
    }

    protected processGetIots(response: AxiosResponse): Promise<Iot列表[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Iot列表.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<Iot列表[]>(<any>null);
    }

    /**
     * 工位和新iot关联
     * @param dto dto
     * @return OK
     */
    workStationIotRelation(dto: WorkStationIotDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-new-iot/work-station-iot-relation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationIotRelation(_response);
        });
    }

    protected processWorkStationIotRelation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class QrServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 添加设备附件
     * @param deviceFileInDTO deviceFileInDTO
     * @return OK
     */
    saveDeviceFile(deviceFileInDTO: DeviceFileInDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-qr/file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceFileInDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveDeviceFile(_response);
        });
    }

    protected processSaveDeviceFile(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 工位二维码
     * @param workStationCode workStationCode
     * @return OK
     */
    workStationQr(workStationCode: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-qr/{workStationCode}";
        if (workStationCode === undefined || workStationCode === null)
            throw new Error("The parameter 'workStationCode' must be defined.");
        url_ = url_.replace("{workStationCode}", encodeURIComponent("" + workStationCode)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationQr(_response);
        });
    }

    protected processWorkStationQr(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询设备附件
     * @param workStationId workStationId
     * @return OK
     */
    getDeviceFile(workStationId: string): Promise<DeviceFileDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-qr/{workStationId}/file";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined.");
        url_ = url_.replace("{workStationId}", encodeURIComponent("" + workStationId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceFile(_response);
        });
    }

    protected processGetDeviceFile(response: AxiosResponse): Promise<DeviceFileDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceFileDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DeviceFileDTO[]>(<any>null);
    }
}

export class WorkStationSettingServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 根据传输目录id查询工位
     * @param id (optional) 传输目录id
     * @return OK
     */
    getWorkStationById(id: string | null | undefined): Promise<WorkStationToDncVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-setting/get-work-station-by-id?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkStationById(_response);
        });
    }

    protected processGetWorkStationById(response: AxiosResponse): Promise<WorkStationToDncVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationToDncVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationToDncVO[]>(<any>null);
    }

    /**
     * 获取工位绑定的传输目录
     * @param workStationId (optional) workStationId
     * @return OK
     */
    workStationTransferSettingDetail(workStationId: string | null | undefined): Promise<WorkStationTransferSettingVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-setting/transfer-directory?";
        if (workStationId !== undefined)
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationTransferSettingDetail(_response);
        });
    }

    protected processWorkStationTransferSettingDetail(response: AxiosResponse): Promise<WorkStationTransferSettingVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStationTransferSettingVO.fromJS(resultData200) : new WorkStationTransferSettingVO();
            return result200;
        }
        return Promise.resolve<WorkStationTransferSettingVO>(<any>null);
    }

    /**
     * 工位设定传输目录
     * @param workStationTransferSettingDTO workStationTransferSettingDTO
     * @return OK
     */
    workStationTransferSetting(workStationTransferSettingDTO: WorkStationTransferSettingDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-setting/transfer-directory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationTransferSettingDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationTransferSetting(_response);
        });
    }

    protected processWorkStationTransferSetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class WorkStationRealTimeStatusServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 根据工位组Id获取工位的实时状态
     * @param current (optional) 当前页
     * @param dto dto
     * @param size (optional) 每页的数量
     * @return OK
     */
    getRealTimeStatus(current: number | null | undefined, dto: WorkStationRealTimeStatusDTO, size: number | null | undefined): Promise<IPageOfWorkStationRealTimeStatusVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-status?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRealTimeStatus(_response);
        });
    }

    protected processGetRealTimeStatus(response: AxiosResponse): Promise<IPageOfWorkStationRealTimeStatusVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfWorkStationRealTimeStatusVO.fromJS(resultData200) : new IPageOfWorkStationRealTimeStatusVO();
            return result200;
        }
        return Promise.resolve<IPageOfWorkStationRealTimeStatusVO>(<any>null);
    }

    /**
     * 根据客户Id获取工位的实时状态
     * @param dto dto
     * @return OK
     */
    getRealTimeStatusByCustomerIdList(dto: CustomerWorkStationRealTimeStatusDTO): Promise<IPageOfCustomerWorkStationRealTimeStatusVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-status/customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRealTimeStatusByCustomerIdList(_response);
        });
    }

    protected processGetRealTimeStatusByCustomerIdList(response: AxiosResponse): Promise<IPageOfCustomerWorkStationRealTimeStatusVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCustomerWorkStationRealTimeStatusVO.fromJS(resultData200) : new IPageOfCustomerWorkStationRealTimeStatusVO();
            return result200;
        }
        return Promise.resolve<IPageOfCustomerWorkStationRealTimeStatusVO>(<any>null);
    }
}

export class WorkStationVisualServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询设备状态及对应的数量
     * @param id (optional) 工位组id
     * @return OK
     */
    getDeviceStatus(id: string | null | undefined): Promise<WorkStationVisualVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-station-visual/status-count?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceStatus(_response);
        });
    }

    protected processGetDeviceStatus(response: AxiosResponse): Promise<WorkStationVisualVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStationVisualVO.fromJS(resultData200) : new WorkStationVisualVO();
            return result200;
        }
        return Promise.resolve<WorkStationVisualVO>(<any>null);
    }
}

export class WorkStationServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 添加工位
     * @param dto dto
     * @return OK
     */
    createWorkStation(dto: WorkStationSubmitDTO): Promise<WorkStation> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateWorkStation(_response);
        });
    }

    protected processCreateWorkStation(response: AxiosResponse): Promise<WorkStation> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStation.fromJS(resultData200) : new WorkStation();
            return result200;
        }
        return Promise.resolve<WorkStation>(<any>null);
    }

    /**
     * 批量删除工位
     * @param ids 工位ids
     * @return OK
     */
    deleteWorkStation(ids: string[]): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteWorkStation(_response);
        });
    }

    protected processDeleteWorkStation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 绑定通过日历id获取没有绑定此日历的工位
     * @param workStationBatchBoundCalendarDTO workStationBatchBoundCalendarDTO
     * @return OK
     */
    calendarBoundWorkStation(workStationBatchBoundCalendarDTO: WorkStationBatchBoundCalendarDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations/calendar/bound/work-station";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationBatchBoundCalendarDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCalendarBoundWorkStation(_response);
        });
    }

    protected processCalendarBoundWorkStation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询相关工位的指定日期班次下标的名称
     * @param workStationShiftIndexNameQueryDTO workStationShiftIndexNameQueryDTO
     * @return OK
     */
    getWorkstationShiftIndexName(workStationShiftIndexNameQueryDTO: WorkStationShiftIndexNameQueryDTO): Promise<WorkstationCalendarShiftVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations/calendar/shift/indexName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationShiftIndexNameQueryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkstationShiftIndexName(_response);
        });
    }

    protected processGetWorkstationShiftIndexName(response: AxiosResponse): Promise<WorkstationCalendarShiftVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkstationCalendarShiftVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkstationCalendarShiftVO[]>(<any>null);
    }

    /**
     * copyWorkStationInfo
     * @param dto dto
     * @return OK
     */
    copyWorkStationInfo(dto: CopyWorkStationDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations/copy-work-station-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCopyWorkStationInfo(_response);
        });
    }

    protected processCopyWorkStationInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出网关信息
     * @param dto dto
     * @return OK
     */
    exportGateway(dto: GatewayExportDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations/gateway-export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportGateway(_response);
        });
    }

    protected processExportGateway(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 根据工位code查询工位信息
     * @param workStationCodeList workStationCodeList
     * @return OK
     */
    getByCode(workStationCodeList: string[]): Promise<WorkStationBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations/getByCode?";
        if (workStationCodeList === undefined || workStationCodeList === null)
            throw new Error("The parameter 'workStationCodeList' must be defined and cannot be null.");
        else
            workStationCodeList && workStationCodeList.forEach(item => { url_ += "workStationCodeList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetByCode(_response);
        });
    }

    protected processGetByCode(response: AxiosResponse): Promise<WorkStationBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationBO[]>(<any>null);
    }

    /**
     * 查询去除休息的班次时间
     * @param workStationId workStationId
     * @return OK
     */
    getShiftTimeWithoutRest(workStationId: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations/getShiftTimeWithoutRest/{workStationId}";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined.");
        url_ = url_.replace("{workStationId}", encodeURIComponent("" + workStationId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetShiftTimeWithoutRest(_response);
        });
    }

    protected processGetShiftTimeWithoutRest(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 根据iotCode查询工位信息
     * @param iotCode (optional) iotCode
     * @param tenantId (optional) tenantId
     * @return OK
     */
    getWorkStationByIotCode(iotCode: string | null | undefined, tenantId: string | null | undefined): Promise<QrCodeInfoVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations/iot?";
        if (iotCode !== undefined)
            url_ += "iotCode=" + encodeURIComponent("" + iotCode) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkStationByIotCode(_response);
        });
    }

    protected processGetWorkStationByIotCode(response: AxiosResponse): Promise<QrCodeInfoVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QrCodeInfoVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<QrCodeInfoVO[]>(<any>null);
    }

    /**
     * 关键词查询所有工位code-name
     * @param keyWord (optional) keyWord
     * @return OK
     */
    getWorkStationCodeAndName(keyWord: string | null | undefined): Promise<WorkStationIdCodeNameVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations/list?";
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkStationCodeAndName(_response);
        });
    }

    protected processGetWorkStationCodeAndName(response: AxiosResponse): Promise<WorkStationIdCodeNameVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationIdCodeNameVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationIdCodeNameVO[]>(<any>null);
    }

    /**
     * 获取未绑定此日历的工位
     * @param calendarCode (optional) 生产日历Code
     * @return OK
     */
    noCalendarBoundWorkStation(calendarCode: string | null | undefined): Promise<WorkStationInGroupVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations/no-calendar-bound/work-station?";
        if (calendarCode !== undefined)
            url_ += "calendarCode=" + encodeURIComponent("" + calendarCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processNoCalendarBoundWorkStation(_response);
        });
    }

    protected processNoCalendarBoundWorkStation(response: AxiosResponse): Promise<WorkStationInGroupVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationInGroupVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationInGroupVO[]>(<any>null);
    }

    /**
     * 查询工位
     * @param current (optional) 当前页
     * @param dto dto
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageWorkStations(current: number | null | undefined, dto: WorkStationDTO, size: number | null | undefined): Promise<PageOfWorkStationBriefVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageWorkStations(_response);
        });
    }

    protected processGetPageWorkStations(response: AxiosResponse): Promise<PageOfWorkStationBriefVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PageOfWorkStationBriefVO.fromJS(resultData200) : new PageOfWorkStationBriefVO();
            return result200;
        }
        return Promise.resolve<PageOfWorkStationBriefVO>(<any>null);
    }

    /**
     * 查询工位详情
     * @param id 工位id
     * @return OK
     */
    getWorkStation(id: string): Promise<WorkStationInsertGroupVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkStation(_response);
        });
    }

    protected processGetWorkStation(response: AxiosResponse): Promise<WorkStationInsertGroupVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStationInsertGroupVO.fromJS(resultData200) : new WorkStationInsertGroupVO();
            return result200;
        }
        return Promise.resolve<WorkStationInsertGroupVO>(<any>null);
    }

    /**
     * 更新工位
     * @param dto dto
     * @param id 工位id
     * @return OK
     */
    updateWorkStation(dto: WorkStationSubmitDTO, id: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateWorkStation(_response);
        });
    }

    protected processUpdateWorkStation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class WrokStationCopyServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * copy
     * @param dto dto
     * @return OK
     */
    copy(dto: CopyWorkStationDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations-copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCopy(_response);
        });
    }

    protected processCopy(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ExtranetServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getExtranetGateway
     * @param workStationId workStationId
     * @return OK
     */
    getExtranetGateway(workStationId: string): Promise<GatewayDeviceVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/work-stations/device/{workStationId}";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined.");
        url_ = url_.replace("{workStationId}", encodeURIComponent("" + workStationId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetExtranetGateway(_response);
        });
    }

    protected processGetExtranetGateway(response: AxiosResponse): Promise<GatewayDeviceVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? GatewayDeviceVO.fromJS(resultData200) : new GatewayDeviceVO();
            return result200;
        }
        return Promise.resolve<GatewayDeviceVO>(<any>null);
    }
}

export class WorkStationWorkingConditionParamSettingServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询工位数据项列表
     * @param workStationId (optional) 工位id
     * @return OK
     */
    getWorkingConditionParams(workStationId: string | null | undefined): Promise<WorkingConditionParamVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/working-condition-params?";
        if (workStationId !== undefined)
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkingConditionParams(_response);
        });
    }

    protected processGetWorkingConditionParams(response: AxiosResponse): Promise<WorkingConditionParamVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkingConditionParamVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkingConditionParamVO[]>(<any>null);
    }

    /**
     * 添加工位数据项
     * @param dto dto
     * @return OK
     */
    createWorkingConditionParam(dto: WorkingConditionParamSubmitDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/working-condition-params";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateWorkingConditionParam(_response);
        });
    }

    protected processCreateWorkingConditionParam(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 批量删除工位数据项
     * @param ids (optional) 工位数据项ids
     * @return OK
     */
    deleteWorkingConditionParam(ids: string[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/working-condition-params?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteWorkingConditionParam(_response);
        });
    }

    protected processDeleteWorkingConditionParam(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * exportJson
     * @param workStationId workStationId
     * @return OK
     */
    exportJson(workStationId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/working-condition-params/export-json?";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportJson(_response);
        });
    }

    protected processExportJson(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * importJson
     * @param file file
     * @param iotAppCode (optional) 网关IOT 应用CODE
     * @param iotAppId (optional) 网关IOT 应用ID
     * @param iotAppName (optional) 网关应用 名称
     * @param iotCode (optional) 网关IOT CODE
     * @param iotId (optional) 网关IOT ID
     * @param iotName (optional) 网关IOT 名称
     * @param iotVersion (optional) 网关IOT 版本
     * @param workStationCode (optional) 工位CODE
     * @param workStationId (optional) 工位ID
     * @return OK
     */
    importJson(file: FileParameter, iotAppCode: string | null | undefined, iotAppId: string | null | undefined, iotAppName: string | null | undefined, iotCode: string | null | undefined, iotId: string | null | undefined, iotName: string | null | undefined, iotVersion: number | null | undefined, workStationCode: string | null | undefined, workStationId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/working-condition-params/import-json?";
        if (iotAppCode !== undefined)
            url_ += "iotAppCode=" + encodeURIComponent("" + iotAppCode) + "&"; 
        if (iotAppId !== undefined)
            url_ += "iotAppId=" + encodeURIComponent("" + iotAppId) + "&"; 
        if (iotAppName !== undefined)
            url_ += "iotAppName=" + encodeURIComponent("" + iotAppName) + "&"; 
        if (iotCode !== undefined)
            url_ += "iotCode=" + encodeURIComponent("" + iotCode) + "&"; 
        if (iotId !== undefined)
            url_ += "iotId=" + encodeURIComponent("" + iotId) + "&"; 
        if (iotName !== undefined)
            url_ += "iotName=" + encodeURIComponent("" + iotName) + "&"; 
        if (iotVersion !== undefined)
            url_ += "iotVersion=" + encodeURIComponent("" + iotVersion) + "&"; 
        if (workStationCode !== undefined)
            url_ += "workStationCode=" + encodeURIComponent("" + workStationCode) + "&"; 
        if (workStationId !== undefined)
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportJson(_response);
        });
    }

    protected processImportJson(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取采集项最新数据
     * @param id (optional) 工位id
     * @return OK
     */
    getPropertyLatestValue(id: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/working-condition-params/latest-property-value?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPropertyLatestValue(_response);
        });
    }

    protected processGetPropertyLatestValue(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 根据工位Code查询工位数据项列表
     * @param workStationCode (optional) 工位Code
     * @return OK
     */
    getWorkingConditionParamsByCode(workStationCode: string | null | undefined): Promise<WorkingConditionParamVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/working-condition-params/list?";
        if (workStationCode !== undefined)
            url_ += "workStationCode=" + encodeURIComponent("" + workStationCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkingConditionParamsByCode(_response);
        });
    }

    protected processGetWorkingConditionParamsByCode(response: AxiosResponse): Promise<WorkingConditionParamVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkingConditionParamVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkingConditionParamVO[]>(<any>null);
    }

    /**
     * 根据工位code集合查询工位数据项列表
     * @param workStationCodeList workStationCodeList
     * @return OK
     */
    getWorkingConditionParamsByWorkStationCodeList(workStationCodeList: string[]): Promise<{ [key: string] : WorkingConditionParamVO[]; }> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/working-condition-params/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationCodeList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkingConditionParamsByWorkStationCodeList(_response);
        });
    }

    protected processGetWorkingConditionParamsByWorkStationCodeList(response: AxiosResponse): Promise<{ [key: string] : WorkingConditionParamVO[]; }> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key] ? resultData200[key].map((i: any) => WorkingConditionParamVO.fromJS(i)) : [];
                }
            }
            return result200;
        }
        return Promise.resolve<{ [key: string] : WorkingConditionParamVO[]; }>(<any>null);
    }

    /**
     * rebuildWorkStationWorkingConditionParamSetting
     * @return OK
     */
    rebuildWorkStationWorkingConditionParamSetting(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/working-condition-params/rebuild-wcs-params";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRebuildWorkStationWorkingConditionParamSetting(_response);
        });
    }

    protected processRebuildWorkStationWorkingConditionParamSetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 同步工位工况参数配置
     * @param workStationParamSettingDTO workStationParamSettingDTO
     * @return OK
     */
    syncWorkStationParamSetting(workStationParamSettingDTO: WorkStationParamSettingDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/working-condition-params/sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationParamSettingDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSyncWorkStationParamSetting(_response);
        });
    }

    protected processSyncWorkStationParamSetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 更新工位数据项
     * @param dto dto
     * @param id (optional) 工位数据项id
     * @return OK
     */
    updateWorkingConditionParam(dto: WorkingConditionParamSubmitDTO, id: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/working-condition-params/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateWorkingConditionParam(_response);
        });
    }

    protected processUpdateWorkingConditionParam(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class WorkingConditionStatusServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * rebuildWorkStationWorkingConditionStatus
     * @param tenantList tenantList
     * @return OK
     */
    rebuildWorkStationWorkingConditionStatus(tenantList: string[]): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-work-station')+ "/working-condition-status/rebuild-wcs-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenantList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRebuildWorkStationWorkingConditionStatus(_response);
        });
    }

    protected processRebuildWorkStationWorkingConditionStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class AllMachineSelectVO implements IAllMachineSelectVO {
    id!: string | undefined;
    /** 机床序列号 */
    serialNo!: string | undefined;
    /** 状态(1网关设备,2自定义设备) */
    status!: number | undefined;

    constructor(data?: IAllMachineSelectVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.serialNo = data["serialNo"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): AllMachineSelectVO {
        data = typeof data === 'object' ? data : {};
        let result = new AllMachineSelectVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNo"] = this.serialNo;
        data["status"] = this.status;
        return data; 
    }
}

export interface IAllMachineSelectVO {
    id: string | undefined;
    /** 机床序列号 */
    serialNo: string | undefined;
    /** 状态(1网关设备,2自定义设备) */
    status: number | undefined;
}

export class AreaMachineStatisticsVO implements IAreaMachineStatisticsVO {
    /** 各设备类型的设备数 */
    deviceTypeDataList!: ChartDataVO[] | undefined;
    /** 大区名称 */
    name!: string | undefined;
    /** 设备数 */
    value!: string | undefined;

    constructor(data?: IAreaMachineStatisticsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["deviceTypeDataList"] && data["deviceTypeDataList"].constructor === Array) {
                this.deviceTypeDataList = [] as any;
                for (let item of data["deviceTypeDataList"])
                    this.deviceTypeDataList!.push(ChartDataVO.fromJS(item));
            }
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): AreaMachineStatisticsVO {
        data = typeof data === 'object' ? data : {};
        let result = new AreaMachineStatisticsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.deviceTypeDataList && this.deviceTypeDataList.constructor === Array) {
            data["deviceTypeDataList"] = [];
            for (let item of this.deviceTypeDataList)
                data["deviceTypeDataList"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface IAreaMachineStatisticsVO {
    /** 各设备类型的设备数 */
    deviceTypeDataList: ChartDataVO[] | undefined;
    /** 大区名称 */
    name: string | undefined;
    /** 设备数 */
    value: string | undefined;
}

export class AssignableMachineDTO implements IAssignableMachineDTO {
    code!: string | undefined;
    id!: string | undefined;
    name!: string | undefined;
    serialNo!: string | undefined;

    constructor(data?: IAssignableMachineDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.serialNo = data["serialNo"];
        }
    }

    static fromJS(data: any): AssignableMachineDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableMachineDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["serialNo"] = this.serialNo;
        return data; 
    }
}

export interface IAssignableMachineDTO {
    code: string | undefined;
    id: string | undefined;
    name: string | undefined;
    serialNo: string | undefined;
}

export class BaseFiledDTO implements IBaseFiledDTO {
    access!: number | undefined;
    array!: boolean | undefined;
    dataType!: string | undefined;
    description!: string | undefined;
    factor!: number | undefined;
    ioaddress!: string | undefined;
    lowerWarn!: number | undefined;
    maxValue!: number | undefined;
    minValue!: number | undefined;
    precision!: number | undefined;
    upperWarn!: number | undefined;
    value!: string | undefined;

    constructor(data?: IBaseFiledDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.access = data["access"];
            this.array = data["array"];
            this.dataType = data["dataType"];
            this.description = data["description"];
            this.factor = data["factor"];
            this.ioaddress = data["ioaddress"];
            this.lowerWarn = data["lowerWarn"];
            this.maxValue = data["maxValue"];
            this.minValue = data["minValue"];
            this.precision = data["precision"];
            this.upperWarn = data["upperWarn"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): BaseFiledDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BaseFiledDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access"] = this.access;
        data["array"] = this.array;
        data["dataType"] = this.dataType;
        data["description"] = this.description;
        data["factor"] = this.factor;
        data["ioaddress"] = this.ioaddress;
        data["lowerWarn"] = this.lowerWarn;
        data["maxValue"] = this.maxValue;
        data["minValue"] = this.minValue;
        data["precision"] = this.precision;
        data["upperWarn"] = this.upperWarn;
        data["value"] = this.value;
        return data; 
    }
}

export interface IBaseFiledDTO {
    access: number | undefined;
    array: boolean | undefined;
    dataType: string | undefined;
    description: string | undefined;
    factor: number | undefined;
    ioaddress: string | undefined;
    lowerWarn: number | undefined;
    maxValue: number | undefined;
    minValue: number | undefined;
    precision: number | undefined;
    upperWarn: number | undefined;
    value: string | undefined;
}

export class BaseFiledVo implements IBaseFiledVo {
    access!: number | undefined;
    array!: boolean | undefined;
    dataType!: string | undefined;
    description!: string | undefined;
    factor!: number | undefined;
    ioaddress!: string | undefined;
    lowerWarn!: number | undefined;
    maxValue!: number | undefined;
    minValue!: number | undefined;
    precision!: number | undefined;
    upperWarn!: number | undefined;
    value!: string | undefined;

    constructor(data?: IBaseFiledVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.access = data["access"];
            this.array = data["array"];
            this.dataType = data["dataType"];
            this.description = data["description"];
            this.factor = data["factor"];
            this.ioaddress = data["ioaddress"];
            this.lowerWarn = data["lowerWarn"];
            this.maxValue = data["maxValue"];
            this.minValue = data["minValue"];
            this.precision = data["precision"];
            this.upperWarn = data["upperWarn"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): BaseFiledVo {
        data = typeof data === 'object' ? data : {};
        let result = new BaseFiledVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access"] = this.access;
        data["array"] = this.array;
        data["dataType"] = this.dataType;
        data["description"] = this.description;
        data["factor"] = this.factor;
        data["ioaddress"] = this.ioaddress;
        data["lowerWarn"] = this.lowerWarn;
        data["maxValue"] = this.maxValue;
        data["minValue"] = this.minValue;
        data["precision"] = this.precision;
        data["upperWarn"] = this.upperWarn;
        data["value"] = this.value;
        return data; 
    }
}

export interface IBaseFiledVo {
    access: number | undefined;
    array: boolean | undefined;
    dataType: string | undefined;
    description: string | undefined;
    factor: number | undefined;
    ioaddress: string | undefined;
    lowerWarn: number | undefined;
    maxValue: number | undefined;
    minValue: number | undefined;
    precision: number | undefined;
    upperWarn: number | undefined;
    value: string | undefined;
}

export class BindMachineIotDTO implements IBindMachineIotDTO {
    appCode!: number | undefined;
    appId!: string | undefined;
    deviceIp!: string | undefined;
    devicePort!: number | undefined;
    featureValue!: number | undefined;
    gatewayCode!: string | undefined;
    gatewayId!: string | undefined;
    templateId!: string | undefined;
    workStationId!: string | undefined;

    constructor(data?: IBindMachineIotDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.appId = data["appId"];
            this.deviceIp = data["deviceIp"];
            this.devicePort = data["devicePort"];
            this.featureValue = data["featureValue"];
            this.gatewayCode = data["gatewayCode"];
            this.gatewayId = data["gatewayId"];
            this.templateId = data["templateId"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): BindMachineIotDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BindMachineIotDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["appId"] = this.appId;
        data["deviceIp"] = this.deviceIp;
        data["devicePort"] = this.devicePort;
        data["featureValue"] = this.featureValue;
        data["gatewayCode"] = this.gatewayCode;
        data["gatewayId"] = this.gatewayId;
        data["templateId"] = this.templateId;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IBindMachineIotDTO {
    appCode: number | undefined;
    appId: string | undefined;
    deviceIp: string | undefined;
    devicePort: number | undefined;
    featureValue: number | undefined;
    gatewayCode: string | undefined;
    gatewayId: string | undefined;
    templateId: string | undefined;
    workStationId: string | undefined;
}

/** 工位信息 */
export class CalendarShiftVO implements ICalendarShiftVO {
    /** 日期以及下标 */
    calendarIndex!: string | undefined;
    /** 下标名称 */
    indexName!: string | undefined;

    constructor(data?: ICalendarShiftVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calendarIndex = data["calendarIndex"];
            this.indexName = data["indexName"];
        }
    }

    static fromJS(data: any): CalendarShiftVO {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarShiftVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarIndex"] = this.calendarIndex;
        data["indexName"] = this.indexName;
        return data; 
    }
}

/** 工位信息 */
export interface ICalendarShiftVO {
    /** 日期以及下标 */
    calendarIndex: string | undefined;
    /** 下标名称 */
    indexName: string | undefined;
}

export class ChartDataVO implements IChartDataVO {
    name!: string | undefined;
    value!: any | undefined;

    constructor(data?: IChartDataVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): ChartDataVO {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDataVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface IChartDataVO {
    name: string | undefined;
    value: any | undefined;
}

export class CheckMachineVO implements ICheckMachineVO {
    /** 客户列表 */
    customerList!: CustomerVO[] | undefined;
    /** 未出库 */
    notOutbound!: boolean | undefined;
    /** 状态: 0正常 1当前客户下已存在相同序列号的系统设备或自定义设备 2其他客户下已存在相同序列号的系统设备或自定义设备或未出库机床已存在相同序列号的系统设备 */
    status!: number | undefined;

    constructor(data?: ICheckMachineVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["customerList"] && data["customerList"].constructor === Array) {
                this.customerList = [] as any;
                for (let item of data["customerList"])
                    this.customerList!.push(CustomerVO.fromJS(item));
            }
            this.notOutbound = data["notOutbound"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): CheckMachineVO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckMachineVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.customerList && this.customerList.constructor === Array) {
            data["customerList"] = [];
            for (let item of this.customerList)
                data["customerList"].push(item.toJSON());
        }
        data["notOutbound"] = this.notOutbound;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICheckMachineVO {
    /** 客户列表 */
    customerList: CustomerVO[] | undefined;
    /** 未出库 */
    notOutbound: boolean | undefined;
    /** 状态: 0正常 1当前客户下已存在相同序列号的系统设备或自定义设备 2其他客户下已存在相同序列号的系统设备或自定义设备或未出库机床已存在相同序列号的系统设备 */
    status: number | undefined;
}

/** 复制工位基础信息 */
export class CopyWorkStationDTO implements ICopyWorkStationDTO {
    /** 原工位ID */
    originalWorkStationId!: string | undefined;
    /** 传输目录ID */
    transferId!: string | undefined;
    /** 工位信息 */
    workStationInfo!: WorkStationSubmitDTO | undefined;

    constructor(data?: ICopyWorkStationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.originalWorkStationId = data["originalWorkStationId"];
            this.transferId = data["transferId"];
            this.workStationInfo = data["workStationInfo"] ? WorkStationSubmitDTO.fromJS(data["workStationInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CopyWorkStationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CopyWorkStationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalWorkStationId"] = this.originalWorkStationId;
        data["transferId"] = this.transferId;
        data["workStationInfo"] = this.workStationInfo ? this.workStationInfo.toJSON() : <any>undefined;
        return data; 
    }
}

/** 复制工位基础信息 */
export interface ICopyWorkStationDTO {
    /** 原工位ID */
    originalWorkStationId: string | undefined;
    /** 传输目录ID */
    transferId: string | undefined;
    /** 工位信息 */
    workStationInfo: WorkStationSubmitDTO | undefined;
}

export class CreateOrUpdateMachineDTO implements ICreateOrUpdateMachineDTO {
    assemblyState!: number;
    attachFiles!: string[] | undefined;
    avatar!: string | undefined;
    code!: string;
    deliveryTime!: string | undefined;
    deviceTypeId!: string;
    hyperlink!: string | undefined;
    id!: string | undefined;
    name!: string;
    serialNo!: string;
    softwareVersion!: string | undefined;
    systemName!: string | undefined;

    constructor(data?: ICreateOrUpdateMachineDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assemblyState = data["assemblyState"];
            if (data["attachFiles"] && data["attachFiles"].constructor === Array) {
                this.attachFiles = [] as any;
                for (let item of data["attachFiles"])
                    this.attachFiles!.push(item);
            }
            this.avatar = data["avatar"];
            this.code = data["code"];
            this.deliveryTime = data["deliveryTime"];
            this.deviceTypeId = data["deviceTypeId"];
            this.hyperlink = data["hyperlink"];
            this.id = data["id"];
            this.name = data["name"];
            this.serialNo = data["serialNo"];
            this.softwareVersion = data["softwareVersion"];
            this.systemName = data["systemName"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMachineDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMachineDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assemblyState"] = this.assemblyState;
        if (this.attachFiles && this.attachFiles.constructor === Array) {
            data["attachFiles"] = [];
            for (let item of this.attachFiles)
                data["attachFiles"].push(item);
        }
        data["avatar"] = this.avatar;
        data["code"] = this.code;
        data["deliveryTime"] = this.deliveryTime;
        data["deviceTypeId"] = this.deviceTypeId;
        data["hyperlink"] = this.hyperlink;
        data["id"] = this.id;
        data["name"] = this.name;
        data["serialNo"] = this.serialNo;
        data["softwareVersion"] = this.softwareVersion;
        data["systemName"] = this.systemName;
        return data; 
    }
}

export interface ICreateOrUpdateMachineDTO {
    assemblyState: number;
    attachFiles: string[] | undefined;
    avatar: string | undefined;
    code: string;
    deliveryTime: string | undefined;
    deviceTypeId: string;
    hyperlink: string | undefined;
    id: string | undefined;
    name: string;
    serialNo: string;
    softwareVersion: string | undefined;
    systemName: string | undefined;
}

export class CustomMachineCheckDTO implements ICustomMachineCheckDTO {
    /** 客户ID */
    customerId!: string;
    /** 设备序列号 */
    deviceCode!: string;
    /** ID */
    id!: string | undefined;

    constructor(data?: ICustomMachineCheckDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.deviceCode = data["deviceCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CustomMachineCheckDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomMachineCheckDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["deviceCode"] = this.deviceCode;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICustomMachineCheckDTO {
    /** 客户ID */
    customerId: string;
    /** 设备序列号 */
    deviceCode: string;
    /** ID */
    id: string | undefined;
}

export class CustomMachineSelectDTO implements ICustomMachineSelectDTO {
    /** 客户ID */
    customerId!: string;
    /** 关键词 */
    keyWord!: string | undefined;

    constructor(data?: ICustomMachineSelectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.keyWord = data["keyWord"];
        }
    }

    static fromJS(data: any): CustomMachineSelectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomMachineSelectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["keyWord"] = this.keyWord;
        return data; 
    }
}

export interface ICustomMachineSelectDTO {
    /** 客户ID */
    customerId: string;
    /** 关键词 */
    keyWord: string | undefined;
}

export class CustomMachineSubmitDTO implements ICustomMachineSubmitDTO {
    /** 客户ID */
    customerId!: string;
    /** 出厂时间 */
    deliveryTime!: Date | undefined;
    /** 设备序列号 */
    deviceCode!: string;
    /** 设备名称 */
    deviceName!: string;
    /** 设备类型ID */
    deviceTypeId!: string | undefined;
    id!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: ICustomMachineSubmitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.deliveryTime = data["deliveryTime"] ? new Date(data["deliveryTime"].toString()) : <any>undefined;
            this.deviceCode = data["deviceCode"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.id = data["id"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): CustomMachineSubmitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomMachineSubmitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["deliveryTime"] = this.deliveryTime ? this.deliveryTime.toISOString() : <any>undefined;
        data["deviceCode"] = this.deviceCode;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["id"] = this.id;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface ICustomMachineSubmitDTO {
    /** 客户ID */
    customerId: string;
    /** 出厂时间 */
    deliveryTime: Date | undefined;
    /** 设备序列号 */
    deviceCode: string;
    /** 设备名称 */
    deviceName: string;
    /** 设备类型ID */
    deviceTypeId: string | undefined;
    id: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class CustomMachineVO implements ICustomMachineVO {
    /** 客户ID */
    customerId!: string | undefined;
    /** 出厂时间 */
    deliveryTime!: Date | undefined;
    /** 设备序列号不能为空 */
    deviceCode!: string | undefined;
    /** 设备名称不能为空 */
    deviceName!: string | undefined;
    /** 设备序列号 */
    deviceTypeId!: string | undefined;
    id!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: ICustomMachineVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.deliveryTime = data["deliveryTime"] ? new Date(data["deliveryTime"].toString()) : <any>undefined;
            this.deviceCode = data["deviceCode"];
            this.deviceName = data["deviceName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.id = data["id"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): CustomMachineVO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomMachineVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["deliveryTime"] = this.deliveryTime ? this.deliveryTime.toISOString() : <any>undefined;
        data["deviceCode"] = this.deviceCode;
        data["deviceName"] = this.deviceName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["id"] = this.id;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface ICustomMachineVO {
    /** 客户ID */
    customerId: string | undefined;
    /** 出厂时间 */
    deliveryTime: Date | undefined;
    /** 设备序列号不能为空 */
    deviceCode: string | undefined;
    /** 设备名称不能为空 */
    deviceName: string | undefined;
    /** 设备序列号 */
    deviceTypeId: string | undefined;
    id: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class CustomerVO implements ICustomerVO {
    /** 客户ID */
    customerId!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;

    constructor(data?: ICustomerVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
        }
    }

    static fromJS(data: any): CustomerVO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        return data; 
    }
}

export interface ICustomerVO {
    /** 客户ID */
    customerId: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
}

export class CustomerWorkStationRealTimeStatusDTO implements ICustomerWorkStationRealTimeStatusDTO {
    /** 客户ID列表 */
    customerIdList!: string[] | undefined;
    query!: Query | undefined;

    constructor(data?: ICustomerWorkStationRealTimeStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["customerIdList"] && data["customerIdList"].constructor === Array) {
                this.customerIdList = [] as any;
                for (let item of data["customerIdList"])
                    this.customerIdList!.push(item);
            }
            this.query = data["query"] ? Query.fromJS(data["query"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerWorkStationRealTimeStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerWorkStationRealTimeStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.customerIdList && this.customerIdList.constructor === Array) {
            data["customerIdList"] = [];
            for (let item of this.customerIdList)
                data["customerIdList"].push(item);
        }
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICustomerWorkStationRealTimeStatusDTO {
    /** 客户ID列表 */
    customerIdList: string[] | undefined;
    query: Query | undefined;
}

export class CustomerWorkStationRealTimeStatusVO implements ICustomerWorkStationRealTimeStatusVO {
    /** 设备图片 */
    avatar!: string | undefined;
    /** 设备ID */
    id!: string | undefined;
    /** 设备名称 */
    name!: string | undefined;
    /** 设备序列号 */
    serialNo!: string | undefined;
    /** 类型图片 */
    typeAvatar!: string | undefined;
    /** 工况参数 */
    workingConditionSetting!: WorkingConditionSettingVO | undefined;

    constructor(data?: ICustomerWorkStationRealTimeStatusVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.avatar = data["avatar"];
            this.id = data["id"];
            this.name = data["name"];
            this.serialNo = data["serialNo"];
            this.typeAvatar = data["typeAvatar"];
            this.workingConditionSetting = data["workingConditionSetting"] ? WorkingConditionSettingVO.fromJS(data["workingConditionSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerWorkStationRealTimeStatusVO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerWorkStationRealTimeStatusVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatar"] = this.avatar;
        data["id"] = this.id;
        data["name"] = this.name;
        data["serialNo"] = this.serialNo;
        data["typeAvatar"] = this.typeAvatar;
        data["workingConditionSetting"] = this.workingConditionSetting ? this.workingConditionSetting.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICustomerWorkStationRealTimeStatusVO {
    /** 设备图片 */
    avatar: string | undefined;
    /** 设备ID */
    id: string | undefined;
    /** 设备名称 */
    name: string | undefined;
    /** 设备序列号 */
    serialNo: string | undefined;
    /** 类型图片 */
    typeAvatar: string | undefined;
    /** 工况参数 */
    workingConditionSetting: WorkingConditionSettingVO | undefined;
}

export class DeleteMachineListDTO implements IDeleteMachineListDTO {
    idList!: string[] | undefined;

    constructor(data?: IDeleteMachineListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["idList"] && data["idList"].constructor === Array) {
                this.idList = [] as any;
                for (let item of data["idList"])
                    this.idList!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteMachineListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMachineListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.idList && this.idList.constructor === Array) {
            data["idList"] = [];
            for (let item of this.idList)
                data["idList"].push(item);
        }
        return data; 
    }
}

export interface IDeleteMachineListDTO {
    idList: string[] | undefined;
}

export class DeleteMachineListVO implements IDeleteMachineListVO {
    errorMachineList!: string[] | undefined;
    success!: boolean | undefined;
    successIdList!: string[] | undefined;

    constructor(data?: IDeleteMachineListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["errorMachineList"] && data["errorMachineList"].constructor === Array) {
                this.errorMachineList = [] as any;
                for (let item of data["errorMachineList"])
                    this.errorMachineList!.push(item);
            }
            this.success = data["success"];
            if (data["successIdList"] && data["successIdList"].constructor === Array) {
                this.successIdList = [] as any;
                for (let item of data["successIdList"])
                    this.successIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteMachineListVO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMachineListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.errorMachineList && this.errorMachineList.constructor === Array) {
            data["errorMachineList"] = [];
            for (let item of this.errorMachineList)
                data["errorMachineList"].push(item);
        }
        data["success"] = this.success;
        if (this.successIdList && this.successIdList.constructor === Array) {
            data["successIdList"] = [];
            for (let item of this.successIdList)
                data["successIdList"].push(item);
        }
        return data; 
    }
}

export interface IDeleteMachineListVO {
    errorMachineList: string[] | undefined;
    success: boolean | undefined;
    successIdList: string[] | undefined;
}

export class DeviceAddressParameterVo implements IDeviceAddressParameterVo {
    defaultValue!: string | undefined;
    description!: string | undefined;
    name!: string | undefined;
    type!: string | undefined;

    constructor(data?: IDeviceAddressParameterVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultValue = data["defaultValue"];
            this.description = data["description"];
            this.name = data["name"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): DeviceAddressParameterVo {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceAddressParameterVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultValue"] = this.defaultValue;
        data["description"] = this.description;
        data["name"] = this.name;
        data["type"] = this.type;
        return data; 
    }
}

export interface IDeviceAddressParameterVo {
    defaultValue: string | undefined;
    description: string | undefined;
    name: string | undefined;
    type: string | undefined;
}

export class DeviceAddressVo implements IDeviceAddressVo {
    description!: string | undefined;
    /** 名称 */
    name!: string | undefined;
    parameters!: DeviceAddressParameterVo[] | undefined;
    /** 名称 */
    returnType!: string | undefined;

    constructor(data?: IDeviceAddressVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.name = data["name"];
            if (data["parameters"] && data["parameters"].constructor === Array) {
                this.parameters = [] as any;
                for (let item of data["parameters"])
                    this.parameters!.push(DeviceAddressParameterVo.fromJS(item));
            }
            this.returnType = data["returnType"];
        }
    }

    static fromJS(data: any): DeviceAddressVo {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceAddressVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["name"] = this.name;
        if (this.parameters && this.parameters.constructor === Array) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["returnType"] = this.returnType;
        return data; 
    }
}

export interface IDeviceAddressVo {
    description: string | undefined;
    /** 名称 */
    name: string | undefined;
    parameters: DeviceAddressParameterVo[] | undefined;
    /** 名称 */
    returnType: string | undefined;
}

export class DeviceDTO implements IDeviceDTO {
    /** 设备条码 */
    barCode!: string | undefined;
    /** 生产日历编码 */
    calendarCode!: string | undefined;
    /** 设备code */
    code!: string | undefined;
    /** 职权域id */
    deptId!: string | undefined;
    /** 设备类型Id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 工位组id */
    groupId!: string[] | undefined;
    /** 保养负责人id */
    maintainUserId!: string | undefined;
    /** 保养负责人名称 */
    maintainUserName!: string | undefined;
    /** 设备名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 使用日期 */
    serviceDate!: Date | undefined;
    /** 使用寿命 */
    serviceLife!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 等待更新的生产日历code */
    waitingUpdateCalendar!: string | undefined;
    /** 设备Id */
    workStationId!: string | undefined;

    constructor(data?: IDeviceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.barCode = data["barCode"];
            this.calendarCode = data["calendarCode"];
            this.code = data["code"];
            this.deptId = data["deptId"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            if (data["groupId"] && data["groupId"].constructor === Array) {
                this.groupId = [] as any;
                for (let item of data["groupId"])
                    this.groupId!.push(item);
            }
            this.maintainUserId = data["maintainUserId"];
            this.maintainUserName = data["maintainUserName"];
            this.name = data["name"];
            this.remark = data["remark"];
            this.serviceDate = data["serviceDate"] ? new Date(data["serviceDate"].toString()) : <any>undefined;
            this.serviceLife = data["serviceLife"];
            this.standardModel = data["standardModel"];
            this.waitingUpdateCalendar = data["waitingUpdateCalendar"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): DeviceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barCode"] = this.barCode;
        data["calendarCode"] = this.calendarCode;
        data["code"] = this.code;
        data["deptId"] = this.deptId;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        if (this.groupId && this.groupId.constructor === Array) {
            data["groupId"] = [];
            for (let item of this.groupId)
                data["groupId"].push(item);
        }
        data["maintainUserId"] = this.maintainUserId;
        data["maintainUserName"] = this.maintainUserName;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["serviceDate"] = this.serviceDate ? formatDate(this.serviceDate) : <any>undefined;
        data["serviceLife"] = this.serviceLife;
        data["standardModel"] = this.standardModel;
        data["waitingUpdateCalendar"] = this.waitingUpdateCalendar;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IDeviceDTO {
    /** 设备条码 */
    barCode: string | undefined;
    /** 生产日历编码 */
    calendarCode: string | undefined;
    /** 设备code */
    code: string | undefined;
    /** 职权域id */
    deptId: string | undefined;
    /** 设备类型Id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 工位组id */
    groupId: string[] | undefined;
    /** 保养负责人id */
    maintainUserId: string | undefined;
    /** 保养负责人名称 */
    maintainUserName: string | undefined;
    /** 设备名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 使用日期 */
    serviceDate: Date | undefined;
    /** 使用寿命 */
    serviceLife: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 等待更新的生产日历code */
    waitingUpdateCalendar: string | undefined;
    /** 设备Id */
    workStationId: string | undefined;
}

export class DeviceFileDTO implements IDeviceFileDTO {
    /** 文件mini类型 */
    contentType!: string | undefined;
    /** 文件名称 */
    fileName!: string | undefined;
    /** objectKey */
    objectKey!: string | undefined;
    /** 设备Id */
    workStationId!: string | undefined;

    constructor(data?: IDeviceFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
            this.fileName = data["fileName"];
            this.objectKey = data["objectKey"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): DeviceFileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceFileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["fileName"] = this.fileName;
        data["objectKey"] = this.objectKey;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IDeviceFileDTO {
    /** 文件mini类型 */
    contentType: string | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** objectKey */
    objectKey: string | undefined;
    /** 设备Id */
    workStationId: string | undefined;
}

export class DeviceFileInDTO implements IDeviceFileInDTO {
    /** 文件信息 */
    fileDTOList!: FileDTO[] | undefined;
    /** 设备Id */
    workStationId!: string | undefined;

    constructor(data?: IDeviceFileInDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["fileDTOList"] && data["fileDTOList"].constructor === Array) {
                this.fileDTOList = [] as any;
                for (let item of data["fileDTOList"])
                    this.fileDTOList!.push(FileDTO.fromJS(item));
            }
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): DeviceFileInDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceFileInDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.fileDTOList && this.fileDTOList.constructor === Array) {
            data["fileDTOList"] = [];
            for (let item of this.fileDTOList)
                data["fileDTOList"].push(item.toJSON());
        }
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IDeviceFileInDTO {
    /** 文件信息 */
    fileDTOList: FileDTO[] | undefined;
    /** 设备Id */
    workStationId: string | undefined;
}

export class DeviceIdsDTO implements IDeviceIdsDTO {
    ids!: string[] | undefined;

    constructor(data?: IDeviceIdsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [] as any;
                for (let item of data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): DeviceIdsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceIdsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IDeviceIdsDTO {
    ids: string[] | undefined;
}

export class DeviceInDTO implements IDeviceInDTO {
    /** 设备条码 */
    barCode!: string | undefined;
    /** 生产日历编码 */
    calendarCode!: string;
    /** 设备code */
    code!: string;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 职权域id */
    deptId!: string | undefined;
    /** 职权域名称 */
    deptName!: string | undefined;
    /** 设备类型Id */
    deviceTypeId!: string;
    /** 设备类型名称 */
    deviceTypeName!: string;
    /** 文件信息 */
    fileDTOList!: FileDTO[] | undefined;
    /** 工位组id */
    groupId!: string[] | undefined;
    /** 工位组名称 */
    groupNames!: string | undefined;
    /** 保养负责人id */
    maintainUserId!: string | undefined;
    /** 保养负责人名称 */
    maintainUserName!: string | undefined;
    /** 设备名称 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;
    /** 使用日期 */
    serviceDate!: Date | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 等待更新的生产日历code */
    waitingUpdateCalendar!: string | undefined;

    constructor(data?: IDeviceInDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.barCode = data["barCode"];
            this.calendarCode = data["calendarCode"];
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.deptId = data["deptId"];
            this.deptName = data["deptName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            if (data["fileDTOList"] && data["fileDTOList"].constructor === Array) {
                this.fileDTOList = [] as any;
                for (let item of data["fileDTOList"])
                    this.fileDTOList!.push(FileDTO.fromJS(item));
            }
            if (data["groupId"] && data["groupId"].constructor === Array) {
                this.groupId = [] as any;
                for (let item of data["groupId"])
                    this.groupId!.push(item);
            }
            this.groupNames = data["groupNames"];
            this.maintainUserId = data["maintainUserId"];
            this.maintainUserName = data["maintainUserName"];
            this.name = data["name"];
            this.remark = data["remark"];
            this.serviceDate = data["serviceDate"] ? new Date(data["serviceDate"].toString()) : <any>undefined;
            this.standardModel = data["standardModel"];
            this.waitingUpdateCalendar = data["waitingUpdateCalendar"];
        }
    }

    static fromJS(data: any): DeviceInDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceInDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barCode"] = this.barCode;
        data["calendarCode"] = this.calendarCode;
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["deptId"] = this.deptId;
        data["deptName"] = this.deptName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        if (this.fileDTOList && this.fileDTOList.constructor === Array) {
            data["fileDTOList"] = [];
            for (let item of this.fileDTOList)
                data["fileDTOList"].push(item.toJSON());
        }
        if (this.groupId && this.groupId.constructor === Array) {
            data["groupId"] = [];
            for (let item of this.groupId)
                data["groupId"].push(item);
        }
        data["groupNames"] = this.groupNames;
        data["maintainUserId"] = this.maintainUserId;
        data["maintainUserName"] = this.maintainUserName;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["serviceDate"] = this.serviceDate ? formatDate(this.serviceDate) : <any>undefined;
        data["standardModel"] = this.standardModel;
        data["waitingUpdateCalendar"] = this.waitingUpdateCalendar;
        return data; 
    }
}

export interface IDeviceInDTO {
    /** 设备条码 */
    barCode: string | undefined;
    /** 生产日历编码 */
    calendarCode: string;
    /** 设备code */
    code: string;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 职权域id */
    deptId: string | undefined;
    /** 职权域名称 */
    deptName: string | undefined;
    /** 设备类型Id */
    deviceTypeId: string;
    /** 设备类型名称 */
    deviceTypeName: string;
    /** 文件信息 */
    fileDTOList: FileDTO[] | undefined;
    /** 工位组id */
    groupId: string[] | undefined;
    /** 工位组名称 */
    groupNames: string | undefined;
    /** 保养负责人id */
    maintainUserId: string | undefined;
    /** 保养负责人名称 */
    maintainUserName: string | undefined;
    /** 设备名称 */
    name: string;
    /** 备注 */
    remark: string | undefined;
    /** 使用日期 */
    serviceDate: Date | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 等待更新的生产日历code */
    waitingUpdateCalendar: string | undefined;
}

export class DevicePageDTO implements IDevicePageDTO {
    /** 设备类型id] */
    deviceTypeId!: string | undefined;
    /** 过滤器[工位编号/名称] */
    filter!: string | undefined;
    /** 租户Id */
    tenantId!: string | undefined;

    constructor(data?: IDevicePageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceTypeId = data["deviceTypeId"];
            this.filter = data["filter"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): DevicePageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DevicePageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceTypeId"] = this.deviceTypeId;
        data["filter"] = this.filter;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IDevicePageDTO {
    /** 设备类型id] */
    deviceTypeId: string | undefined;
    /** 过滤器[工位编号/名称] */
    filter: string | undefined;
    /** 租户Id */
    tenantId: string | undefined;
}

/** 设备信息 */
export class DevicePageVO implements IDevicePageVO {
    /** 设备条码 */
    barCode!: string | undefined;
    /** 设备编码 */
    code!: string | undefined;
    /** 设备类型id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 上次点检时间 */
    lastCheckTime!: Date | undefined;
    /** 上次保养时间 */
    lastMaintainTime!: Date | undefined;
    /** 上次维修时间 */
    lastRepairTime!: Date | undefined;
    /** 保养状态 */
    maintainStatus!: number | undefined;
    /** 设备名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 维修状态 */
    repairStatus!: number | undefined;
    /** 使用日期 */
    serviceDate!: Date | undefined;
    /** 使用寿命 */
    serviceLife!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;

    constructor(data?: IDevicePageVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.barCode = data["barCode"];
            this.code = data["code"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.id = data["id"];
            this.lastCheckTime = data["lastCheckTime"] ? new Date(data["lastCheckTime"].toString()) : <any>undefined;
            this.lastMaintainTime = data["lastMaintainTime"] ? new Date(data["lastMaintainTime"].toString()) : <any>undefined;
            this.lastRepairTime = data["lastRepairTime"] ? new Date(data["lastRepairTime"].toString()) : <any>undefined;
            this.maintainStatus = data["maintainStatus"];
            this.name = data["name"];
            this.remark = data["remark"];
            this.repairStatus = data["repairStatus"];
            this.serviceDate = data["serviceDate"] ? new Date(data["serviceDate"].toString()) : <any>undefined;
            this.serviceLife = data["serviceLife"];
            this.standardModel = data["standardModel"];
        }
    }

    static fromJS(data: any): DevicePageVO {
        data = typeof data === 'object' ? data : {};
        let result = new DevicePageVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barCode"] = this.barCode;
        data["code"] = this.code;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["id"] = this.id;
        data["lastCheckTime"] = this.lastCheckTime ? this.lastCheckTime.toISOString() : <any>undefined;
        data["lastMaintainTime"] = this.lastMaintainTime ? this.lastMaintainTime.toISOString() : <any>undefined;
        data["lastRepairTime"] = this.lastRepairTime ? this.lastRepairTime.toISOString() : <any>undefined;
        data["maintainStatus"] = this.maintainStatus;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["repairStatus"] = this.repairStatus;
        data["serviceDate"] = this.serviceDate ? formatDate(this.serviceDate) : <any>undefined;
        data["serviceLife"] = this.serviceLife;
        data["standardModel"] = this.standardModel;
        return data; 
    }
}

/** 设备信息 */
export interface IDevicePageVO {
    /** 设备条码 */
    barCode: string | undefined;
    /** 设备编码 */
    code: string | undefined;
    /** 设备类型id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** id */
    id: string | undefined;
    /** 上次点检时间 */
    lastCheckTime: Date | undefined;
    /** 上次保养时间 */
    lastMaintainTime: Date | undefined;
    /** 上次维修时间 */
    lastRepairTime: Date | undefined;
    /** 保养状态 */
    maintainStatus: number | undefined;
    /** 设备名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 维修状态 */
    repairStatus: number | undefined;
    /** 使用日期 */
    serviceDate: Date | undefined;
    /** 使用寿命 */
    serviceLife: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
}

export class DeviceSimpleVO implements IDeviceSimpleVO {
    code!: string | undefined;
    deviceTypeId!: string | undefined;
    deviceTypeName!: string | undefined;
    name!: string | undefined;
    serviceDate!: Date | undefined;
    standardModel!: string | undefined;
    workStationId!: string | undefined;

    constructor(data?: IDeviceSimpleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.name = data["name"];
            this.serviceDate = data["serviceDate"] ? new Date(data["serviceDate"].toString()) : <any>undefined;
            this.standardModel = data["standardModel"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): DeviceSimpleVO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSimpleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["name"] = this.name;
        data["serviceDate"] = this.serviceDate ? formatDate(this.serviceDate) : <any>undefined;
        data["standardModel"] = this.standardModel;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IDeviceSimpleVO {
    code: string | undefined;
    deviceTypeId: string | undefined;
    deviceTypeName: string | undefined;
    name: string | undefined;
    serviceDate: Date | undefined;
    standardModel: string | undefined;
    workStationId: string | undefined;
}

export class DeviceStandardSettingDTO implements IDeviceStandardSettingDTO {
    /** 颜色 */
    colour!: string | undefined;
    /** 产品编码 */
    productCode!: string | undefined;
    /** 产品信息 */
    productInfo!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型id */
    productTypeId!: string | undefined;
    /** 产品类型名称 */
    productTypeName!: string | undefined;
    /** 程序号 */
    programName!: string | undefined;
    /** 班次产能 */
    shiftCapacity!: string | undefined;
    /** 标准产能(日) */
    standardCapacityDay!: string | undefined;
    /** 标准产能(月) */
    standardCapacityMonth!: string | undefined;
    /** 标准产能(周) */
    standardCapacityWeek!: string | undefined;
    /** 标准月) */
    standardMonth!: number | undefined;
    /** 标准用时 */
    standardTime!: string | undefined;
    /** 标准周 */
    standardWeek!: number | undefined;
    /** 工位id */
    workStationId!: string | undefined;

    constructor(data?: IDeviceStandardSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.colour = data["colour"];
            this.productCode = data["productCode"];
            this.productInfo = data["productInfo"];
            this.productName = data["productName"];
            this.productTypeId = data["productTypeId"];
            this.productTypeName = data["productTypeName"];
            this.programName = data["programName"];
            this.shiftCapacity = data["shiftCapacity"];
            this.standardCapacityDay = data["standardCapacityDay"];
            this.standardCapacityMonth = data["standardCapacityMonth"];
            this.standardCapacityWeek = data["standardCapacityWeek"];
            this.standardMonth = data["standardMonth"];
            this.standardTime = data["standardTime"];
            this.standardWeek = data["standardWeek"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): DeviceStandardSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceStandardSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colour"] = this.colour;
        data["productCode"] = this.productCode;
        data["productInfo"] = this.productInfo;
        data["productName"] = this.productName;
        data["productTypeId"] = this.productTypeId;
        data["productTypeName"] = this.productTypeName;
        data["programName"] = this.programName;
        data["shiftCapacity"] = this.shiftCapacity;
        data["standardCapacityDay"] = this.standardCapacityDay;
        data["standardCapacityMonth"] = this.standardCapacityMonth;
        data["standardCapacityWeek"] = this.standardCapacityWeek;
        data["standardMonth"] = this.standardMonth;
        data["standardTime"] = this.standardTime;
        data["standardWeek"] = this.standardWeek;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IDeviceStandardSettingDTO {
    /** 颜色 */
    colour: string | undefined;
    /** 产品编码 */
    productCode: string | undefined;
    /** 产品信息 */
    productInfo: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型id */
    productTypeId: string | undefined;
    /** 产品类型名称 */
    productTypeName: string | undefined;
    /** 程序号 */
    programName: string | undefined;
    /** 班次产能 */
    shiftCapacity: string | undefined;
    /** 标准产能(日) */
    standardCapacityDay: string | undefined;
    /** 标准产能(月) */
    standardCapacityMonth: string | undefined;
    /** 标准产能(周) */
    standardCapacityWeek: string | undefined;
    /** 标准月) */
    standardMonth: number | undefined;
    /** 标准用时 */
    standardTime: string | undefined;
    /** 标准周 */
    standardWeek: number | undefined;
    /** 工位id */
    workStationId: string | undefined;
}

export class DeviceStandardSettingUpdateDTO implements IDeviceStandardSettingUpdateDTO {
    /** 颜色 */
    colour!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 产品编码 */
    productCode!: string | undefined;
    /** 产品信息 */
    productInfo!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型id */
    productTypeId!: string | undefined;
    /** 产品类型名称 */
    productTypeName!: string | undefined;
    /** 程序号 */
    programName!: string | undefined;
    /** 班次产能 */
    shiftCapacity!: string | undefined;
    /** 标准产能(日) */
    standardCapacityDay!: string | undefined;
    /** 标准产能(月) */
    standardCapacityMonth!: string | undefined;
    /** 标准产能(周) */
    standardCapacityWeek!: string | undefined;
    /** 标准月) */
    standardMonth!: number | undefined;
    /** 标准用时 */
    standardTime!: string | undefined;
    /** 标准周 */
    standardWeek!: number | undefined;
    /** 工位id */
    workStationId!: string | undefined;

    constructor(data?: IDeviceStandardSettingUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.colour = data["colour"];
            this.id = data["id"];
            this.productCode = data["productCode"];
            this.productInfo = data["productInfo"];
            this.productName = data["productName"];
            this.productTypeId = data["productTypeId"];
            this.productTypeName = data["productTypeName"];
            this.programName = data["programName"];
            this.shiftCapacity = data["shiftCapacity"];
            this.standardCapacityDay = data["standardCapacityDay"];
            this.standardCapacityMonth = data["standardCapacityMonth"];
            this.standardCapacityWeek = data["standardCapacityWeek"];
            this.standardMonth = data["standardMonth"];
            this.standardTime = data["standardTime"];
            this.standardWeek = data["standardWeek"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): DeviceStandardSettingUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceStandardSettingUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colour"] = this.colour;
        data["id"] = this.id;
        data["productCode"] = this.productCode;
        data["productInfo"] = this.productInfo;
        data["productName"] = this.productName;
        data["productTypeId"] = this.productTypeId;
        data["productTypeName"] = this.productTypeName;
        data["programName"] = this.programName;
        data["shiftCapacity"] = this.shiftCapacity;
        data["standardCapacityDay"] = this.standardCapacityDay;
        data["standardCapacityMonth"] = this.standardCapacityMonth;
        data["standardCapacityWeek"] = this.standardCapacityWeek;
        data["standardMonth"] = this.standardMonth;
        data["standardTime"] = this.standardTime;
        data["standardWeek"] = this.standardWeek;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IDeviceStandardSettingUpdateDTO {
    /** 颜色 */
    colour: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 产品编码 */
    productCode: string | undefined;
    /** 产品信息 */
    productInfo: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型id */
    productTypeId: string | undefined;
    /** 产品类型名称 */
    productTypeName: string | undefined;
    /** 程序号 */
    programName: string | undefined;
    /** 班次产能 */
    shiftCapacity: string | undefined;
    /** 标准产能(日) */
    standardCapacityDay: string | undefined;
    /** 标准产能(月) */
    standardCapacityMonth: string | undefined;
    /** 标准产能(周) */
    standardCapacityWeek: string | undefined;
    /** 标准月) */
    standardMonth: number | undefined;
    /** 标准用时 */
    standardTime: string | undefined;
    /** 标准周 */
    standardWeek: number | undefined;
    /** 工位id */
    workStationId: string | undefined;
}

export class DeviceStandardSettingVO implements IDeviceStandardSettingVO {
    /** 颜色 */
    colour!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 产品编码 */
    productCode!: string | undefined;
    /** 产品信息 */
    productInfo!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型id */
    productTypeId!: string | undefined;
    /** 产品类型名称 */
    productTypeName!: string | undefined;
    /** 程序号 */
    programName!: string | undefined;
    /** 班次产能 */
    shiftCapacity!: string | undefined;
    /** 标准产能(日) */
    standardCapacityDay!: string | undefined;
    /** 标准产能(月) */
    standardCapacityMonth!: string | undefined;
    /** 标准产能(周) */
    standardCapacityWeek!: string | undefined;
    /** 标准月) */
    standardMonth!: number | undefined;
    /** 标准用时 */
    standardTime!: string | undefined;
    /** 标准周 */
    standardWeek!: number | undefined;
    /** 工位id */
    workStationId!: string | undefined;

    constructor(data?: IDeviceStandardSettingVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.colour = data["colour"];
            this.id = data["id"];
            this.productCode = data["productCode"];
            this.productInfo = data["productInfo"];
            this.productName = data["productName"];
            this.productTypeId = data["productTypeId"];
            this.productTypeName = data["productTypeName"];
            this.programName = data["programName"];
            this.shiftCapacity = data["shiftCapacity"];
            this.standardCapacityDay = data["standardCapacityDay"];
            this.standardCapacityMonth = data["standardCapacityMonth"];
            this.standardCapacityWeek = data["standardCapacityWeek"];
            this.standardMonth = data["standardMonth"];
            this.standardTime = data["standardTime"];
            this.standardWeek = data["standardWeek"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): DeviceStandardSettingVO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceStandardSettingVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colour"] = this.colour;
        data["id"] = this.id;
        data["productCode"] = this.productCode;
        data["productInfo"] = this.productInfo;
        data["productName"] = this.productName;
        data["productTypeId"] = this.productTypeId;
        data["productTypeName"] = this.productTypeName;
        data["programName"] = this.programName;
        data["shiftCapacity"] = this.shiftCapacity;
        data["standardCapacityDay"] = this.standardCapacityDay;
        data["standardCapacityMonth"] = this.standardCapacityMonth;
        data["standardCapacityWeek"] = this.standardCapacityWeek;
        data["standardMonth"] = this.standardMonth;
        data["standardTime"] = this.standardTime;
        data["standardWeek"] = this.standardWeek;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IDeviceStandardSettingVO {
    /** 颜色 */
    colour: string | undefined;
    /** id */
    id: string | undefined;
    /** 产品编码 */
    productCode: string | undefined;
    /** 产品信息 */
    productInfo: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型id */
    productTypeId: string | undefined;
    /** 产品类型名称 */
    productTypeName: string | undefined;
    /** 程序号 */
    programName: string | undefined;
    /** 班次产能 */
    shiftCapacity: string | undefined;
    /** 标准产能(日) */
    standardCapacityDay: string | undefined;
    /** 标准产能(月) */
    standardCapacityMonth: string | undefined;
    /** 标准产能(周) */
    standardCapacityWeek: string | undefined;
    /** 标准月) */
    standardMonth: number | undefined;
    /** 标准用时 */
    standardTime: string | undefined;
    /** 标准周 */
    standardWeek: number | undefined;
    /** 工位id */
    workStationId: string | undefined;
}

/** 新增设备类型信息 */
export class DeviceTypeDTO implements IDeviceTypeDTO {
    /** 类型编码 */
    code!: string | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 类型名称 */
    name!: string;
    /** 图片 */
    photoUrl!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IDeviceTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.name = data["name"];
            this.photoUrl = data["photoUrl"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): DeviceTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["name"] = this.name;
        data["photoUrl"] = this.photoUrl;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 新增设备类型信息 */
export interface IDeviceTypeDTO {
    /** 类型编码 */
    code: string | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 类型名称 */
    name: string;
    /** 图片 */
    photoUrl: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class DeviceTypeExcelDTO implements IDeviceTypeExcelDTO {
    ids!: string[] | undefined;

    constructor(data?: IDeviceTypeExcelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [] as any;
                for (let item of data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): DeviceTypeExcelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceTypeExcelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IDeviceTypeExcelDTO {
    ids: string[] | undefined;
}

/** 设备类型分页查询信息 */
export class DeviceTypePageDTO implements IDeviceTypePageDTO {
    /** 关键词 */
    keyWord!: string | undefined;
    /** 分页信息 */
    query!: Query | undefined;

    constructor(data?: IDeviceTypePageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.keyWord = data["keyWord"];
            this.query = data["query"] ? Query.fromJS(data["query"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceTypePageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceTypePageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyWord"] = this.keyWord;
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        return data; 
    }
}

/** 设备类型分页查询信息 */
export interface IDeviceTypePageDTO {
    /** 关键词 */
    keyWord: string | undefined;
    /** 分页信息 */
    query: Query | undefined;
}

/** 更新设备类型信息 */
export class DeviceTypeUpdateDTO implements IDeviceTypeUpdateDTO {
    /** 主键id */
    id!: string;
    /** 类型名称 */
    name!: string;
    /** 图片 */
    photoUrl!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IDeviceTypeUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.photoUrl = data["photoUrl"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): DeviceTypeUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceTypeUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["photoUrl"] = this.photoUrl;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 更新设备类型信息 */
export interface IDeviceTypeUpdateDTO {
    /** 主键id */
    id: string;
    /** 类型名称 */
    name: string;
    /** 图片 */
    photoUrl: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

/** 设备类型信息 */
export class DeviceTypeVO implements IDeviceTypeVO {
    /** 类型编码 */
    code!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 类型名称 */
    name!: string | undefined;
    /** 图片 */
    photoUrl!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IDeviceTypeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.photoUrl = data["photoUrl"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): DeviceTypeVO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceTypeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["photoUrl"] = this.photoUrl;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 设备类型信息 */
export interface IDeviceTypeVO {
    /** 类型编码 */
    code: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 类型名称 */
    name: string | undefined;
    /** 图片 */
    photoUrl: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class DeviceUpdateDTO implements IDeviceUpdateDTO {
    /** 工位日历 */
    calendarCode!: string;
    /** 职权域id */
    deptId!: string | undefined;
    /** 设备类型Id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 工位组id */
    groupId!: string[] | undefined;
    /** 保养负责人id */
    maintainUserId!: string | undefined;
    /** 保养负责人名称 */
    maintainUserName!: string | undefined;
    /** 设备名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 使用日期 */
    serviceDate!: Date | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 工位Id */
    workStationId!: string;

    constructor(data?: IDeviceUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calendarCode = data["calendarCode"];
            this.deptId = data["deptId"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            if (data["groupId"] && data["groupId"].constructor === Array) {
                this.groupId = [] as any;
                for (let item of data["groupId"])
                    this.groupId!.push(item);
            }
            this.maintainUserId = data["maintainUserId"];
            this.maintainUserName = data["maintainUserName"];
            this.name = data["name"];
            this.remark = data["remark"];
            this.serviceDate = data["serviceDate"] ? new Date(data["serviceDate"].toString()) : <any>undefined;
            this.standardModel = data["standardModel"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): DeviceUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarCode"] = this.calendarCode;
        data["deptId"] = this.deptId;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        if (this.groupId && this.groupId.constructor === Array) {
            data["groupId"] = [];
            for (let item of this.groupId)
                data["groupId"].push(item);
        }
        data["maintainUserId"] = this.maintainUserId;
        data["maintainUserName"] = this.maintainUserName;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["serviceDate"] = this.serviceDate ? formatDate(this.serviceDate) : <any>undefined;
        data["standardModel"] = this.standardModel;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IDeviceUpdateDTO {
    /** 工位日历 */
    calendarCode: string;
    /** 职权域id */
    deptId: string | undefined;
    /** 设备类型Id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 工位组id */
    groupId: string[] | undefined;
    /** 保养负责人id */
    maintainUserId: string | undefined;
    /** 保养负责人名称 */
    maintainUserName: string | undefined;
    /** 设备名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 使用日期 */
    serviceDate: Date | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 工位Id */
    workStationId: string;
}

export class EditorConditionStatusDTO implements IEditorConditionStatusDTO {
    /** 工况参数设定列表 */
    list!: WorkConditionSettingVO[] | undefined;

    constructor(data?: IEditorConditionStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(WorkConditionSettingVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditorConditionStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EditorConditionStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEditorConditionStatusDTO {
    /** 工况参数设定列表 */
    list: WorkConditionSettingVO[] | undefined;
}

export class ExtendFieldDTO implements IExtendFieldDTO {
    mark!: string | undefined;
    tag!: string | undefined;
    unit!: string | undefined;

    constructor(data?: IExtendFieldDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mark = data["mark"];
            this.tag = data["tag"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): ExtendFieldDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendFieldDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mark"] = this.mark;
        data["tag"] = this.tag;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IExtendFieldDTO {
    mark: string | undefined;
    tag: string | undefined;
    unit: string | undefined;
}

export class ExtendFieldVo implements IExtendFieldVo {
    mark!: string | undefined;
    tag!: string | undefined;
    unit!: string | undefined;

    constructor(data?: IExtendFieldVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mark = data["mark"];
            this.tag = data["tag"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): ExtendFieldVo {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendFieldVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mark"] = this.mark;
        data["tag"] = this.tag;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IExtendFieldVo {
    mark: string | undefined;
    tag: string | undefined;
    unit: string | undefined;
}

export class FileDTO implements IFileDTO {
    /** 文件mini类型 */
    contentType!: string | undefined;
    /** 文件名称 */
    fileName!: string | undefined;
    /** objectKey */
    objectKey!: string | undefined;

    constructor(data?: IFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
            this.fileName = data["fileName"];
            this.objectKey = data["objectKey"];
        }
    }

    static fromJS(data: any): FileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["fileName"] = this.fileName;
        data["objectKey"] = this.objectKey;
        return data; 
    }
}

export interface IFileDTO {
    /** 文件mini类型 */
    contentType: string | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** objectKey */
    objectKey: string | undefined;
}

export class GatewayAppAddDTO implements IGatewayAppAddDTO {
    /** 网关ID */
    gatewayId!: string | undefined;
    /** 驱动 */
    gatewayTypeName!: string | undefined;
    /** 应用名称 */
    name!: string | undefined;

    constructor(data?: IGatewayAppAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayId = data["gatewayId"];
            this.gatewayTypeName = data["gatewayTypeName"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayAppAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayAppAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayId"] = this.gatewayId;
        data["gatewayTypeName"] = this.gatewayTypeName;
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayAppAddDTO {
    /** 网关ID */
    gatewayId: string | undefined;
    /** 驱动 */
    gatewayTypeName: string | undefined;
    /** 应用名称 */
    name: string | undefined;
}

export class GatewayAppParamterSetValueDTO implements IGatewayAppParamterSetValueDTO {
    /** 网关ID */
    gatewayAppId!: string | undefined;
    /** 属性名称 */
    name!: string | undefined;
    /** 属性名称 */
    value!: string | undefined;

    constructor(data?: IGatewayAppParamterSetValueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayAppId = data["gatewayAppId"];
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): GatewayAppParamterSetValueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayAppParamterSetValueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayAppId"] = this.gatewayAppId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface IGatewayAppParamterSetValueDTO {
    /** 网关ID */
    gatewayAppId: string | undefined;
    /** 属性名称 */
    name: string | undefined;
    /** 属性名称 */
    value: string | undefined;
}

export class GatewayAppSwitchingTypeDTO implements IGatewayAppSwitchingTypeDTO {
    /** 网关应用Id */
    gatewayAppId!: string | undefined;
    /** 网关Id */
    gatewayId!: string | undefined;
    /** 应用名称 */
    typeName!: string | undefined;

    constructor(data?: IGatewayAppSwitchingTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayAppId = data["gatewayAppId"];
            this.gatewayId = data["gatewayId"];
            this.typeName = data["typeName"];
        }
    }

    static fromJS(data: any): GatewayAppSwitchingTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayAppSwitchingTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayAppId"] = this.gatewayAppId;
        data["gatewayId"] = this.gatewayId;
        data["typeName"] = this.typeName;
        return data; 
    }
}

export interface IGatewayAppSwitchingTypeDTO {
    /** 网关应用Id */
    gatewayAppId: string | undefined;
    /** 网关Id */
    gatewayId: string | undefined;
    /** 应用名称 */
    typeName: string | undefined;
}

export class GatewayAppUpdateDTO implements IGatewayAppUpdateDTO {
    /** 网关应用ID */
    gatewayAppId!: string | undefined;
    /** 网关应用名称 */
    name!: string | undefined;

    constructor(data?: IGatewayAppUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayAppId = data["gatewayAppId"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayAppUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayAppUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayAppId"] = this.gatewayAppId;
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayAppUpdateDTO {
    /** 网关应用ID */
    gatewayAppId: string | undefined;
    /** 网关应用名称 */
    name: string | undefined;
}

export class GatewayBindInfoDto implements IGatewayBindInfoDto {
    /** 创建时间 */
    bindDatetime!: Date | undefined;
    customerAddress!: string | undefined;
    customerId!: string | undefined;
    customerName!: string | undefined;
    gatewayCode!: string | undefined;
    gatewayId!: string | undefined;
    workStationCode!: string | undefined;
    workStationId!: string | undefined;
    workStationName!: string | undefined;

    constructor(data?: IGatewayBindInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bindDatetime = data["bindDatetime"] ? new Date(data["bindDatetime"].toString()) : <any>undefined;
            this.customerAddress = data["customerAddress"];
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
            this.gatewayCode = data["gatewayCode"];
            this.gatewayId = data["gatewayId"];
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): GatewayBindInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayBindInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bindDatetime"] = this.bindDatetime ? this.bindDatetime.toISOString() : <any>undefined;
        data["customerAddress"] = this.customerAddress;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["gatewayCode"] = this.gatewayCode;
        data["gatewayId"] = this.gatewayId;
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IGatewayBindInfoDto {
    /** 创建时间 */
    bindDatetime: Date | undefined;
    customerAddress: string | undefined;
    customerId: string | undefined;
    customerName: string | undefined;
    gatewayCode: string | undefined;
    gatewayId: string | undefined;
    workStationCode: string | undefined;
    workStationId: string | undefined;
    workStationName: string | undefined;
}

export class GatewayDeviceVO implements IGatewayDeviceVO {
    /** 网关设备SN */
    gatewayToken!: string | undefined;
    /** 是否在线 */
    isOnline!: boolean | undefined;
    /** 工位名称 */
    name!: string | undefined;

    constructor(data?: IGatewayDeviceVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayToken = data["gatewayToken"];
            this.isOnline = data["isOnline"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayDeviceVO {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayDeviceVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayToken"] = this.gatewayToken;
        data["isOnline"] = this.isOnline;
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayDeviceVO {
    /** 网关设备SN */
    gatewayToken: string | undefined;
    /** 是否在线 */
    isOnline: boolean | undefined;
    /** 工位名称 */
    name: string | undefined;
}

export class GatewayExportDTO implements IGatewayExportDTO {
    /** 批次号 */
    batchCode!: string | undefined;
    /** 关键词 */
    filter!: string | undefined;
    /** 是否已绑定工位 */
    hasWorkStation!: boolean | undefined;
    /** 选中数据集合 */
    idList!: string[] | undefined;
    /** 是否在线 */
    isOnline!: boolean | undefined;
    /** 租户code */
    tenantId!: string | undefined;
    /** 过滤条件:workStationId */
    workStationIdPattern!: string | undefined;

    constructor(data?: IGatewayExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.batchCode = data["batchCode"];
            this.filter = data["filter"];
            this.hasWorkStation = data["hasWorkStation"];
            if (data["idList"] && data["idList"].constructor === Array) {
                this.idList = [] as any;
                for (let item of data["idList"])
                    this.idList!.push(item);
            }
            this.isOnline = data["isOnline"];
            this.tenantId = data["tenantId"];
            this.workStationIdPattern = data["workStationIdPattern"];
        }
    }

    static fromJS(data: any): GatewayExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchCode"] = this.batchCode;
        data["filter"] = this.filter;
        data["hasWorkStation"] = this.hasWorkStation;
        if (this.idList && this.idList.constructor === Array) {
            data["idList"] = [];
            for (let item of this.idList)
                data["idList"].push(item);
        }
        data["isOnline"] = this.isOnline;
        data["tenantId"] = this.tenantId;
        data["workStationIdPattern"] = this.workStationIdPattern;
        return data; 
    }
}

export interface IGatewayExportDTO {
    /** 批次号 */
    batchCode: string | undefined;
    /** 关键词 */
    filter: string | undefined;
    /** 是否已绑定工位 */
    hasWorkStation: boolean | undefined;
    /** 选中数据集合 */
    idList: string[] | undefined;
    /** 是否在线 */
    isOnline: boolean | undefined;
    /** 租户code */
    tenantId: string | undefined;
    /** 过滤条件:workStationId */
    workStationIdPattern: string | undefined;
}

export class GatewayFilterDefinition implements IGatewayFilterDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayFilterDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayFilterDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayFilterDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayFilterDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class GatewayMethodVO implements IGatewayMethodVO {
    methodId!: number | undefined;
    methodName!: string | undefined;

    constructor(data?: IGatewayMethodVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.methodId = data["methodId"];
            this.methodName = data["methodName"];
        }
    }

    static fromJS(data: any): GatewayMethodVO {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayMethodVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["methodId"] = this.methodId;
        data["methodName"] = this.methodName;
        return data; 
    }
}

export interface IGatewayMethodVO {
    methodId: number | undefined;
    methodName: string | undefined;
}

export class GatewayParamterSetValueDTO implements IGatewayParamterSetValueDTO {
    /** 网关ID */
    gatewayId!: string | undefined;
    /** 属性名称 */
    name!: string | undefined;
    /** 属性名称 */
    value!: string | undefined;

    constructor(data?: IGatewayParamterSetValueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayId = data["gatewayId"];
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): GatewayParamterSetValueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayParamterSetValueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayId"] = this.gatewayId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface IGatewayParamterSetValueDTO {
    /** 网关ID */
    gatewayId: string | undefined;
    /** 属性名称 */
    name: string | undefined;
    /** 属性名称 */
    value: string | undefined;
}

export class GatewayPredicateDefinition implements IGatewayPredicateDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayPredicateDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayPredicateDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPredicateDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayPredicateDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class GetMachineListDTO implements IGetMachineListDTO {
    /** 区域 */
    areaNameList!: string[] | undefined;
    /** 升序 */
    asc!: boolean | undefined;
    /** 机床状态 */
    assemblyState!: number | undefined;
    /** 创建日期--结束 */
    createTimeEnd!: Date | undefined;
    /** 创建日期--开始 */
    createTimeStart!: Date | undefined;
    customerId!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** 设备类型Id */
    deviceTypeId!: string | undefined;
    /** 设备状态,1:在线,0:离线 */
    iotState!: number | undefined;
    isAssigned!: boolean | undefined;
    /** 机床关键字 */
    keywords!: string | undefined;
    /** 机床名称 */
    machineName!: string | undefined;
    /** 排序规则 */
    sortRuleType!: number | undefined;

    constructor(data?: IGetMachineListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["areaNameList"] && data["areaNameList"].constructor === Array) {
                this.areaNameList = [] as any;
                for (let item of data["areaNameList"])
                    this.areaNameList!.push(item);
            }
            this.asc = data["asc"];
            this.assemblyState = data["assemblyState"];
            this.createTimeEnd = data["createTimeEnd"] ? new Date(data["createTimeEnd"].toString()) : <any>undefined;
            this.createTimeStart = data["createTimeStart"] ? new Date(data["createTimeStart"].toString()) : <any>undefined;
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.iotState = data["iotState"];
            this.isAssigned = data["isAssigned"];
            this.keywords = data["keywords"];
            this.machineName = data["machineName"];
            this.sortRuleType = data["sortRuleType"];
        }
    }

    static fromJS(data: any): GetMachineListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetMachineListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.areaNameList && this.areaNameList.constructor === Array) {
            data["areaNameList"] = [];
            for (let item of this.areaNameList)
                data["areaNameList"].push(item);
        }
        data["asc"] = this.asc;
        data["assemblyState"] = this.assemblyState;
        data["createTimeEnd"] = this.createTimeEnd ? this.createTimeEnd.toISOString() : <any>undefined;
        data["createTimeStart"] = this.createTimeStart ? this.createTimeStart.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["iotState"] = this.iotState;
        data["isAssigned"] = this.isAssigned;
        data["keywords"] = this.keywords;
        data["machineName"] = this.machineName;
        data["sortRuleType"] = this.sortRuleType;
        return data; 
    }
}

export interface IGetMachineListDTO {
    /** 区域 */
    areaNameList: string[] | undefined;
    /** 升序 */
    asc: boolean | undefined;
    /** 机床状态 */
    assemblyState: number | undefined;
    /** 创建日期--结束 */
    createTimeEnd: Date | undefined;
    /** 创建日期--开始 */
    createTimeStart: Date | undefined;
    customerId: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** 设备类型Id */
    deviceTypeId: string | undefined;
    /** 设备状态,1:在线,0:离线 */
    iotState: number | undefined;
    isAssigned: boolean | undefined;
    /** 机床关键字 */
    keywords: string | undefined;
    /** 机床名称 */
    machineName: string | undefined;
    /** 排序规则 */
    sortRuleType: number | undefined;
}

export class GetMachineListVO implements IGetMachineListVO {
    avatar!: string | undefined;
    code!: string | undefined;
    customerId!: string | undefined;
    customerName!: string | undefined;
    deliveryTime!: Date | undefined;
    id!: string | undefined;
    isShared!: boolean | undefined;
    name!: string | undefined;
    serialNo!: string | undefined;
    typeAvatar!: string | undefined;

    constructor(data?: IGetMachineListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.avatar = data["avatar"];
            this.code = data["code"];
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
            this.deliveryTime = data["deliveryTime"] ? new Date(data["deliveryTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.isShared = data["isShared"];
            this.name = data["name"];
            this.serialNo = data["serialNo"];
            this.typeAvatar = data["typeAvatar"];
        }
    }

    static fromJS(data: any): GetMachineListVO {
        data = typeof data === 'object' ? data : {};
        let result = new GetMachineListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatar"] = this.avatar;
        data["code"] = this.code;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["deliveryTime"] = this.deliveryTime ? this.deliveryTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["isShared"] = this.isShared;
        data["name"] = this.name;
        data["serialNo"] = this.serialNo;
        data["typeAvatar"] = this.typeAvatar;
        return data; 
    }
}

export interface IGetMachineListVO {
    avatar: string | undefined;
    code: string | undefined;
    customerId: string | undefined;
    customerName: string | undefined;
    deliveryTime: Date | undefined;
    id: string | undefined;
    isShared: boolean | undefined;
    name: string | undefined;
    serialNo: string | undefined;
    typeAvatar: string | undefined;
}

export class IPageOfCustomMachineVO implements IIPageOfCustomMachineVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: CustomMachineVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfCustomMachineVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(CustomMachineVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfCustomMachineVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfCustomMachineVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfCustomMachineVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: CustomMachineVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfCustomerWorkStationRealTimeStatusVO implements IIPageOfCustomerWorkStationRealTimeStatusVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: CustomerWorkStationRealTimeStatusVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfCustomerWorkStationRealTimeStatusVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(CustomerWorkStationRealTimeStatusVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfCustomerWorkStationRealTimeStatusVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfCustomerWorkStationRealTimeStatusVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfCustomerWorkStationRealTimeStatusVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: CustomerWorkStationRealTimeStatusVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfDeviceTypeVO implements IIPageOfDeviceTypeVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: DeviceTypeVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfDeviceTypeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(DeviceTypeVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfDeviceTypeVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfDeviceTypeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfDeviceTypeVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: DeviceTypeVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfProcessBO implements IIPageOfProcessBO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ProcessBO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfProcessBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ProcessBO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfProcessBO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfProcessBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfProcessBO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ProcessBO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfWorkStationGroupVO implements IIPageOfWorkStationGroupVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: WorkStationGroupVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfWorkStationGroupVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(WorkStationGroupVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfWorkStationGroupVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfWorkStationGroupVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfWorkStationGroupVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: WorkStationGroupVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfWorkStationRealTimeStatusVO implements IIPageOfWorkStationRealTimeStatusVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: WorkStationRealTimeStatusVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfWorkStationRealTimeStatusVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(WorkStationRealTimeStatusVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfWorkStationRealTimeStatusVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfWorkStationRealTimeStatusVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfWorkStationRealTimeStatusVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: WorkStationRealTimeStatusVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOf网关应用 implements IIPageOf网关应用 {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: 网关应用_1[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOf网关应用) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(网关应用_1.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOf网关应用 {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOf网关应用();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOf网关应用 {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: 网关应用_1[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class ImportPropertiesDTO implements IImportPropertiesDTO {
    /** 网关应用ID */
    gatewayAppId!: string | undefined;
    /** 属性的JSON格式 */
    properties!: string | undefined;

    constructor(data?: IImportPropertiesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayAppId = data["gatewayAppId"];
            this.properties = data["properties"];
        }
    }

    static fromJS(data: any): ImportPropertiesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportPropertiesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayAppId"] = this.gatewayAppId;
        data["properties"] = this.properties;
        return data; 
    }
}

export interface IImportPropertiesDTO {
    /** 网关应用ID */
    gatewayAppId: string | undefined;
    /** 属性的JSON格式 */
    properties: string | undefined;
}

export class IotApp简要信息 implements IIotApp简要信息 {
    /** 应用驱动 */
    gatewayAppTypeName!: string | undefined;
    /** id */
    id!: string | undefined;
    /** iotApp名称 */
    name!: string | undefined;
    /** 应用版本号 */
    version!: string | undefined;

    constructor(data?: IIotApp简要信息) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayAppTypeName = data["gatewayAppTypeName"];
            this.id = data["id"];
            this.name = data["name"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): IotApp简要信息 {
        data = typeof data === 'object' ? data : {};
        let result = new IotApp简要信息();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayAppTypeName"] = this.gatewayAppTypeName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["version"] = this.version;
        return data; 
    }
}

export interface IIotApp简要信息 {
    /** 应用驱动 */
    gatewayAppTypeName: string | undefined;
    /** id */
    id: string | undefined;
    /** iotApp名称 */
    name: string | undefined;
    /** 应用版本号 */
    version: string | undefined;
}

export class IotCollectionSettingDTO implements IIotCollectionSettingDTO {
    appCode!: number | undefined;
    appId!: string | undefined;
    deviceIp!: string | undefined;
    devicePort!: number | undefined;
    gatewayCode!: string | undefined;
    gatewayId!: string | undefined;
    templateId!: string | undefined;
    workStationId!: string | undefined;

    constructor(data?: IIotCollectionSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.appId = data["appId"];
            this.deviceIp = data["deviceIp"];
            this.devicePort = data["devicePort"];
            this.gatewayCode = data["gatewayCode"];
            this.gatewayId = data["gatewayId"];
            this.templateId = data["templateId"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): IotCollectionSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IotCollectionSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["appId"] = this.appId;
        data["deviceIp"] = this.deviceIp;
        data["devicePort"] = this.devicePort;
        data["gatewayCode"] = this.gatewayCode;
        data["gatewayId"] = this.gatewayId;
        data["templateId"] = this.templateId;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IIotCollectionSettingDTO {
    appCode: number | undefined;
    appId: string | undefined;
    deviceIp: string | undefined;
    devicePort: number | undefined;
    gatewayCode: string | undefined;
    gatewayId: string | undefined;
    templateId: string | undefined;
    workStationId: string | undefined;
}

export class Iot列表 implements IIot列表 {
    /** iot编号 */
    iotCode!: string | undefined;
    /** iot设备id */
    iotId!: string | undefined;
    /** iot名称 */
    iotName!: string | undefined;
    /** 网关版本 */
    iotVersion!: number | undefined;

    constructor(data?: IIot列表) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.iotCode = data["iotCode"];
            this.iotId = data["iotId"];
            this.iotName = data["iotName"];
            this.iotVersion = data["iotVersion"];
        }
    }

    static fromJS(data: any): Iot列表 {
        data = typeof data === 'object' ? data : {};
        let result = new Iot列表();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iotCode"] = this.iotCode;
        data["iotId"] = this.iotId;
        data["iotName"] = this.iotName;
        data["iotVersion"] = this.iotVersion;
        return data; 
    }
}

export interface IIot列表 {
    /** iot编号 */
    iotCode: string | undefined;
    /** iot设备id */
    iotId: string | undefined;
    /** iot名称 */
    iotName: string | undefined;
    /** 网关版本 */
    iotVersion: number | undefined;
}

export class Iot简要信息 implements IIot简要信息 {
    /** iotApp列表 */
    iotApps!: IotApp简要信息[] | undefined;
    /** iot编号 */
    iotCode!: string | undefined;
    /** iot设备id */
    iotId!: string | undefined;
    /** iot名称 */
    iotName!: string | undefined;
    /** 网关版本 */
    iotVersion!: number | undefined;

    constructor(data?: IIot简要信息) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["iotApps"] && data["iotApps"].constructor === Array) {
                this.iotApps = [] as any;
                for (let item of data["iotApps"])
                    this.iotApps!.push(IotApp简要信息.fromJS(item));
            }
            this.iotCode = data["iotCode"];
            this.iotId = data["iotId"];
            this.iotName = data["iotName"];
            this.iotVersion = data["iotVersion"];
        }
    }

    static fromJS(data: any): Iot简要信息 {
        data = typeof data === 'object' ? data : {};
        let result = new Iot简要信息();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.iotApps && this.iotApps.constructor === Array) {
            data["iotApps"] = [];
            for (let item of this.iotApps)
                data["iotApps"].push(item.toJSON());
        }
        data["iotCode"] = this.iotCode;
        data["iotId"] = this.iotId;
        data["iotName"] = this.iotName;
        data["iotVersion"] = this.iotVersion;
        return data; 
    }
}

export interface IIot简要信息 {
    /** iotApp列表 */
    iotApps: IotApp简要信息[] | undefined;
    /** iot编号 */
    iotCode: string | undefined;
    /** iot设备id */
    iotId: string | undefined;
    /** iot名称 */
    iotName: string | undefined;
    /** 网关版本 */
    iotVersion: number | undefined;
}

export class MachineCustomerDetailVO implements IMachineCustomerDetailVO {
    /** 地址 */
    address!: string | undefined;
    /** 区域 */
    areaName!: string | undefined;
    /** 设备图片 */
    avatar!: string | undefined;
    /** 联系人 */
    contact!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** 出厂时间 */
    deliveryTime!: Date | undefined;
    /** 设备类型 */
    deviceTypeName!: string | undefined;
    /** 设备名称 */
    name!: string | undefined;
    /** 设备序列号 */
    serialNo!: string | undefined;
    /** 软件版本 */
    softwareVersion!: string | undefined;
    /** 系统名称 */
    systemName!: string | undefined;
    /** 联系方式 */
    tel!: string | undefined;
    /** 类型图片 */
    typeAvatar!: string | undefined;

    constructor(data?: IMachineCustomerDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.areaName = data["areaName"];
            this.avatar = data["avatar"];
            this.contact = data["contact"];
            this.customerName = data["customerName"];
            this.deliveryTime = data["deliveryTime"] ? new Date(data["deliveryTime"].toString()) : <any>undefined;
            this.deviceTypeName = data["deviceTypeName"];
            this.name = data["name"];
            this.serialNo = data["serialNo"];
            this.softwareVersion = data["softwareVersion"];
            this.systemName = data["systemName"];
            this.tel = data["tel"];
            this.typeAvatar = data["typeAvatar"];
        }
    }

    static fromJS(data: any): MachineCustomerDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new MachineCustomerDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["areaName"] = this.areaName;
        data["avatar"] = this.avatar;
        data["contact"] = this.contact;
        data["customerName"] = this.customerName;
        data["deliveryTime"] = this.deliveryTime ? this.deliveryTime.toISOString() : <any>undefined;
        data["deviceTypeName"] = this.deviceTypeName;
        data["name"] = this.name;
        data["serialNo"] = this.serialNo;
        data["softwareVersion"] = this.softwareVersion;
        data["systemName"] = this.systemName;
        data["tel"] = this.tel;
        data["typeAvatar"] = this.typeAvatar;
        return data; 
    }
}

export interface IMachineCustomerDetailVO {
    /** 地址 */
    address: string | undefined;
    /** 区域 */
    areaName: string | undefined;
    /** 设备图片 */
    avatar: string | undefined;
    /** 联系人 */
    contact: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** 出厂时间 */
    deliveryTime: Date | undefined;
    /** 设备类型 */
    deviceTypeName: string | undefined;
    /** 设备名称 */
    name: string | undefined;
    /** 设备序列号 */
    serialNo: string | undefined;
    /** 软件版本 */
    softwareVersion: string | undefined;
    /** 系统名称 */
    systemName: string | undefined;
    /** 联系方式 */
    tel: string | undefined;
    /** 类型图片 */
    typeAvatar: string | undefined;
}

export class MachineFeatureVO implements IMachineFeatureVO {
    gatewayCode!: string | undefined;
    gatewayId!: string | undefined;
    hasDataCollection!: boolean | undefined;
    hasRemoteConnection!: boolean | undefined;

    constructor(data?: IMachineFeatureVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayCode = data["gatewayCode"];
            this.gatewayId = data["gatewayId"];
            this.hasDataCollection = data["hasDataCollection"];
            this.hasRemoteConnection = data["hasRemoteConnection"];
        }
    }

    static fromJS(data: any): MachineFeatureVO {
        data = typeof data === 'object' ? data : {};
        let result = new MachineFeatureVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayCode"] = this.gatewayCode;
        data["gatewayId"] = this.gatewayId;
        data["hasDataCollection"] = this.hasDataCollection;
        data["hasRemoteConnection"] = this.hasRemoteConnection;
        return data; 
    }
}

export interface IMachineFeatureVO {
    gatewayCode: string | undefined;
    gatewayId: string | undefined;
    hasDataCollection: boolean | undefined;
    hasRemoteConnection: boolean | undefined;
}

export class MachineGatewayVO implements IMachineGatewayVO {
    gatewayCode!: string | undefined;
    gatewayId!: string | undefined;
    iotAppCode!: number | undefined;
    iotAppId!: string | undefined;
    methodList!: GatewayMethodVO[] | undefined;

    constructor(data?: IMachineGatewayVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayCode = data["gatewayCode"];
            this.gatewayId = data["gatewayId"];
            this.iotAppCode = data["iotAppCode"];
            this.iotAppId = data["iotAppId"];
            if (data["methodList"] && data["methodList"].constructor === Array) {
                this.methodList = [] as any;
                for (let item of data["methodList"])
                    this.methodList!.push(GatewayMethodVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MachineGatewayVO {
        data = typeof data === 'object' ? data : {};
        let result = new MachineGatewayVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayCode"] = this.gatewayCode;
        data["gatewayId"] = this.gatewayId;
        data["iotAppCode"] = this.iotAppCode;
        data["iotAppId"] = this.iotAppId;
        if (this.methodList && this.methodList.constructor === Array) {
            data["methodList"] = [];
            for (let item of this.methodList)
                data["methodList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMachineGatewayVO {
    gatewayCode: string | undefined;
    gatewayId: string | undefined;
    iotAppCode: number | undefined;
    iotAppId: string | undefined;
    methodList: GatewayMethodVO[] | undefined;
}

export class MachineIotVo implements IMachineIotVo {
    deviceIp!: string | undefined;
    devicePort!: number | undefined;
    gatewayId!: string | undefined;
    templateId!: string | undefined;
    workstationId!: string | undefined;

    constructor(data?: IMachineIotVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceIp = data["deviceIp"];
            this.devicePort = data["devicePort"];
            this.gatewayId = data["gatewayId"];
            this.templateId = data["templateId"];
            this.workstationId = data["workstationId"];
        }
    }

    static fromJS(data: any): MachineIotVo {
        data = typeof data === 'object' ? data : {};
        let result = new MachineIotVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceIp"] = this.deviceIp;
        data["devicePort"] = this.devicePort;
        data["gatewayId"] = this.gatewayId;
        data["templateId"] = this.templateId;
        data["workstationId"] = this.workstationId;
        return data; 
    }
}

export interface IMachineIotVo {
    deviceIp: string | undefined;
    devicePort: number | undefined;
    gatewayId: string | undefined;
    templateId: string | undefined;
    workstationId: string | undefined;
}

export class MachineSelectVO implements IMachineSelectVO {
    /** 图片 */
    avatar!: string | undefined;
    /** 出厂时间 */
    deliveryTime!: Date | undefined;
    /** 设备类型ID */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    id!: string | undefined;
    /** 机床名称 */
    name!: string | undefined;
    /** 机床序列号 */
    serialNo!: string | undefined;
    /** 状态(1网关设备,2自定义设备) */
    status!: number | undefined;
    /** 类型图片 */
    typeAvatar!: string | undefined;
    /** 未完成工单数 */
    unfinishedWorkOrderNumber!: number | undefined;

    constructor(data?: IMachineSelectVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.avatar = data["avatar"];
            this.deliveryTime = data["deliveryTime"] ? new Date(data["deliveryTime"].toString()) : <any>undefined;
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.id = data["id"];
            this.name = data["name"];
            this.serialNo = data["serialNo"];
            this.status = data["status"];
            this.typeAvatar = data["typeAvatar"];
            this.unfinishedWorkOrderNumber = data["unfinishedWorkOrderNumber"];
        }
    }

    static fromJS(data: any): MachineSelectVO {
        data = typeof data === 'object' ? data : {};
        let result = new MachineSelectVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatar"] = this.avatar;
        data["deliveryTime"] = this.deliveryTime ? this.deliveryTime.toISOString() : <any>undefined;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["serialNo"] = this.serialNo;
        data["status"] = this.status;
        data["typeAvatar"] = this.typeAvatar;
        data["unfinishedWorkOrderNumber"] = this.unfinishedWorkOrderNumber;
        return data; 
    }
}

export interface IMachineSelectVO {
    /** 图片 */
    avatar: string | undefined;
    /** 出厂时间 */
    deliveryTime: Date | undefined;
    /** 设备类型ID */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    id: string | undefined;
    /** 机床名称 */
    name: string | undefined;
    /** 机床序列号 */
    serialNo: string | undefined;
    /** 状态(1网关设备,2自定义设备) */
    status: number | undefined;
    /** 类型图片 */
    typeAvatar: string | undefined;
    /** 未完成工单数 */
    unfinishedWorkOrderNumber: number | undefined;
}

export class MachineVO implements IMachineVO {
    assemblyState!: number | undefined;
    attachFiles!: string[] | undefined;
    avatar!: string | undefined;
    code!: string | undefined;
    deliveryTime!: Date | undefined;
    deviceTypeId!: string | undefined;
    hyperlink!: string | undefined;
    id!: string | undefined;
    name!: string | undefined;
    serialNo!: string | undefined;
    softwareVersion!: string | undefined;
    systemName!: string | undefined;
    typeAvatar!: string | undefined;

    constructor(data?: IMachineVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assemblyState = data["assemblyState"];
            if (data["attachFiles"] && data["attachFiles"].constructor === Array) {
                this.attachFiles = [] as any;
                for (let item of data["attachFiles"])
                    this.attachFiles!.push(item);
            }
            this.avatar = data["avatar"];
            this.code = data["code"];
            this.deliveryTime = data["deliveryTime"] ? new Date(data["deliveryTime"].toString()) : <any>undefined;
            this.deviceTypeId = data["deviceTypeId"];
            this.hyperlink = data["hyperlink"];
            this.id = data["id"];
            this.name = data["name"];
            this.serialNo = data["serialNo"];
            this.softwareVersion = data["softwareVersion"];
            this.systemName = data["systemName"];
            this.typeAvatar = data["typeAvatar"];
        }
    }

    static fromJS(data: any): MachineVO {
        data = typeof data === 'object' ? data : {};
        let result = new MachineVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assemblyState"] = this.assemblyState;
        if (this.attachFiles && this.attachFiles.constructor === Array) {
            data["attachFiles"] = [];
            for (let item of this.attachFiles)
                data["attachFiles"].push(item);
        }
        data["avatar"] = this.avatar;
        data["code"] = this.code;
        data["deliveryTime"] = this.deliveryTime ? this.deliveryTime.toISOString() : <any>undefined;
        data["deviceTypeId"] = this.deviceTypeId;
        data["hyperlink"] = this.hyperlink;
        data["id"] = this.id;
        data["name"] = this.name;
        data["serialNo"] = this.serialNo;
        data["softwareVersion"] = this.softwareVersion;
        data["systemName"] = this.systemName;
        data["typeAvatar"] = this.typeAvatar;
        return data; 
    }
}

export interface IMachineVO {
    assemblyState: number | undefined;
    attachFiles: string[] | undefined;
    avatar: string | undefined;
    code: string | undefined;
    deliveryTime: Date | undefined;
    deviceTypeId: string | undefined;
    hyperlink: string | undefined;
    id: string | undefined;
    name: string | undefined;
    serialNo: string | undefined;
    softwareVersion: string | undefined;
    systemName: string | undefined;
    typeAvatar: string | undefined;
}

export class MultipleParameterSetValueDTO implements IMultipleParameterSetValueDTO {
    /** 属性名称 */
    name!: string | undefined;
    /** 属性值 */
    value!: string | undefined;

    constructor(data?: IMultipleParameterSetValueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): MultipleParameterSetValueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MultipleParameterSetValueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface IMultipleParameterSetValueDTO {
    /** 属性名称 */
    name: string | undefined;
    /** 属性值 */
    value: string | undefined;
}

export class OrderItem implements IOrderItem {
    asc!: boolean | undefined;
    column!: string | undefined;

    constructor(data?: IOrderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.asc = data["asc"];
            this.column = data["column"];
        }
    }

    static fromJS(data: any): OrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asc"] = this.asc;
        data["column"] = this.column;
        return data; 
    }
}

export interface IOrderItem {
    asc: boolean | undefined;
    column: string | undefined;
}

export class PageOfAssignableMachineDTO implements IPageOfAssignableMachineDTO {
    countId!: string | undefined;
    current!: string | undefined;
    hitCount!: boolean | undefined;
    maxLimit!: string | undefined;
    optimizeCountSql!: boolean | undefined;
    orders!: OrderItem[] | undefined;
    pages!: string | undefined;
    records!: AssignableMachineDTO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IPageOfAssignableMachineDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countId = data["countId"];
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.maxLimit = data["maxLimit"];
            this.optimizeCountSql = data["optimizeCountSql"];
            if (data["orders"] && data["orders"].constructor === Array) {
                this.orders = [] as any;
                for (let item of data["orders"])
                    this.orders!.push(OrderItem.fromJS(item));
            }
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(AssignableMachineDTO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): PageOfAssignableMachineDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PageOfAssignableMachineDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countId"] = this.countId;
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["maxLimit"] = this.maxLimit;
        data["optimizeCountSql"] = this.optimizeCountSql;
        if (this.orders && this.orders.constructor === Array) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IPageOfAssignableMachineDTO {
    countId: string | undefined;
    current: string | undefined;
    hitCount: boolean | undefined;
    maxLimit: string | undefined;
    optimizeCountSql: boolean | undefined;
    orders: OrderItem[] | undefined;
    pages: string | undefined;
    records: AssignableMachineDTO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class PageOfDevicePageVO implements IPageOfDevicePageVO {
    countId!: string | undefined;
    current!: string | undefined;
    hitCount!: boolean | undefined;
    maxLimit!: string | undefined;
    optimizeCountSql!: boolean | undefined;
    orders!: OrderItem[] | undefined;
    pages!: string | undefined;
    records!: DevicePageVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IPageOfDevicePageVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countId = data["countId"];
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.maxLimit = data["maxLimit"];
            this.optimizeCountSql = data["optimizeCountSql"];
            if (data["orders"] && data["orders"].constructor === Array) {
                this.orders = [] as any;
                for (let item of data["orders"])
                    this.orders!.push(OrderItem.fromJS(item));
            }
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(DevicePageVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): PageOfDevicePageVO {
        data = typeof data === 'object' ? data : {};
        let result = new PageOfDevicePageVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countId"] = this.countId;
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["maxLimit"] = this.maxLimit;
        data["optimizeCountSql"] = this.optimizeCountSql;
        if (this.orders && this.orders.constructor === Array) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IPageOfDevicePageVO {
    countId: string | undefined;
    current: string | undefined;
    hitCount: boolean | undefined;
    maxLimit: string | undefined;
    optimizeCountSql: boolean | undefined;
    orders: OrderItem[] | undefined;
    pages: string | undefined;
    records: DevicePageVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class PageOfGetMachineListVO implements IPageOfGetMachineListVO {
    countId!: string | undefined;
    current!: string | undefined;
    hitCount!: boolean | undefined;
    maxLimit!: string | undefined;
    optimizeCountSql!: boolean | undefined;
    orders!: OrderItem[] | undefined;
    pages!: string | undefined;
    records!: GetMachineListVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IPageOfGetMachineListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countId = data["countId"];
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.maxLimit = data["maxLimit"];
            this.optimizeCountSql = data["optimizeCountSql"];
            if (data["orders"] && data["orders"].constructor === Array) {
                this.orders = [] as any;
                for (let item of data["orders"])
                    this.orders!.push(OrderItem.fromJS(item));
            }
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(GetMachineListVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): PageOfGetMachineListVO {
        data = typeof data === 'object' ? data : {};
        let result = new PageOfGetMachineListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countId"] = this.countId;
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["maxLimit"] = this.maxLimit;
        data["optimizeCountSql"] = this.optimizeCountSql;
        if (this.orders && this.orders.constructor === Array) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IPageOfGetMachineListVO {
    countId: string | undefined;
    current: string | undefined;
    hitCount: boolean | undefined;
    maxLimit: string | undefined;
    optimizeCountSql: boolean | undefined;
    orders: OrderItem[] | undefined;
    pages: string | undefined;
    records: GetMachineListVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class PageOfWorkStationBriefVO implements IPageOfWorkStationBriefVO {
    countId!: string | undefined;
    current!: string | undefined;
    hitCount!: boolean | undefined;
    maxLimit!: string | undefined;
    optimizeCountSql!: boolean | undefined;
    orders!: OrderItem[] | undefined;
    pages!: string | undefined;
    records!: WorkStationBriefVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IPageOfWorkStationBriefVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countId = data["countId"];
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.maxLimit = data["maxLimit"];
            this.optimizeCountSql = data["optimizeCountSql"];
            if (data["orders"] && data["orders"].constructor === Array) {
                this.orders = [] as any;
                for (let item of data["orders"])
                    this.orders!.push(OrderItem.fromJS(item));
            }
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(WorkStationBriefVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): PageOfWorkStationBriefVO {
        data = typeof data === 'object' ? data : {};
        let result = new PageOfWorkStationBriefVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countId"] = this.countId;
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["maxLimit"] = this.maxLimit;
        data["optimizeCountSql"] = this.optimizeCountSql;
        if (this.orders && this.orders.constructor === Array) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IPageOfWorkStationBriefVO {
    countId: string | undefined;
    current: string | undefined;
    hitCount: boolean | undefined;
    maxLimit: string | undefined;
    optimizeCountSql: boolean | undefined;
    orders: OrderItem[] | undefined;
    pages: string | undefined;
    records: WorkStationBriefVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class ParamVO implements IParamVO {
    /** 描述信息 */
    description!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 数据类型 */
    type!: string | undefined;
    /** 值 */
    value!: any | undefined;

    constructor(data?: IParamVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
            this.name = data["name"];
            this.type = data["type"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): ParamVO {
        data = typeof data === 'object' ? data : {};
        let result = new ParamVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["value"] = this.value;
        return data; 
    }
}

export interface IParamVO {
    /** 描述信息 */
    description: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 数据类型 */
    type: string | undefined;
    /** 值 */
    value: any | undefined;
}

export class Process implements IProcess {
    code!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    description!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    name!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    tenantId!: string | undefined;
    type!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.description = data["description"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.name = data["name"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.type = data["type"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): Process {
        data = typeof data === 'object' ? data : {};
        let result = new Process();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["type"] = this.type;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IProcess {
    code: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    description: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    name: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    tenantId: string | undefined;
    type: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

/** 生产工序 */
export class ProcessBO implements IProcessBO {
    /** 工序编号 */
    code!: string | undefined;
    /** 工序描述 */
    description!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 工序名称 */
    name!: string | undefined;
    /** 工序工位信息 */
    processWorkStationList!: ProcessWorkStationVO[] | undefined;
    /** 启用禁用按钮1-启动0-禁用 */
    status!: number | undefined;
    /** 工序类型 */
    type!: string | undefined;

    constructor(data?: IProcessBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.description = data["description"];
            this.id = data["id"];
            this.name = data["name"];
            if (data["processWorkStationList"] && data["processWorkStationList"].constructor === Array) {
                this.processWorkStationList = [] as any;
                for (let item of data["processWorkStationList"])
                    this.processWorkStationList!.push(ProcessWorkStationVO.fromJS(item));
            }
            this.status = data["status"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): ProcessBO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["id"] = this.id;
        data["name"] = this.name;
        if (this.processWorkStationList && this.processWorkStationList.constructor === Array) {
            data["processWorkStationList"] = [];
            for (let item of this.processWorkStationList)
                data["processWorkStationList"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["type"] = this.type;
        return data; 
    }
}

/** 生产工序 */
export interface IProcessBO {
    /** 工序编号 */
    code: string | undefined;
    /** 工序描述 */
    description: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 工序名称 */
    name: string | undefined;
    /** 工序工位信息 */
    processWorkStationList: ProcessWorkStationVO[] | undefined;
    /** 启用禁用按钮1-启动0-禁用 */
    status: number | undefined;
    /** 工序类型 */
    type: string | undefined;
}

/** 生产工序 */
export class ProcessInsertDTO implements IProcessInsertDTO {
    /** 工序编号 */
    code!: string;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 工序描述 */
    description!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 工序名称 */
    name!: string;
    /** 启用禁用按钮1-启动0-禁用 */
    status!: number | undefined;
    /** 所属租户 */
    tenantId!: string | undefined;
    /** 工序类型 */
    type!: string | undefined;
    /** 工位id集合 */
    workStationIds!: string[] | undefined;

    constructor(data?: IProcessInsertDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.description = data["description"];
            this.id = data["id"];
            this.name = data["name"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.type = data["type"];
            if (data["workStationIds"] && data["workStationIds"].constructor === Array) {
                this.workStationIds = [] as any;
                for (let item of data["workStationIds"])
                    this.workStationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ProcessInsertDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessInsertDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["description"] = this.description;
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["type"] = this.type;
        if (this.workStationIds && this.workStationIds.constructor === Array) {
            data["workStationIds"] = [];
            for (let item of this.workStationIds)
                data["workStationIds"].push(item);
        }
        return data; 
    }
}

/** 生产工序 */
export interface IProcessInsertDTO {
    /** 工序编号 */
    code: string;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 工序描述 */
    description: string | undefined;
    /** id */
    id: string | undefined;
    /** 工序名称 */
    name: string;
    /** 启用禁用按钮1-启动0-禁用 */
    status: number | undefined;
    /** 所属租户 */
    tenantId: string | undefined;
    /** 工序类型 */
    type: string | undefined;
    /** 工位id集合 */
    workStationIds: string[] | undefined;
}

export class ProcessSearchDTO implements IProcessSearchDTO {
    /** 状态集合 */
    statusList!: number[];

    constructor(data?: IProcessSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusList = [];
        }
    }

    init(data?: any) {
        if (data) {
            if (data["statusList"] && data["statusList"].constructor === Array) {
                this.statusList = [] as any;
                for (let item of data["statusList"])
                    this.statusList!.push(item);
            }
        }
    }

    static fromJS(data: any): ProcessSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.statusList && this.statusList.constructor === Array) {
            data["statusList"] = [];
            for (let item of this.statusList)
                data["statusList"].push(item);
        }
        return data; 
    }
}

export interface IProcessSearchDTO {
    /** 状态集合 */
    statusList: number[];
}

export class ProcessWorkStationVO implements IProcessWorkStationVO {
    /** 工位code */
    workStationCode!: string | undefined;
    /** 工位id */
    workStationId!: string | undefined;
    /** 工位name */
    workStationName!: string | undefined;

    constructor(data?: IProcessWorkStationVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): ProcessWorkStationVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessWorkStationVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IProcessWorkStationVO {
    /** 工位code */
    workStationCode: string | undefined;
    /** 工位id */
    workStationId: string | undefined;
    /** 工位name */
    workStationName: string | undefined;
}

export class PropertiesVO implements IPropertiesVO {
    /** 基础字段 */
    baseField!: BaseFiledVo | undefined;
    /** 扩展字段 */
    extendField!: ExtendFieldVo | undefined;
    /** 网关应用ID */
    gatewayAppId!: string | undefined;
    /** 属性名称 */
    name!: string | undefined;

    constructor(data?: IPropertiesVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.baseField = data["baseField"] ? BaseFiledVo.fromJS(data["baseField"]) : <any>undefined;
            this.extendField = data["extendField"] ? ExtendFieldVo.fromJS(data["extendField"]) : <any>undefined;
            this.gatewayAppId = data["gatewayAppId"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): PropertiesVO {
        data = typeof data === 'object' ? data : {};
        let result = new PropertiesVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseField"] = this.baseField ? this.baseField.toJSON() : <any>undefined;
        data["extendField"] = this.extendField ? this.extendField.toJSON() : <any>undefined;
        data["gatewayAppId"] = this.gatewayAppId;
        data["name"] = this.name;
        return data; 
    }
}

export interface IPropertiesVO {
    /** 基础字段 */
    baseField: BaseFiledVo | undefined;
    /** 扩展字段 */
    extendField: ExtendFieldVo | undefined;
    /** 网关应用ID */
    gatewayAppId: string | undefined;
    /** 属性名称 */
    name: string | undefined;
}

export class ProvinceMachineStatisticsDTO implements IProvinceMachineStatisticsDTO {
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;

    constructor(data?: IProvinceMachineStatisticsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProvinceMachineStatisticsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceMachineStatisticsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endTime"] = this.endTime ? formatDate(this.endTime) : <any>undefined;
        data["startTime"] = this.startTime ? formatDate(this.startTime) : <any>undefined;
        return data; 
    }
}

export interface IProvinceMachineStatisticsDTO {
    /** 结束时间 */
    endTime: Date | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
}

export class ProvinceMachineStatisticsVO implements IProvinceMachineStatisticsVO {
    /** 网关设备数 */
    machineValue!: string | undefined;
    /** 省份名称 */
    name!: string | undefined;
    /** 所有的设备数 */
    totalValue!: string | undefined;

    constructor(data?: IProvinceMachineStatisticsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.machineValue = data["machineValue"];
            this.name = data["name"];
            this.totalValue = data["totalValue"];
        }
    }

    static fromJS(data: any): ProvinceMachineStatisticsVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceMachineStatisticsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineValue"] = this.machineValue;
        data["name"] = this.name;
        data["totalValue"] = this.totalValue;
        return data; 
    }
}

export interface IProvinceMachineStatisticsVO {
    /** 网关设备数 */
    machineValue: string | undefined;
    /** 省份名称 */
    name: string | undefined;
    /** 所有的设备数 */
    totalValue: string | undefined;
}

export class QrCodeCustomerAddressVO implements IQrCodeCustomerAddressVO {
    /** 详细地址 */
    address!: string | undefined;
    /** 大区名称 */
    areaName!: string | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;

    constructor(data?: IQrCodeCustomerAddressVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.areaName = data["areaName"];
            this.cityName = data["cityName"];
            this.provinceName = data["provinceName"];
        }
    }

    static fromJS(data: any): QrCodeCustomerAddressVO {
        data = typeof data === 'object' ? data : {};
        let result = new QrCodeCustomerAddressVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["areaName"] = this.areaName;
        data["cityName"] = this.cityName;
        data["provinceName"] = this.provinceName;
        return data; 
    }
}

export interface IQrCodeCustomerAddressVO {
    /** 详细地址 */
    address: string | undefined;
    /** 大区名称 */
    areaName: string | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
}

export class QrCodeInfoVO implements IQrCodeInfoVO {
    /** 工位序列号 */
    code!: string | undefined;
    /** 联系方式 */
    contact!: string | undefined;
    /** 客户地址 */
    customerAddress!: QrCodeCustomerAddressVO | undefined;
    /** 客户id */
    customerId!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** 出厂时间 */
    deliveryTime!: Date | undefined;
    /** 工位ID */
    id!: string | undefined;
    /** 工位名字 */
    name!: string | undefined;
    /** 联系方式 */
    tel!: string | undefined;

    constructor(data?: IQrCodeInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.contact = data["contact"];
            this.customerAddress = data["customerAddress"] ? QrCodeCustomerAddressVO.fromJS(data["customerAddress"]) : <any>undefined;
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
            this.deliveryTime = data["deliveryTime"] ? new Date(data["deliveryTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.name = data["name"];
            this.tel = data["tel"];
        }
    }

    static fromJS(data: any): QrCodeInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new QrCodeInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["contact"] = this.contact;
        data["customerAddress"] = this.customerAddress ? this.customerAddress.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["deliveryTime"] = this.deliveryTime ? this.deliveryTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["tel"] = this.tel;
        return data; 
    }
}

export interface IQrCodeInfoVO {
    /** 工位序列号 */
    code: string | undefined;
    /** 联系方式 */
    contact: string | undefined;
    /** 客户地址 */
    customerAddress: QrCodeCustomerAddressVO | undefined;
    /** 客户id */
    customerId: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** 出厂时间 */
    deliveryTime: Date | undefined;
    /** 工位ID */
    id: string | undefined;
    /** 工位名字 */
    name: string | undefined;
    /** 联系方式 */
    tel: string | undefined;
}

/** 查询条件 */
export class Query implements IQuery {
    /** 当前页 */
    current!: number | undefined;
    /** 每页的数量 */
    size!: number | undefined;

    constructor(data?: IQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): Query {
        data = typeof data === 'object' ? data : {};
        let result = new Query();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["size"] = this.size;
        return data; 
    }
}

/** 查询条件 */
export interface IQuery {
    /** 当前页 */
    current: number | undefined;
    /** 每页的数量 */
    size: number | undefined;
}

export class RepeatedSerialNoMachineVO implements IRepeatedSerialNoMachineVO {
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 客户ID */
    customerId!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** 序列号 */
    serialNo!: string | undefined;

    constructor(data?: IRepeatedSerialNoMachineVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
            this.serialNo = data["serialNo"];
        }
    }

    static fromJS(data: any): RepeatedSerialNoMachineVO {
        data = typeof data === 'object' ? data : {};
        let result = new RepeatedSerialNoMachineVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["serialNo"] = this.serialNo;
        return data; 
    }
}

export interface IRepeatedSerialNoMachineVO {
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 客户ID */
    customerId: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** 序列号 */
    serialNo: string | undefined;
}

export class RouteDefinition implements IRouteDefinition {
    compatibleMode!: number | undefined;
    filters!: GatewayFilterDefinition[] | undefined;
    id!: string | undefined;
    ignoreValidate!: number | undefined;
    mergeResult!: number | undefined;
    name!: string | undefined;
    needToken!: number | undefined;
    order!: number | undefined;
    path!: string | undefined;
    permission!: number | undefined;
    predicates!: GatewayPredicateDefinition[] | undefined;
    status!: number | undefined;
    uri!: string | undefined;
    version!: string | undefined;

    constructor(data?: IRouteDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.compatibleMode = data["compatibleMode"];
            if (data["filters"] && data["filters"].constructor === Array) {
                this.filters = [] as any;
                for (let item of data["filters"])
                    this.filters!.push(GatewayFilterDefinition.fromJS(item));
            }
            this.id = data["id"];
            this.ignoreValidate = data["ignoreValidate"];
            this.mergeResult = data["mergeResult"];
            this.name = data["name"];
            this.needToken = data["needToken"];
            this.order = data["order"];
            this.path = data["path"];
            this.permission = data["permission"];
            if (data["predicates"] && data["predicates"].constructor === Array) {
                this.predicates = [] as any;
                for (let item of data["predicates"])
                    this.predicates!.push(GatewayPredicateDefinition.fromJS(item));
            }
            this.status = data["status"];
            this.uri = data["uri"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): RouteDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new RouteDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compatibleMode"] = this.compatibleMode;
        if (this.filters && this.filters.constructor === Array) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["ignoreValidate"] = this.ignoreValidate;
        data["mergeResult"] = this.mergeResult;
        data["name"] = this.name;
        data["needToken"] = this.needToken;
        data["order"] = this.order;
        data["path"] = this.path;
        data["permission"] = this.permission;
        if (this.predicates && this.predicates.constructor === Array) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["uri"] = this.uri;
        data["version"] = this.version;
        return data; 
    }
}

export interface IRouteDefinition {
    compatibleMode: number | undefined;
    filters: GatewayFilterDefinition[] | undefined;
    id: string | undefined;
    ignoreValidate: number | undefined;
    mergeResult: number | undefined;
    name: string | undefined;
    needToken: number | undefined;
    order: number | undefined;
    path: string | undefined;
    permission: number | undefined;
    predicates: GatewayPredicateDefinition[] | undefined;
    status: number | undefined;
    uri: string | undefined;
    version: string | undefined;
}

export class SaveWorkStationToGroupDTO implements ISaveWorkStationToGroupDTO {
    /** 工位组Id */
    groupId!: string | undefined;
    /** 工位id */
    workStationId!: string[] | undefined;

    constructor(data?: ISaveWorkStationToGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.groupId = data["groupId"];
            if (data["workStationId"] && data["workStationId"].constructor === Array) {
                this.workStationId = [] as any;
                for (let item of data["workStationId"])
                    this.workStationId!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveWorkStationToGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWorkStationToGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        if (this.workStationId && this.workStationId.constructor === Array) {
            data["workStationId"] = [];
            for (let item of this.workStationId)
                data["workStationId"].push(item);
        }
        return data; 
    }
}

export interface ISaveWorkStationToGroupDTO {
    /** 工位组Id */
    groupId: string | undefined;
    /** 工位id */
    workStationId: string[] | undefined;
}

export class ServiceRouteInfo implements IServiceRouteInfo {
    createTime!: Date | undefined;
    description!: string | undefined;
    routeDefinitionList!: RouteDefinition[] | undefined;
    serviceId!: string | undefined;
    updateTime!: Date | undefined;

    constructor(data?: IServiceRouteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.description = data["description"];
            if (data["routeDefinitionList"] && data["routeDefinitionList"].constructor === Array) {
                this.routeDefinitionList = [] as any;
                for (let item of data["routeDefinitionList"])
                    this.routeDefinitionList!.push(RouteDefinition.fromJS(item));
            }
            this.serviceId = data["serviceId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceRouteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRouteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (this.routeDefinitionList && this.routeDefinitionList.constructor === Array) {
            data["routeDefinitionList"] = [];
            for (let item of this.routeDefinitionList)
                data["routeDefinitionList"].push(item.toJSON());
        }
        data["serviceId"] = this.serviceId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IServiceRouteInfo {
    createTime: Date | undefined;
    description: string | undefined;
    routeDefinitionList: RouteDefinition[] | undefined;
    serviceId: string | undefined;
    updateTime: Date | undefined;
}

export class ShareMachineDTO implements IShareMachineDTO {
    targetTenantId!: string | undefined;
    unsharedWorkStationIdList!: string[] | undefined;
    workStationIdList!: string[] | undefined;

    constructor(data?: IShareMachineDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetTenantId = data["targetTenantId"];
            if (data["unsharedWorkStationIdList"] && data["unsharedWorkStationIdList"].constructor === Array) {
                this.unsharedWorkStationIdList = [] as any;
                for (let item of data["unsharedWorkStationIdList"])
                    this.unsharedWorkStationIdList!.push(item);
            }
            if (data["workStationIdList"] && data["workStationIdList"].constructor === Array) {
                this.workStationIdList = [] as any;
                for (let item of data["workStationIdList"])
                    this.workStationIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): ShareMachineDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShareMachineDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        if (this.unsharedWorkStationIdList && this.unsharedWorkStationIdList.constructor === Array) {
            data["unsharedWorkStationIdList"] = [];
            for (let item of this.unsharedWorkStationIdList)
                data["unsharedWorkStationIdList"].push(item);
        }
        if (this.workStationIdList && this.workStationIdList.constructor === Array) {
            data["workStationIdList"] = [];
            for (let item of this.workStationIdList)
                data["workStationIdList"].push(item);
        }
        return data; 
    }
}

export interface IShareMachineDTO {
    targetTenantId: string | undefined;
    unsharedWorkStationIdList: string[] | undefined;
    workStationIdList: string[] | undefined;
}

export class UnactivatedMachineDTO implements IUnactivatedMachineDTO {
    /** 装配状态 */
    assemblyState!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** 网关编号 */
    gatewayCode!: string | undefined;
    /** 序列号 */
    serialNo!: string | undefined;

    constructor(data?: IUnactivatedMachineDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assemblyState = data["assemblyState"];
            this.customerName = data["customerName"];
            this.gatewayCode = data["gatewayCode"];
            this.serialNo = data["serialNo"];
        }
    }

    static fromJS(data: any): UnactivatedMachineDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UnactivatedMachineDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assemblyState"] = this.assemblyState;
        data["customerName"] = this.customerName;
        data["gatewayCode"] = this.gatewayCode;
        data["serialNo"] = this.serialNo;
        return data; 
    }
}

export interface IUnactivatedMachineDTO {
    /** 装配状态 */
    assemblyState: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** 网关编号 */
    gatewayCode: string | undefined;
    /** 序列号 */
    serialNo: string | undefined;
}

export class UnbindMachineIotDTO implements IUnbindMachineIotDTO {
    featureValue!: number | undefined;
    gatewayId!: string | undefined;
    machineId!: string | undefined;

    constructor(data?: IUnbindMachineIotDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.featureValue = data["featureValue"];
            this.gatewayId = data["gatewayId"];
            this.machineId = data["machineId"];
        }
    }

    static fromJS(data: any): UnbindMachineIotDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UnbindMachineIotDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureValue"] = this.featureValue;
        data["gatewayId"] = this.gatewayId;
        data["machineId"] = this.machineId;
        return data; 
    }
}

export interface IUnbindMachineIotDTO {
    featureValue: number | undefined;
    gatewayId: string | undefined;
    machineId: string | undefined;
}

export class WcsSettingDTO implements IWcsSettingDTO {
    /** wcs颜色 */
    color!: string | undefined;
    /** wcs名称 */
    wcsName!: string | undefined;
    /** wcs序号 */
    wcsNum!: number | undefined;

    constructor(data?: IWcsSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.color = data["color"];
            this.wcsName = data["wcsName"];
            this.wcsNum = data["wcsNum"];
        }
    }

    static fromJS(data: any): WcsSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WcsSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["wcsName"] = this.wcsName;
        data["wcsNum"] = this.wcsNum;
        return data; 
    }
}

export interface IWcsSettingDTO {
    /** wcs颜色 */
    color: string | undefined;
    /** wcs名称 */
    wcsName: string | undefined;
    /** wcs序号 */
    wcsNum: number | undefined;
}

export class WorkConditionSettingVO implements IWorkConditionSettingVO {
    /** 关联采集值 */
    collectStatus!: number | undefined;
    /** 关联采集状态 */
    collectStatusName!: string | undefined;
    /** 用户维护颜色 */
    color!: string | undefined;
    /** id */
    id!: string | undefined;
    /** rps值 */
    rps!: number | undefined;
    /** 归属时间 */
    rpsName!: string | undefined;
    /** wcs值 */
    wcs!: number | undefined;
    /** 工况状态 */
    wcsName!: string | undefined;

    constructor(data?: IWorkConditionSettingVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.collectStatus = data["collectStatus"];
            this.collectStatusName = data["collectStatusName"];
            this.color = data["color"];
            this.id = data["id"];
            this.rps = data["rps"];
            this.rpsName = data["rpsName"];
            this.wcs = data["wcs"];
            this.wcsName = data["wcsName"];
        }
    }

    static fromJS(data: any): WorkConditionSettingVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkConditionSettingVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectStatus"] = this.collectStatus;
        data["collectStatusName"] = this.collectStatusName;
        data["color"] = this.color;
        data["id"] = this.id;
        data["rps"] = this.rps;
        data["rpsName"] = this.rpsName;
        data["wcs"] = this.wcs;
        data["wcsName"] = this.wcsName;
        return data; 
    }
}

export interface IWorkConditionSettingVO {
    /** 关联采集值 */
    collectStatus: number | undefined;
    /** 关联采集状态 */
    collectStatusName: string | undefined;
    /** 用户维护颜色 */
    color: string | undefined;
    /** id */
    id: string | undefined;
    /** rps值 */
    rps: number | undefined;
    /** 归属时间 */
    rpsName: string | undefined;
    /** wcs值 */
    wcs: number | undefined;
    /** 工况状态 */
    wcsName: string | undefined;
}

export class WorkStation implements IWorkStation {
    avatar!: string | undefined;
    calendarCode!: string | undefined;
    code!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    deptId!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    internalStorage!: boolean | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    isShared!: boolean | undefined;
    name!: string | undefined;
    standardEfficiency!: number | undefined;
    /** 业务状态 */
    status!: number | undefined;
    tenantId!: string | undefined;
    type!: number | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;
    waitingUpdateCalendar!: string | undefined;
    yieldRatio!: number | undefined;

    constructor(data?: IWorkStation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.avatar = data["avatar"];
            this.calendarCode = data["calendarCode"];
            this.code = data["code"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.deptId = data["deptId"];
            this.id = data["id"];
            this.internalStorage = data["internalStorage"];
            this.isDeleted = data["isDeleted"];
            this.isShared = data["isShared"];
            this.name = data["name"];
            this.standardEfficiency = data["standardEfficiency"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.type = data["type"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
            this.waitingUpdateCalendar = data["waitingUpdateCalendar"];
            this.yieldRatio = data["yieldRatio"];
        }
    }

    static fromJS(data: any): WorkStation {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatar"] = this.avatar;
        data["calendarCode"] = this.calendarCode;
        data["code"] = this.code;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["deptId"] = this.deptId;
        data["id"] = this.id;
        data["internalStorage"] = this.internalStorage;
        data["isDeleted"] = this.isDeleted;
        data["isShared"] = this.isShared;
        data["name"] = this.name;
        data["standardEfficiency"] = this.standardEfficiency;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["type"] = this.type;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        data["waitingUpdateCalendar"] = this.waitingUpdateCalendar;
        data["yieldRatio"] = this.yieldRatio;
        return data; 
    }
}

export interface IWorkStation {
    avatar: string | undefined;
    calendarCode: string | undefined;
    code: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    deptId: string | undefined;
    /** 主键id */
    id: string | undefined;
    internalStorage: boolean | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    isShared: boolean | undefined;
    name: string | undefined;
    standardEfficiency: number | undefined;
    /** 业务状态 */
    status: number | undefined;
    tenantId: string | undefined;
    type: number | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
    waitingUpdateCalendar: string | undefined;
    yieldRatio: number | undefined;
}

export class WorkStationAddToGroupDTO implements IWorkStationAddToGroupDTO {
    groupId!: string[] | undefined;
    workStationId!: string | undefined;

    constructor(data?: IWorkStationAddToGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["groupId"] && data["groupId"].constructor === Array) {
                this.groupId = [] as any;
                for (let item of data["groupId"])
                    this.groupId!.push(item);
            }
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): WorkStationAddToGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationAddToGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.groupId && this.groupId.constructor === Array) {
            data["groupId"] = [];
            for (let item of this.groupId)
                data["groupId"].push(item);
        }
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IWorkStationAddToGroupDTO {
    groupId: string[] | undefined;
    workStationId: string | undefined;
}

export class WorkStationBO implements IWorkStationBO {
    calendarCode!: string | undefined;
    /** 工位编码 */
    code!: string | undefined;
    id!: string | undefined;
    /** 工位名字 */
    name!: string | undefined;
    standardEfficiency!: number | undefined;
    /** 产量倍率 */
    yieldRatio!: number | undefined;

    constructor(data?: IWorkStationBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calendarCode = data["calendarCode"];
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.standardEfficiency = data["standardEfficiency"];
            this.yieldRatio = data["yieldRatio"];
        }
    }

    static fromJS(data: any): WorkStationBO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarCode"] = this.calendarCode;
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["standardEfficiency"] = this.standardEfficiency;
        data["yieldRatio"] = this.yieldRatio;
        return data; 
    }
}

export interface IWorkStationBO {
    calendarCode: string | undefined;
    /** 工位编码 */
    code: string | undefined;
    id: string | undefined;
    /** 工位名字 */
    name: string | undefined;
    standardEfficiency: number | undefined;
    /** 产量倍率 */
    yieldRatio: number | undefined;
}

export class WorkStationBatchBoundCalendarDTO implements IWorkStationBatchBoundCalendarDTO {
    /** 等待更新的生产日历code */
    waitingUpdateCalendar!: string | undefined;
    /** 工位id */
    workStationId!: string[] | undefined;

    constructor(data?: IWorkStationBatchBoundCalendarDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.waitingUpdateCalendar = data["waitingUpdateCalendar"];
            if (data["workStationId"] && data["workStationId"].constructor === Array) {
                this.workStationId = [] as any;
                for (let item of data["workStationId"])
                    this.workStationId!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkStationBatchBoundCalendarDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationBatchBoundCalendarDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waitingUpdateCalendar"] = this.waitingUpdateCalendar;
        if (this.workStationId && this.workStationId.constructor === Array) {
            data["workStationId"] = [];
            for (let item of this.workStationId)
                data["workStationId"].push(item);
        }
        return data; 
    }
}

export interface IWorkStationBatchBoundCalendarDTO {
    /** 等待更新的生产日历code */
    waitingUpdateCalendar: string | undefined;
    /** 工位id */
    workStationId: string[] | undefined;
}

/** 工位简要信息 */
export class WorkStationBriefVO implements IWorkStationBriefVO {
    /** 生产日历编码 */
    calendarCode!: string | undefined;
    /** 工位编号 */
    code!: string | undefined;
    /** 职权域id */
    deptId!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 工位名称 */
    name!: string | undefined;
    /** 标准效率 */
    standardEfficiency!: number | undefined;
    /** 工位类型 */
    type!: number | undefined;
    /** 等待生产日历编码 */
    waitingUpdateCalendar!: string | undefined;
    /** 产量倍率 */
    yieldRatio!: number | undefined;

    constructor(data?: IWorkStationBriefVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calendarCode = data["calendarCode"];
            this.code = data["code"];
            this.deptId = data["deptId"];
            this.id = data["id"];
            this.name = data["name"];
            this.standardEfficiency = data["standardEfficiency"];
            this.type = data["type"];
            this.waitingUpdateCalendar = data["waitingUpdateCalendar"];
            this.yieldRatio = data["yieldRatio"];
        }
    }

    static fromJS(data: any): WorkStationBriefVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationBriefVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarCode"] = this.calendarCode;
        data["code"] = this.code;
        data["deptId"] = this.deptId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["standardEfficiency"] = this.standardEfficiency;
        data["type"] = this.type;
        data["waitingUpdateCalendar"] = this.waitingUpdateCalendar;
        data["yieldRatio"] = this.yieldRatio;
        return data; 
    }
}

/** 工位简要信息 */
export interface IWorkStationBriefVO {
    /** 生产日历编码 */
    calendarCode: string | undefined;
    /** 工位编号 */
    code: string | undefined;
    /** 职权域id */
    deptId: string | undefined;
    /** id */
    id: string | undefined;
    /** 工位名称 */
    name: string | undefined;
    /** 标准效率 */
    standardEfficiency: number | undefined;
    /** 工位类型 */
    type: number | undefined;
    /** 等待生产日历编码 */
    waitingUpdateCalendar: string | undefined;
    /** 产量倍率 */
    yieldRatio: number | undefined;
}

export class WorkStationConditionStatusCodeDTO implements IWorkStationConditionStatusCodeDTO {
    /** workStationCodeList */
    workStationCodeList!: string[] | undefined;

    constructor(data?: IWorkStationConditionStatusCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["workStationCodeList"] && data["workStationCodeList"].constructor === Array) {
                this.workStationCodeList = [] as any;
                for (let item of data["workStationCodeList"])
                    this.workStationCodeList!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkStationConditionStatusCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationConditionStatusCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.workStationCodeList && this.workStationCodeList.constructor === Array) {
            data["workStationCodeList"] = [];
            for (let item of this.workStationCodeList)
                data["workStationCodeList"].push(item);
        }
        return data; 
    }
}

export interface IWorkStationConditionStatusCodeDTO {
    /** workStationCodeList */
    workStationCodeList: string[] | undefined;
}

export class WorkStationConditionStatusCollectVO implements IWorkStationConditionStatusCollectVO {
    /** 采集状态 */
    collectStatus!: number | undefined;
    /** 采集状态名称 */
    collectStatusName!: string | undefined;
    /** 工位名称 */
    workStationCode!: string | undefined;

    constructor(data?: IWorkStationConditionStatusCollectVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.collectStatus = data["collectStatus"];
            this.collectStatusName = data["collectStatusName"];
            this.workStationCode = data["workStationCode"];
        }
    }

    static fromJS(data: any): WorkStationConditionStatusCollectVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationConditionStatusCollectVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectStatus"] = this.collectStatus;
        data["collectStatusName"] = this.collectStatusName;
        data["workStationCode"] = this.workStationCode;
        return data; 
    }
}

export interface IWorkStationConditionStatusCollectVO {
    /** 采集状态 */
    collectStatus: number | undefined;
    /** 采集状态名称 */
    collectStatusName: string | undefined;
    /** 工位名称 */
    workStationCode: string | undefined;
}

export class WorkStationDTO implements IWorkStationDTO {
    /** 过滤器[工位编号/名称] */
    filter!: string | undefined;

    constructor(data?: IWorkStationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): WorkStationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IWorkStationDTO {
    /** 过滤器[工位编号/名称] */
    filter: string | undefined;
}

export class WorkStationGroupDTO implements IWorkStationGroupDTO {
    /** 工位组Id */
    id!: string | undefined;
    /** 工位组名称 */
    name!: string | undefined;
    /** 工位组的父级Id */
    parentId!: string | undefined;

    constructor(data?: IWorkStationGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.parentId = data["parentId"];
        }
    }

    static fromJS(data: any): WorkStationGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data; 
    }
}

export interface IWorkStationGroupDTO {
    /** 工位组Id */
    id: string | undefined;
    /** 工位组名称 */
    name: string | undefined;
    /** 工位组的父级Id */
    parentId: string | undefined;
}

export class WorkStationGroupListVO implements IWorkStationGroupListVO {
    /** 工位组列表VO */
    workStationGroupDTOList!: WorkStationGroupDTO[] | undefined;

    constructor(data?: IWorkStationGroupListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["workStationGroupDTOList"] && data["workStationGroupDTOList"].constructor === Array) {
                this.workStationGroupDTOList = [] as any;
                for (let item of data["workStationGroupDTOList"])
                    this.workStationGroupDTOList!.push(WorkStationGroupDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkStationGroupListVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationGroupListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.workStationGroupDTOList && this.workStationGroupDTOList.constructor === Array) {
            data["workStationGroupDTOList"] = [];
            for (let item of this.workStationGroupDTOList)
                data["workStationGroupDTOList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWorkStationGroupListVO {
    /** 工位组列表VO */
    workStationGroupDTOList: WorkStationGroupDTO[] | undefined;
}

export class WorkStationGroupVO implements IWorkStationGroupVO {
    creatTime!: string | undefined;
    groupId!: string | undefined;
    name!: string | undefined;
    workStationId!: string | undefined;

    constructor(data?: IWorkStationGroupVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creatTime = data["creatTime"];
            this.groupId = data["groupId"];
            this.name = data["name"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): WorkStationGroupVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationGroupVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatTime"] = this.creatTime;
        data["groupId"] = this.groupId;
        data["name"] = this.name;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IWorkStationGroupVO {
    creatTime: string | undefined;
    groupId: string | undefined;
    name: string | undefined;
    workStationId: string | undefined;
}

/** 工位信息 */
export class WorkStationIdCodeNameVO implements IWorkStationIdCodeNameVO {
    /** 工位编码 */
    code!: string | undefined;
    /** 工位编码 */
    name!: string | undefined;
    /** 工位id */
    workStationId!: string | undefined;

    constructor(data?: IWorkStationIdCodeNameVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): WorkStationIdCodeNameVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationIdCodeNameVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

/** 工位信息 */
export interface IWorkStationIdCodeNameVO {
    /** 工位编码 */
    code: string | undefined;
    /** 工位编码 */
    name: string | undefined;
    /** 工位id */
    workStationId: string | undefined;
}

export class WorkStationInGroupVO implements IWorkStationInGroupVO {
    /** 工位组工位编号 */
    code!: string | undefined;
    /** 工位组工位id */
    id!: string | undefined;
    /** 是否是工位组 */
    isGroup!: boolean | undefined;
    /** 是否是工位 */
    isWorkStation!: boolean | undefined;
    /** 工位组工位父级id */
    parentId!: string | undefined;
    /** 标准效率 */
    standardEfficiency!: number | undefined;
    /** 工位组工位标题 */
    title!: string | undefined;

    constructor(data?: IWorkStationInGroupVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.isGroup = data["isGroup"];
            this.isWorkStation = data["isWorkStation"];
            this.parentId = data["parentId"];
            this.standardEfficiency = data["standardEfficiency"];
            this.title = data["title"];
        }
    }

    static fromJS(data: any): WorkStationInGroupVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationInGroupVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["isGroup"] = this.isGroup;
        data["isWorkStation"] = this.isWorkStation;
        data["parentId"] = this.parentId;
        data["standardEfficiency"] = this.standardEfficiency;
        data["title"] = this.title;
        return data; 
    }
}

export interface IWorkStationInGroupVO {
    /** 工位组工位编号 */
    code: string | undefined;
    /** 工位组工位id */
    id: string | undefined;
    /** 是否是工位组 */
    isGroup: boolean | undefined;
    /** 是否是工位 */
    isWorkStation: boolean | undefined;
    /** 工位组工位父级id */
    parentId: string | undefined;
    /** 标准效率 */
    standardEfficiency: number | undefined;
    /** 工位组工位标题 */
    title: string | undefined;
}

/** 工位信息及所属工位组 */
export class WorkStationInsertGroupVO implements IWorkStationInsertGroupVO {
    /** 生产日历编码 */
    calendarCode!: string | undefined;
    /** 工位编号 */
    code!: string | undefined;
    /** 职权域id */
    deptId!: string | undefined;
    groupId!: string[] | undefined;
    /** id */
    id!: string | undefined;
    /** 内部存储 */
    internalStorage!: boolean | undefined;
    /** 工位名称 */
    name!: string | undefined;
    /** 标准效率 */
    standardEfficiency!: number | undefined;
    /** 工位类型 */
    type!: number | undefined;
    /** 等待生产日历编码 */
    waitingUpdateCalendar!: string | undefined;
    /** 产量倍率 */
    yieldRatio!: number | undefined;

    constructor(data?: IWorkStationInsertGroupVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calendarCode = data["calendarCode"];
            this.code = data["code"];
            this.deptId = data["deptId"];
            if (data["groupId"] && data["groupId"].constructor === Array) {
                this.groupId = [] as any;
                for (let item of data["groupId"])
                    this.groupId!.push(item);
            }
            this.id = data["id"];
            this.internalStorage = data["internalStorage"];
            this.name = data["name"];
            this.standardEfficiency = data["standardEfficiency"];
            this.type = data["type"];
            this.waitingUpdateCalendar = data["waitingUpdateCalendar"];
            this.yieldRatio = data["yieldRatio"];
        }
    }

    static fromJS(data: any): WorkStationInsertGroupVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationInsertGroupVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarCode"] = this.calendarCode;
        data["code"] = this.code;
        data["deptId"] = this.deptId;
        if (this.groupId && this.groupId.constructor === Array) {
            data["groupId"] = [];
            for (let item of this.groupId)
                data["groupId"].push(item);
        }
        data["id"] = this.id;
        data["internalStorage"] = this.internalStorage;
        data["name"] = this.name;
        data["standardEfficiency"] = this.standardEfficiency;
        data["type"] = this.type;
        data["waitingUpdateCalendar"] = this.waitingUpdateCalendar;
        data["yieldRatio"] = this.yieldRatio;
        return data; 
    }
}

/** 工位信息及所属工位组 */
export interface IWorkStationInsertGroupVO {
    /** 生产日历编码 */
    calendarCode: string | undefined;
    /** 工位编号 */
    code: string | undefined;
    /** 职权域id */
    deptId: string | undefined;
    groupId: string[] | undefined;
    /** id */
    id: string | undefined;
    /** 内部存储 */
    internalStorage: boolean | undefined;
    /** 工位名称 */
    name: string | undefined;
    /** 标准效率 */
    standardEfficiency: number | undefined;
    /** 工位类型 */
    type: number | undefined;
    /** 等待生产日历编码 */
    waitingUpdateCalendar: string | undefined;
    /** 产量倍率 */
    yieldRatio: number | undefined;
}

export class WorkStationIot implements IWorkStationIot {
    feature!: number | undefined;
    id!: string | undefined;
    iotCode!: string | undefined;
    iotId!: string | undefined;
    iotName!: string | undefined;
    iotVersion!: number | undefined;
    workStationCode!: string | undefined;
    workStationId!: string | undefined;

    constructor(data?: IWorkStationIot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.feature = data["feature"];
            this.id = data["id"];
            this.iotCode = data["iotCode"];
            this.iotId = data["iotId"];
            this.iotName = data["iotName"];
            this.iotVersion = data["iotVersion"];
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): WorkStationIot {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationIot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feature"] = this.feature;
        data["id"] = this.id;
        data["iotCode"] = this.iotCode;
        data["iotId"] = this.iotId;
        data["iotName"] = this.iotName;
        data["iotVersion"] = this.iotVersion;
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IWorkStationIot {
    feature: number | undefined;
    id: string | undefined;
    iotCode: string | undefined;
    iotId: string | undefined;
    iotName: string | undefined;
    iotVersion: number | undefined;
    workStationCode: string | undefined;
    workStationId: string | undefined;
}

export class WorkStationIotDTO implements IWorkStationIotDTO {
    /** iot网关编号 */
    iotCode!: string | undefined;
    /** iot网关id */
    iotId!: string | undefined;
    /** iot网关编号 */
    iotName!: string | undefined;
    /** iot网关版本 0 旧版本 | 1 新版本 */
    iotVersion!: number | undefined;
    /** 工位编号 */
    workStationCode!: string | undefined;
    /** 工位id */
    workStationId!: string | undefined;

    constructor(data?: IWorkStationIotDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.iotCode = data["iotCode"];
            this.iotId = data["iotId"];
            this.iotName = data["iotName"];
            this.iotVersion = data["iotVersion"];
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): WorkStationIotDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationIotDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iotCode"] = this.iotCode;
        data["iotId"] = this.iotId;
        data["iotName"] = this.iotName;
        data["iotVersion"] = this.iotVersion;
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IWorkStationIotDTO {
    /** iot网关编号 */
    iotCode: string | undefined;
    /** iot网关id */
    iotId: string | undefined;
    /** iot网关编号 */
    iotName: string | undefined;
    /** iot网关版本 0 旧版本 | 1 新版本 */
    iotVersion: number | undefined;
    /** 工位编号 */
    workStationCode: string | undefined;
    /** 工位id */
    workStationId: string | undefined;
}

/** 工况设定同步 */
export class WorkStationParamSettingDTO implements IWorkStationParamSettingDTO {
    /** 设定ID */
    settingId!: string | undefined;
    /** 工位ID集合 */
    workStationIds!: string[] | undefined;

    constructor(data?: IWorkStationParamSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.settingId = data["settingId"];
            if (data["workStationIds"] && data["workStationIds"].constructor === Array) {
                this.workStationIds = [] as any;
                for (let item of data["workStationIds"])
                    this.workStationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkStationParamSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationParamSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingId"] = this.settingId;
        if (this.workStationIds && this.workStationIds.constructor === Array) {
            data["workStationIds"] = [];
            for (let item of this.workStationIds)
                data["workStationIds"].push(item);
        }
        return data; 
    }
}

/** 工况设定同步 */
export interface IWorkStationParamSettingDTO {
    /** 设定ID */
    settingId: string | undefined;
    /** 工位ID集合 */
    workStationIds: string[] | undefined;
}

export class WorkStationRealTimeStatusDTO implements IWorkStationRealTimeStatusDTO {
    /** 工位组Id */
    workStationGroupIdList!: string[] | undefined;

    constructor(data?: IWorkStationRealTimeStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["workStationGroupIdList"] && data["workStationGroupIdList"].constructor === Array) {
                this.workStationGroupIdList = [] as any;
                for (let item of data["workStationGroupIdList"])
                    this.workStationGroupIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkStationRealTimeStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationRealTimeStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.workStationGroupIdList && this.workStationGroupIdList.constructor === Array) {
            data["workStationGroupIdList"] = [];
            for (let item of this.workStationGroupIdList)
                data["workStationGroupIdList"].push(item);
        }
        return data; 
    }
}

export interface IWorkStationRealTimeStatusDTO {
    /** 工位组Id */
    workStationGroupIdList: string[] | undefined;
}

export class WorkStationRealTimeStatusVO implements IWorkStationRealTimeStatusVO {
    /** 工位采集数量 */
    collectionNum!: number | undefined;
    /** 工位id */
    id!: string | undefined;
    /** 工位名称 */
    name!: string | undefined;
    /** 订单编码 */
    orderCode!: string | undefined;
    /** 生产计划编号 */
    planCode!: string | undefined;
    /** 当前加工人员名称 */
    producerName!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 工况参数 */
    workingConditionSettingVOList!: WorkingConditionSettingVO[] | undefined;

    constructor(data?: IWorkStationRealTimeStatusVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.collectionNum = data["collectionNum"];
            this.id = data["id"];
            this.name = data["name"];
            this.orderCode = data["orderCode"];
            this.planCode = data["planCode"];
            this.producerName = data["producerName"];
            this.productName = data["productName"];
            this.standardModel = data["standardModel"];
            if (data["workingConditionSettingVOList"] && data["workingConditionSettingVOList"].constructor === Array) {
                this.workingConditionSettingVOList = [] as any;
                for (let item of data["workingConditionSettingVOList"])
                    this.workingConditionSettingVOList!.push(WorkingConditionSettingVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkStationRealTimeStatusVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationRealTimeStatusVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectionNum"] = this.collectionNum;
        data["id"] = this.id;
        data["name"] = this.name;
        data["orderCode"] = this.orderCode;
        data["planCode"] = this.planCode;
        data["producerName"] = this.producerName;
        data["productName"] = this.productName;
        data["standardModel"] = this.standardModel;
        if (this.workingConditionSettingVOList && this.workingConditionSettingVOList.constructor === Array) {
            data["workingConditionSettingVOList"] = [];
            for (let item of this.workingConditionSettingVOList)
                data["workingConditionSettingVOList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWorkStationRealTimeStatusVO {
    /** 工位采集数量 */
    collectionNum: number | undefined;
    /** 工位id */
    id: string | undefined;
    /** 工位名称 */
    name: string | undefined;
    /** 订单编码 */
    orderCode: string | undefined;
    /** 生产计划编号 */
    planCode: string | undefined;
    /** 当前加工人员名称 */
    producerName: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 工况参数 */
    workingConditionSettingVOList: WorkingConditionSettingVO[] | undefined;
}

export class WorkStationShiftIndexNameQueryDTO implements IWorkStationShiftIndexNameQueryDTO {
    /** 结束时间 */
    endDate!: Date | undefined;
    /** 班次下标集合 */
    shiftIndexList!: number[] | undefined;
    /** 开始时间 */
    startDate!: Date | undefined;
    /** 工位id */
    workStationIdList!: string[] | undefined;

    constructor(data?: IWorkStationShiftIndexNameQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            if (data["shiftIndexList"] && data["shiftIndexList"].constructor === Array) {
                this.shiftIndexList = [] as any;
                for (let item of data["shiftIndexList"])
                    this.shiftIndexList!.push(item);
            }
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            if (data["workStationIdList"] && data["workStationIdList"].constructor === Array) {
                this.workStationIdList = [] as any;
                for (let item of data["workStationIdList"])
                    this.workStationIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkStationShiftIndexNameQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationShiftIndexNameQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        if (this.shiftIndexList && this.shiftIndexList.constructor === Array) {
            data["shiftIndexList"] = [];
            for (let item of this.shiftIndexList)
                data["shiftIndexList"].push(item);
        }
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        if (this.workStationIdList && this.workStationIdList.constructor === Array) {
            data["workStationIdList"] = [];
            for (let item of this.workStationIdList)
                data["workStationIdList"].push(item);
        }
        return data; 
    }
}

export interface IWorkStationShiftIndexNameQueryDTO {
    /** 结束时间 */
    endDate: Date | undefined;
    /** 班次下标集合 */
    shiftIndexList: number[] | undefined;
    /** 开始时间 */
    startDate: Date | undefined;
    /** 工位id */
    workStationIdList: string[] | undefined;
}

/** 工位提交 */
export class WorkStationSubmitDTO implements IWorkStationSubmitDTO {
    /** 生产日历编码 */
    calendarCode!: string | undefined;
    /** 工位编号 */
    code!: string;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 职权域id */
    deptId!: string | undefined;
    /** 工位组id */
    groupId!: string[] | undefined;
    /** 内部存储 */
    internalStorage!: boolean | undefined;
    /** 工位名称 */
    name!: string;
    /** 标准效率 */
    standardEfficiency!: number | undefined;
    /** 工位类型 */
    type!: number;
    /** 产量倍率 */
    yieldRatio!: number | undefined;

    constructor(data?: IWorkStationSubmitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calendarCode = data["calendarCode"];
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.deptId = data["deptId"];
            if (data["groupId"] && data["groupId"].constructor === Array) {
                this.groupId = [] as any;
                for (let item of data["groupId"])
                    this.groupId!.push(item);
            }
            this.internalStorage = data["internalStorage"];
            this.name = data["name"];
            this.standardEfficiency = data["standardEfficiency"];
            this.type = data["type"];
            this.yieldRatio = data["yieldRatio"];
        }
    }

    static fromJS(data: any): WorkStationSubmitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationSubmitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarCode"] = this.calendarCode;
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["deptId"] = this.deptId;
        if (this.groupId && this.groupId.constructor === Array) {
            data["groupId"] = [];
            for (let item of this.groupId)
                data["groupId"].push(item);
        }
        data["internalStorage"] = this.internalStorage;
        data["name"] = this.name;
        data["standardEfficiency"] = this.standardEfficiency;
        data["type"] = this.type;
        data["yieldRatio"] = this.yieldRatio;
        return data; 
    }
}

/** 工位提交 */
export interface IWorkStationSubmitDTO {
    /** 生产日历编码 */
    calendarCode: string | undefined;
    /** 工位编号 */
    code: string;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 职权域id */
    deptId: string | undefined;
    /** 工位组id */
    groupId: string[] | undefined;
    /** 内部存储 */
    internalStorage: boolean | undefined;
    /** 工位名称 */
    name: string;
    /** 标准效率 */
    standardEfficiency: number | undefined;
    /** 工位类型 */
    type: number;
    /** 产量倍率 */
    yieldRatio: number | undefined;
}

/** 工位信息 */
export class WorkStationToDncVO implements IWorkStationToDncVO {
    /** 工位图片地址 */
    avatar!: string | undefined;
    /** 生产日历编码 */
    calendarCode!: string | undefined;
    /** 工位编号 */
    code!: string | undefined;
    /** 职权域id */
    deptId!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 内部存储 */
    internalStorage!: boolean | undefined;
    iotAppCode!: number | undefined;
    /** iot编码 */
    iotCode!: string | undefined;
    isShared!: boolean | undefined;
    /** 工位名称 */
    name!: string | undefined;
    standardEfficiency!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 工位类型：空、机器、人工 */
    type!: number | undefined;
    /** 等待更新的生产日历编码 */
    waitingUpdateCalendar!: string | undefined;
    /** 产量倍率 */
    yieldRatio!: number | undefined;

    constructor(data?: IWorkStationToDncVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.avatar = data["avatar"];
            this.calendarCode = data["calendarCode"];
            this.code = data["code"];
            this.deptId = data["deptId"];
            this.id = data["id"];
            this.internalStorage = data["internalStorage"];
            this.iotAppCode = data["iotAppCode"];
            this.iotCode = data["iotCode"];
            this.isShared = data["isShared"];
            this.name = data["name"];
            this.standardEfficiency = data["standardEfficiency"];
            this.tenantId = data["tenantId"];
            this.type = data["type"];
            this.waitingUpdateCalendar = data["waitingUpdateCalendar"];
            this.yieldRatio = data["yieldRatio"];
        }
    }

    static fromJS(data: any): WorkStationToDncVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationToDncVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatar"] = this.avatar;
        data["calendarCode"] = this.calendarCode;
        data["code"] = this.code;
        data["deptId"] = this.deptId;
        data["id"] = this.id;
        data["internalStorage"] = this.internalStorage;
        data["iotAppCode"] = this.iotAppCode;
        data["iotCode"] = this.iotCode;
        data["isShared"] = this.isShared;
        data["name"] = this.name;
        data["standardEfficiency"] = this.standardEfficiency;
        data["tenantId"] = this.tenantId;
        data["type"] = this.type;
        data["waitingUpdateCalendar"] = this.waitingUpdateCalendar;
        data["yieldRatio"] = this.yieldRatio;
        return data; 
    }
}

/** 工位信息 */
export interface IWorkStationToDncVO {
    /** 工位图片地址 */
    avatar: string | undefined;
    /** 生产日历编码 */
    calendarCode: string | undefined;
    /** 工位编号 */
    code: string | undefined;
    /** 职权域id */
    deptId: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 内部存储 */
    internalStorage: boolean | undefined;
    iotAppCode: number | undefined;
    /** iot编码 */
    iotCode: string | undefined;
    isShared: boolean | undefined;
    /** 工位名称 */
    name: string | undefined;
    standardEfficiency: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 工位类型：空、机器、人工 */
    type: number | undefined;
    /** 等待更新的生产日历编码 */
    waitingUpdateCalendar: string | undefined;
    /** 产量倍率 */
    yieldRatio: number | undefined;
}

export class WorkStationTransferSettingDTO implements IWorkStationTransferSettingDTO {
    /** 主键Id */
    id!: string | undefined;
    /** transferDirectoryId */
    transferDirectoryId!: string | undefined;
    /** workStationId */
    workStationId!: string | undefined;

    constructor(data?: IWorkStationTransferSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.transferDirectoryId = data["transferDirectoryId"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): WorkStationTransferSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationTransferSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transferDirectoryId"] = this.transferDirectoryId;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IWorkStationTransferSettingDTO {
    /** 主键Id */
    id: string | undefined;
    /** transferDirectoryId */
    transferDirectoryId: string | undefined;
    /** workStationId */
    workStationId: string | undefined;
}

export class WorkStationTransferSettingVO implements IWorkStationTransferSettingVO {
    /** 主键Id */
    id!: string | undefined;
    /** transferDirectoryId */
    transferDirectoryId!: string | undefined;
    /** workStationId */
    workStationId!: string | undefined;

    constructor(data?: IWorkStationTransferSettingVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.transferDirectoryId = data["transferDirectoryId"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): WorkStationTransferSettingVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationTransferSettingVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transferDirectoryId"] = this.transferDirectoryId;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IWorkStationTransferSettingVO {
    /** 主键Id */
    id: string | undefined;
    /** transferDirectoryId */
    transferDirectoryId: string | undefined;
    /** workStationId */
    workStationId: string | undefined;
}

/** 设备状态可视化 */
export class WorkStationVisualVO implements IWorkStationVisualVO {
    /** 状态对应的数量：key分别是【设备运行、设备等待、设备报警、设备离线、未知状态、网络断线】 */
    deviceStatus!: { [key: string] : number; } | undefined;

    constructor(data?: IWorkStationVisualVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["deviceStatus"]) {
                this.deviceStatus = {} as any;
                for (let key in data["deviceStatus"]) {
                    if (data["deviceStatus"].hasOwnProperty(key))
                        this.deviceStatus![key] = data["deviceStatus"][key];
                }
            }
        }
    }

    static fromJS(data: any): WorkStationVisualVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationVisualVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.deviceStatus) {
            data["deviceStatus"] = {};
            for (let key in this.deviceStatus) {
                if (this.deviceStatus.hasOwnProperty(key))
                    data["deviceStatus"][key] = this.deviceStatus[key];
            }
        }
        return data; 
    }
}

/** 设备状态可视化 */
export interface IWorkStationVisualVO {
    /** 状态对应的数量：key分别是【设备运行、设备等待、设备报警、设备离线、未知状态、网络断线】 */
    deviceStatus: { [key: string] : number; } | undefined;
}

export class WorkStationWcsEditDTO implements IWorkStationWcsEditDTO {
    /** wcs值 */
    code!: number | undefined;
    /** wcs颜色 */
    color!: string | undefined;
    /** 单条id */
    id!: string | undefined;
    /** wcs名称 */
    name!: string | undefined;

    constructor(data?: IWorkStationWcsEditDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.color = data["color"];
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): WorkStationWcsEditDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationWcsEditDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["color"] = this.color;
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IWorkStationWcsEditDTO {
    /** wcs值 */
    code: number | undefined;
    /** wcs颜色 */
    color: string | undefined;
    /** 单条id */
    id: string | undefined;
    /** wcs名称 */
    name: string | undefined;
}

export class WorkStationWcsVO implements IWorkStationWcsVO {
    /** 编辑删除标记：0-不可删除编辑，1-可删除编辑 */
    canEditor!: number | undefined;
    /** wcs的值 */
    code!: number | undefined;
    /** wcs颜色 */
    color!: string | undefined;
    /** id */
    id!: string | undefined;
    /** wcs名称 */
    name!: string | undefined;

    constructor(data?: IWorkStationWcsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canEditor = data["canEditor"];
            this.code = data["code"];
            this.color = data["color"];
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): WorkStationWcsVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationWcsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canEditor"] = this.canEditor;
        data["code"] = this.code;
        data["color"] = this.color;
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IWorkStationWcsVO {
    /** 编辑删除标记：0-不可删除编辑，1-可删除编辑 */
    canEditor: number | undefined;
    /** wcs的值 */
    code: number | undefined;
    /** wcs颜色 */
    color: string | undefined;
    /** id */
    id: string | undefined;
    /** wcs名称 */
    name: string | undefined;
}

/** 工况参数提交 */
export class WorkingConditionParamSubmitDTO implements IWorkingConditionParamSubmitDTO {
    /** 业务类型[产量/报警等] */
    bizType!: number | undefined;
    /** iot应用编号[名称] */
    iotAppCode!: string | undefined;
    /** iot应用id */
    iotAppId!: string | undefined;
    /** iot应用属性描述[名称] */
    iotAppParamDesc!: string | undefined;
    /** iot应用属性id[采集项] */
    iotAppParamId!: string | undefined;
    /** iot编号 */
    iotCode!: string | undefined;
    /** iot设备id */
    iotId!: string | undefined;
    /** iot名称 */
    iotName!: string | undefined;
    /** 参数描述[名称] */
    paramDesc!: string | undefined;
    /** 参数多语言key */
    paramDescI18nKey!: string | undefined;
    /** 单位 */
    unit!: string | undefined;
    /** 工位编号 */
    workStationCode!: string | undefined;
    /** 工位id */
    workStationId!: string | undefined;

    constructor(data?: IWorkingConditionParamSubmitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bizType = data["bizType"];
            this.iotAppCode = data["iotAppCode"];
            this.iotAppId = data["iotAppId"];
            this.iotAppParamDesc = data["iotAppParamDesc"];
            this.iotAppParamId = data["iotAppParamId"];
            this.iotCode = data["iotCode"];
            this.iotId = data["iotId"];
            this.iotName = data["iotName"];
            this.paramDesc = data["paramDesc"];
            this.paramDescI18nKey = data["paramDescI18nKey"];
            this.unit = data["unit"];
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): WorkingConditionParamSubmitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingConditionParamSubmitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bizType"] = this.bizType;
        data["iotAppCode"] = this.iotAppCode;
        data["iotAppId"] = this.iotAppId;
        data["iotAppParamDesc"] = this.iotAppParamDesc;
        data["iotAppParamId"] = this.iotAppParamId;
        data["iotCode"] = this.iotCode;
        data["iotId"] = this.iotId;
        data["iotName"] = this.iotName;
        data["paramDesc"] = this.paramDesc;
        data["paramDescI18nKey"] = this.paramDescI18nKey;
        data["unit"] = this.unit;
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

/** 工况参数提交 */
export interface IWorkingConditionParamSubmitDTO {
    /** 业务类型[产量/报警等] */
    bizType: number | undefined;
    /** iot应用编号[名称] */
    iotAppCode: string | undefined;
    /** iot应用id */
    iotAppId: string | undefined;
    /** iot应用属性描述[名称] */
    iotAppParamDesc: string | undefined;
    /** iot应用属性id[采集项] */
    iotAppParamId: string | undefined;
    /** iot编号 */
    iotCode: string | undefined;
    /** iot设备id */
    iotId: string | undefined;
    /** iot名称 */
    iotName: string | undefined;
    /** 参数描述[名称] */
    paramDesc: string | undefined;
    /** 参数多语言key */
    paramDescI18nKey: string | undefined;
    /** 单位 */
    unit: string | undefined;
    /** 工位编号 */
    workStationCode: string | undefined;
    /** 工位id */
    workStationId: string | undefined;
}

/** 工况参数 */
export class WorkingConditionParamVO implements IWorkingConditionParamVO {
    /** 业务类型[产量/报警等] */
    bizType!: number | undefined;
    /** id */
    id!: string | undefined;
    /** iot应用编号[名称] */
    iotAppCode!: string | undefined;
    /** iot应用id */
    iotAppId!: string | undefined;
    /** iot应用属性描述[名称] */
    iotAppParamDesc!: string | undefined;
    /** iot应用属性id[采集项] */
    iotAppParamId!: string | undefined;
    /** iot编号 */
    iotCode!: string | undefined;
    /** iot设备id */
    iotId!: string | undefined;
    /** iot名称 */
    iotName!: string | undefined;
    /** 新旧网关标识 */
    iotVersion!: number | undefined;
    /** 参数描述[名称] */
    paramDesc!: string | undefined;
    /** 参数多语言key */
    paramDescI18nKey!: string | undefined;
    /** 单位 */
    unit!: string | undefined;
    /** 工况参数最新值 */
    value!: any | undefined;
    /** 工位编号 */
    workStationCode!: string | undefined;
    /** 工位id */
    workStationId!: string | undefined;

    constructor(data?: IWorkingConditionParamVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bizType = data["bizType"];
            this.id = data["id"];
            this.iotAppCode = data["iotAppCode"];
            this.iotAppId = data["iotAppId"];
            this.iotAppParamDesc = data["iotAppParamDesc"];
            this.iotAppParamId = data["iotAppParamId"];
            this.iotCode = data["iotCode"];
            this.iotId = data["iotId"];
            this.iotName = data["iotName"];
            this.iotVersion = data["iotVersion"];
            this.paramDesc = data["paramDesc"];
            this.paramDescI18nKey = data["paramDescI18nKey"];
            this.unit = data["unit"];
            this.value = data["value"];
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): WorkingConditionParamVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingConditionParamVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bizType"] = this.bizType;
        data["id"] = this.id;
        data["iotAppCode"] = this.iotAppCode;
        data["iotAppId"] = this.iotAppId;
        data["iotAppParamDesc"] = this.iotAppParamDesc;
        data["iotAppParamId"] = this.iotAppParamId;
        data["iotCode"] = this.iotCode;
        data["iotId"] = this.iotId;
        data["iotName"] = this.iotName;
        data["iotVersion"] = this.iotVersion;
        data["paramDesc"] = this.paramDesc;
        data["paramDescI18nKey"] = this.paramDescI18nKey;
        data["unit"] = this.unit;
        data["value"] = this.value;
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

/** 工况参数 */
export interface IWorkingConditionParamVO {
    /** 业务类型[产量/报警等] */
    bizType: number | undefined;
    /** id */
    id: string | undefined;
    /** iot应用编号[名称] */
    iotAppCode: string | undefined;
    /** iot应用id */
    iotAppId: string | undefined;
    /** iot应用属性描述[名称] */
    iotAppParamDesc: string | undefined;
    /** iot应用属性id[采集项] */
    iotAppParamId: string | undefined;
    /** iot编号 */
    iotCode: string | undefined;
    /** iot设备id */
    iotId: string | undefined;
    /** iot名称 */
    iotName: string | undefined;
    /** 新旧网关标识 */
    iotVersion: number | undefined;
    /** 参数描述[名称] */
    paramDesc: string | undefined;
    /** 参数多语言key */
    paramDescI18nKey: string | undefined;
    /** 单位 */
    unit: string | undefined;
    /** 工况参数最新值 */
    value: any | undefined;
    /** 工位编号 */
    workStationCode: string | undefined;
    /** 工位id */
    workStationId: string | undefined;
}

export class WorkingConditionSettingVO implements IWorkingConditionSettingVO {
    /** 业务类型[产量/报警等] */
    bizType!: number | undefined;
    /** id */
    id!: string | undefined;
    /** iotAppId */
    iotAppId!: string | undefined;
    /** iot应用属性描述[名称] */
    iotAppParamDesc!: string | undefined;
    /** iot应用属性id[采集项] */
    iotAppParamId!: string | undefined;
    /** iotCode */
    iotCode!: string | undefined;
    /** iotId */
    iotId!: string | undefined;
    /** 参数描述[名称] */
    paramDesc!: string | undefined;
    /** 单位 */
    unit!: string | undefined;

    constructor(data?: IWorkingConditionSettingVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bizType = data["bizType"];
            this.id = data["id"];
            this.iotAppId = data["iotAppId"];
            this.iotAppParamDesc = data["iotAppParamDesc"];
            this.iotAppParamId = data["iotAppParamId"];
            this.iotCode = data["iotCode"];
            this.iotId = data["iotId"];
            this.paramDesc = data["paramDesc"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): WorkingConditionSettingVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingConditionSettingVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bizType"] = this.bizType;
        data["id"] = this.id;
        data["iotAppId"] = this.iotAppId;
        data["iotAppParamDesc"] = this.iotAppParamDesc;
        data["iotAppParamId"] = this.iotAppParamId;
        data["iotCode"] = this.iotCode;
        data["iotId"] = this.iotId;
        data["paramDesc"] = this.paramDesc;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IWorkingConditionSettingVO {
    /** 业务类型[产量/报警等] */
    bizType: number | undefined;
    /** id */
    id: string | undefined;
    /** iotAppId */
    iotAppId: string | undefined;
    /** iot应用属性描述[名称] */
    iotAppParamDesc: string | undefined;
    /** iot应用属性id[采集项] */
    iotAppParamId: string | undefined;
    /** iotCode */
    iotCode: string | undefined;
    /** iotId */
    iotId: string | undefined;
    /** 参数描述[名称] */
    paramDesc: string | undefined;
    /** 单位 */
    unit: string | undefined;
}

/** 工位信息 */
export class WorkstationCalendarShiftVO implements IWorkstationCalendarShiftVO {
    /** 下标名称集合 */
    calendarShiftVOList!: CalendarShiftVO[] | undefined;
    /** 工位id */
    workstationId!: string | undefined;

    constructor(data?: IWorkstationCalendarShiftVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["calendarShiftVOList"] && data["calendarShiftVOList"].constructor === Array) {
                this.calendarShiftVOList = [] as any;
                for (let item of data["calendarShiftVOList"])
                    this.calendarShiftVOList!.push(CalendarShiftVO.fromJS(item));
            }
            this.workstationId = data["workstationId"];
        }
    }

    static fromJS(data: any): WorkstationCalendarShiftVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkstationCalendarShiftVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.calendarShiftVOList && this.calendarShiftVOList.constructor === Array) {
            data["calendarShiftVOList"] = [];
            for (let item of this.calendarShiftVOList)
                data["calendarShiftVOList"].push(item.toJSON());
        }
        data["workstationId"] = this.workstationId;
        return data; 
    }
}

/** 工位信息 */
export interface IWorkstationCalendarShiftVO {
    /** 下标名称集合 */
    calendarShiftVOList: CalendarShiftVO[] | undefined;
    /** 工位id */
    workstationId: string | undefined;
}

export class 网关在线信息 implements I网关在线信息 {
    /** 网关应用的状态 */
    apps!: 网关应用状态信息[] | undefined;
    /** 网关状态 */
    gatewayStatus!: boolean | undefined;

    constructor(data?: I网关在线信息) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["apps"] && data["apps"].constructor === Array) {
                this.apps = [] as any;
                for (let item of data["apps"])
                    this.apps!.push(网关应用状态信息.fromJS(item));
            }
            this.gatewayStatus = data["gatewayStatus"];
        }
    }

    static fromJS(data: any): 网关在线信息 {
        data = typeof data === 'object' ? data : {};
        let result = new 网关在线信息();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.apps && this.apps.constructor === Array) {
            data["apps"] = [];
            for (let item of this.apps)
                data["apps"].push(item.toJSON());
        }
        data["gatewayStatus"] = this.gatewayStatus;
        return data; 
    }
}

export interface I网关在线信息 {
    /** 网关应用的状态 */
    apps: 网关应用状态信息[] | undefined;
    /** 网关状态 */
    gatewayStatus: boolean | undefined;
}

export class 网关应用 implements I网关应用 {
    /** ID */
    gatewayAppId!: string | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 状态 */
    state!: number | undefined;
    /** 网关类型名称 */
    typeName!: string | undefined;

    constructor(data?: I网关应用) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayAppId = data["gatewayAppId"];
            this.name = data["name"];
            this.state = data["state"];
            this.typeName = data["typeName"];
        }
    }

    static fromJS(data: any): 网关应用 {
        data = typeof data === 'object' ? data : {};
        let result = new 网关应用();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayAppId"] = this.gatewayAppId;
        data["name"] = this.name;
        data["state"] = this.state;
        data["typeName"] = this.typeName;
        return data; 
    }
}

export interface I网关应用 {
    /** ID */
    gatewayAppId: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 状态 */
    state: number | undefined;
    /** 网关类型名称 */
    typeName: string | undefined;
}

export class 网关应用_1 implements I网关应用_1 {
    /** 读写权限[1=readonly, 2=readwrite] */
    access!: number | undefined;
    /** 地址 */
    address!: string | undefined;
    /** 数据类型 */
    dataType!: string | undefined;
    /** 属性描述 */
    desc!: string | undefined;
    /** 属性Id */
    id!: string | undefined;
    /** 是否可以删除 */
    isDeletable!: string | undefined;
    /** 标识 */
    mark!: string | undefined;
    /** 属性名称 */
    name!: string | undefined;
    /** 自定义标识 */
    tag!: string | undefined;
    /** 属性单位 */
    unit!: string | undefined;
    /** 默认值 */
    value!: string | undefined;

    constructor(data?: I网关应用_1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.access = data["access"];
            this.address = data["address"];
            this.dataType = data["dataType"];
            this.desc = data["desc"];
            this.id = data["id"];
            this.isDeletable = data["isDeletable"];
            this.mark = data["mark"];
            this.name = data["name"];
            this.tag = data["tag"];
            this.unit = data["unit"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): 网关应用_1 {
        data = typeof data === 'object' ? data : {};
        let result = new 网关应用_1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access"] = this.access;
        data["address"] = this.address;
        data["dataType"] = this.dataType;
        data["desc"] = this.desc;
        data["id"] = this.id;
        data["isDeletable"] = this.isDeletable;
        data["mark"] = this.mark;
        data["name"] = this.name;
        data["tag"] = this.tag;
        data["unit"] = this.unit;
        data["value"] = this.value;
        return data; 
    }
}

export interface I网关应用_1 {
    /** 读写权限[1=readonly, 2=readwrite] */
    access: number | undefined;
    /** 地址 */
    address: string | undefined;
    /** 数据类型 */
    dataType: string | undefined;
    /** 属性描述 */
    desc: string | undefined;
    /** 属性Id */
    id: string | undefined;
    /** 是否可以删除 */
    isDeletable: string | undefined;
    /** 标识 */
    mark: string | undefined;
    /** 属性名称 */
    name: string | undefined;
    /** 自定义标识 */
    tag: string | undefined;
    /** 属性单位 */
    unit: string | undefined;
    /** 默认值 */
    value: string | undefined;
}

export class 网关应用_2 implements I网关应用_2 {
    /** 基础字段 */
    baseField!: BaseFiledDTO | undefined;
    create!: boolean | undefined;
    /** 扩展字段 */
    extendField!: ExtendFieldDTO | undefined;
    /** 网关应用ID */
    gatewayAppId!: string | undefined;
    /** 网关id */
    gatewayId!: string | undefined;
    /** 属性名称 */
    name!: string | undefined;

    constructor(data?: I网关应用_2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.baseField = data["baseField"] ? BaseFiledDTO.fromJS(data["baseField"]) : <any>undefined;
            this.create = data["create"];
            this.extendField = data["extendField"] ? ExtendFieldDTO.fromJS(data["extendField"]) : <any>undefined;
            this.gatewayAppId = data["gatewayAppId"];
            this.gatewayId = data["gatewayId"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): 网关应用_2 {
        data = typeof data === 'object' ? data : {};
        let result = new 网关应用_2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseField"] = this.baseField ? this.baseField.toJSON() : <any>undefined;
        data["create"] = this.create;
        data["extendField"] = this.extendField ? this.extendField.toJSON() : <any>undefined;
        data["gatewayAppId"] = this.gatewayAppId;
        data["gatewayId"] = this.gatewayId;
        data["name"] = this.name;
        return data; 
    }
}

export interface I网关应用_2 {
    /** 基础字段 */
    baseField: BaseFiledDTO | undefined;
    create: boolean | undefined;
    /** 扩展字段 */
    extendField: ExtendFieldDTO | undefined;
    /** 网关应用ID */
    gatewayAppId: string | undefined;
    /** 网关id */
    gatewayId: string | undefined;
    /** 属性名称 */
    name: string | undefined;
}

export class 网关应用状态信息 implements I网关应用状态信息 {
    /** 网关应用ID */
    id!: string | undefined;
    /** 网关应用状态 */
    status!: number | undefined;

    constructor(data?: I网关应用状态信息) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): 网关应用状态信息 {
        data = typeof data === 'object' ? data : {};
        let result = new 网关应用状态信息();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data; 
    }
}

export interface I网关应用状态信息 {
    /** 网关应用ID */
    id: string | undefined;
    /** 网关应用状态 */
    status: number | undefined;
}

export class 网关应用类型 implements I网关应用类型 {
    /** 标签 */
    tag!: string | undefined;
    /** 类型名称 */
    typeName!: string | undefined;

    constructor(data?: I网关应用类型) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tag = data["tag"];
            this.typeName = data["typeName"];
        }
    }

    static fromJS(data: any): 网关应用类型 {
        data = typeof data === 'object' ? data : {};
        let result = new 网关应用类型();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["typeName"] = this.typeName;
        return data; 
    }
}

export interface I网关应用类型 {
    /** 标签 */
    tag: string | undefined;
    /** 类型名称 */
    typeName: string | undefined;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}